import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from './alertMessageSlice';

import SentinelHubService from '../services/sentinelHub.service';


const tempData = {

  email_id: "10",
  outlook_report: {
    "data": {
      "overview_tab": {
        "overall_reviews": 450,
        "overall_customer_satisfaction": {
          "average_rating": 4.6,
          "verified_purchase": 3.99,
          "non_verified_purchase": 3.82
        },
        "customer_ratings": {
          "five_star_ratings": 58.44,
          "four_star_ratings": 15.33,
          "three_star_ratings": 5.78,
          "two_star_ratings": 4.22,
          "one_star_ratings": 16.23
        },
        "Verified_non_verified_users": [
          {
            "rating": 5,
            "verified": 59.1,
            "nonverified": 55.91
          },
          {
            "rating": 4,
            "verified": 15.69,
            "nonverified": 13.98
          },
          {
            "rating": 3,
            "verified": 5.32,
            "nonverified": 7.53
          },
          {
            "rating": 2,
            "verified": 5.04,
            "nonverified": 1.08
          },
          {
            "rating": 1,
            "verified": 14.85,
            "nonverified": 21.5
          }
        ],
        "gender_demographics": {
          "male_percentage": 26.22,
          "female_percentage": 6.22,
          "unknown_percentage": 67.56
        },
        "gender_based_avg_rating": {
          "female_percentage": 3.46,
          "male_percentage": 3.86,
          "unknown_percentage": 4.04
        },
        "gender_based_rating": {
          "female": {
            "five_star_ratings": 50,
            "four_star_ratings": 10.71,
            "three_star_ratings": 3.57,
            "two_star_ratings": 7.14,
            "one_star_ratings": 28.58
          },
          "male": {
            "five_star_ratings": 55.93,
            "four_star_ratings": 15.25,
            "three_star_ratings": 6.78,
            "two_star_ratings": 2.54,
            "one_star_ratings": 19.5
          },
          "unknown": {
            "five_star_ratings": 60.2,
            "four_star_ratings": 15.79,
            "three_star_ratings": 5.59,
            "two_star_ratings": 4.61,
            "one_star_ratings": 13.81
          }
        },
        "trends_in_user_activity": {
          "days": {
            "timeline": [
              "18/08/2023",
              "23/08/2023",
              "25/08/2023",
              "26/08/2023",
              "27/08/2023",
              "28/08/2023",
              "29/08/2023",
              "03/09/2023",
              "06/09/2023",
              "11/09/2023",
              "12/09/2023",
              "16/09/2023",
              "19/09/2023",
              "20/09/2023",
              "25/09/2023",
              "26/09/2023",
              "27/09/2023",
              "28/09/2023",
              "30/09/2023",
              "02/10/2023",
              "08/10/2023",
              "10/10/2023",
              "14/10/2023",
              "16/10/2023",
              "20/10/2023",
              "30/10/2023",
              "02/11/2023",
              "04/11/2023",
              "05/11/2023",
              "06/11/2023",
              "09/11/2023",
              "11/11/2023",
              "23/11/2023",
              "24/11/2023",
              "25/11/2023",
              "28/11/2023",
              "29/11/2023",
              "01/12/2023",
              "02/12/2023",
              "04/12/2023",
              "06/12/2023",
              "07/12/2023",
              "08/12/2023",
              "09/12/2023",
              "11/12/2023",
              "12/12/2023",
              "13/12/2023",
              "14/12/2023",
              "15/12/2023",
              "16/12/2023",
              "17/12/2023",
              "18/12/2023",
              "19/12/2023",
              "20/12/2023",
              "21/12/2023",
              "22/12/2023",
              "23/12/2023",
              "24/12/2023",
              "25/12/2023",
              "27/12/2023",
              "28/12/2023",
              "29/12/2023",
              "31/12/2023",
              "02/01/2024",
              "03/01/2024",
              "05/01/2024",
              "06/01/2024",
              "07/01/2024",
              "08/01/2024",
              "10/01/2024",
              "11/01/2024",
              "12/01/2024",
              "13/01/2024",
              "14/01/2024",
              "17/01/2024",
              "18/01/2024",
              "19/01/2024",
              "20/01/2024",
              "21/01/2024",
              "23/01/2024",
              "24/01/2024",
              "25/01/2024",
              "28/01/2024",
              "29/01/2024",
              "30/01/2024",
              "31/01/2024",
              "01/02/2024",
              "03/02/2024",
              "04/02/2024",
              "05/02/2024",
              "06/02/2024",
              "08/02/2024",
              "09/02/2024",
              "10/02/2024",
              "11/02/2024",
              "13/02/2024",
              "14/02/2024",
              "15/02/2024",
              "16/02/2024",
              "17/02/2024",
              "18/02/2024",
              "19/02/2024",
              "20/02/2024",
              "21/02/2024",
              "23/02/2024",
              "24/02/2024",
              "25/02/2024",
              "26/02/2024",
              "27/02/2024",
              "28/02/2024",
              "29/02/2024",
              "01/03/2024",
              "02/03/2024",
              "03/03/2024",
              "04/03/2024",
              "05/03/2024",
              "06/03/2024",
              "07/03/2024",
              "08/03/2024",
              "09/03/2024",
              "10/03/2024",
              "11/03/2024",
              "12/03/2024",
              "13/03/2024",
              "14/03/2024",
              "15/03/2024",
              "16/03/2024",
              "17/03/2024",
              "18/03/2024",
              "19/03/2024",
              "20/03/2024",
              "21/03/2024",
              "22/03/2024",
              "23/03/2024",
              "24/03/2024",
              "25/03/2024",
              "26/03/2024",
              "27/03/2024",
              "28/03/2024",
              "29/03/2024",
              "30/03/2024",
              "31/03/2024",
              "01/04/2024",
              "02/04/2024",
              "03/04/2024",
              "04/04/2024",
              "05/04/2024",
              "06/04/2024",
              "07/04/2024",
              "08/04/2024",
              "09/04/2024",
              "10/04/2024",
              "11/04/2024",
              "12/04/2024",
              "13/04/2024",
              "14/04/2024",
              "15/04/2024",
              "16/04/2024",
              "17/04/2024",
              "18/04/2024",
              "19/04/2024",
              "20/04/2024"
            ],
            "count": [
              1,
              2,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              2,
              1,
              1,
              1,
              1,
              1,
              1,
              2,
              2,
              2,
              1,
              1,
              1,
              1,
              1,
              1,
              2,
              1,
              1,
              1,
              2,
              1,
              1,
              1,
              1,
              1,
              3,
              2,
              1,
              2,
              2,
              3,
              1,
              2,
              2,
              1,
              2,
              1,
              3,
              1,
              3,
              3,
              3,
              2,
              1,
              1,
              3,
              3,
              2,
              1,
              2,
              1,
              5,
              1,
              1,
              2,
              4,
              1,
              4,
              1,
              1,
              3,
              5,
              1,
              3,
              4,
              1,
              3,
              1,
              1,
              2,
              2,
              3,
              2,
              2,
              3,
              3,
              1,
              2,
              2,
              3,
              1,
              4,
              2,
              3,
              2,
              2,
              1,
              2,
              1,
              4,
              5,
              2,
              1,
              1,
              1,
              2,
              4,
              5,
              1,
              1,
              2,
              2,
              3,
              6,
              1,
              2,
              2,
              1,
              3,
              2,
              4,
              3,
              2,
              3,
              4,
              2,
              3,
              3,
              3,
              6,
              6,
              4,
              8,
              7,
              5,
              5,
              7,
              6,
              7,
              2,
              8,
              6,
              3,
              6,
              4,
              6,
              3,
              10,
              7,
              5,
              9,
              6,
              8,
              7,
              7,
              9,
              10,
              4,
              5,
              2,
              4,
              2
            ]
          },
          "week": {
            "timeline": [
              "14/08/2023",
              "21/08/2023",
              "28/08/2023",
              "04/09/2023",
              "11/09/2023",
              "18/09/2023",
              "25/09/2023",
              "02/10/2023",
              "09/10/2023",
              "16/10/2023",
              "30/10/2023",
              "06/11/2023",
              "20/11/2023",
              "27/11/2023",
              "04/12/2023",
              "11/12/2023",
              "18/12/2023",
              "25/12/2023",
              "01/01/2024",
              "08/01/2024",
              "15/01/2024",
              "22/01/2024",
              "29/01/2024",
              "05/02/2024",
              "12/02/2024",
              "19/02/2024",
              "26/02/2024",
              "04/03/2024",
              "11/03/2024",
              "18/03/2024",
              "25/03/2024",
              "01/04/2024",
              "08/04/2024",
              "15/04/2024"
            ],
            "count": [
              1,
              5,
              3,
              1,
              4,
              2,
              8,
              2,
              2,
              2,
              5,
              4,
              3,
              8,
              10,
              14,
              15,
              10,
              12,
              14,
              10,
              9,
              13,
              15,
              15,
              11,
              20,
              15,
              20,
              39,
              41,
              39,
              51,
              27
            ]
          },
          "month": {
            "timeline": [
              "08/2023",
              "09/2023",
              "10/2023",
              "11/2023",
              "12/2023",
              "01/2024",
              "02/2024",
              "03/2024",
              "04/2024"
            ],
            "count": [
              8,
              16,
              8,
              15,
              52,
              53,
              55,
              126,
              117
            ]
          },
          "year": {
            "timeline": [
              "2023",
              "2024"
            ],
            "count": [
              99,
              351
            ]
          }
        }
      },
      "sentiments_tab": {
        "sentiment_drilldown": {
          "positive_sentiment": 64.67,
          "negative_sentiment": 21.11,
          "neutral_sentiment": 14.22
        },
        "topic_analysis": {
          "positive_topics": {
            "topic1": "The iPhone Plus is a masterpiece of design, performance, and innovation that sets a new benchmark for excellence in the smartphone industry, offering an unparalleled user experience.",
            "topic2": "The mobile camera battery has excellent longevity and display quality, making it a top choice for photo enthusiasts.",
            "topic3": "The iPhone is well-designed, user-friendly, and provides a seamless experience with a great camera and display, making it a worthy investment."
          },
          "negative_topics": {
            "topic1": "Customers experienced delayed delivery, defective products, heating issues, billing errors, and poor customer service with Apple products purchased through Amazon.",
            "topic2": "iPhone in the Indian market lacks customizations, organization, and user-friendly features, leading to dissatisfaction and disappointment among users."
          },
          "neutral_topics": {
            "topic1": "The iPhone offers durable displays, long battery life, and a user-friendly experience, making it a popular choice among consumers.",
            "topic2": "The product provides average battery performance and has some issues with used or faulty devices, recommended to verify before purchasing.",
            "topic3": "The products are of good value for money with satisfactory performance and quality.",
            "topic4": "Budget-friendly phone with improved charging and heating capabilities, good camera quality, and efficient battery consumption for various activities.",
            "topic5": "The iPhone Pro has upgraded camera with a 12 MP main sensor and improved performance at a competitive price point."
          }
        },
        "top_helpfull_reviews": {
          "no_of_positive_helpful_reviews": 134,
          "no_of_negative_helpful_reviews": 58,
          "no_of_neutral_helpful_reviews": 33,
          "helpful_reviews": {
            "most_positive": "The Apple iPhone 15 Plus is a little on the higher side of budget but it’s a great phone. The battery life is amazing, and offers over 15 hours of Screen On Time and over 36 hours of Standby Time and takes a little over an hour using the Apple 20W USB C Charger to completely charge. The lack of 120Hz display for the price range doesn’t make sense but I barely notice the 60 Hz display even when I use it next to my Samsung Galaxy S20 with its 120Hz display. There are a very few instances when the software doesn’t work as intended but nothing that’s majorly noticeable or work hampering. The 256GB Storage along with eSIM is a great use case for me. The Camera is usually very good with brilliant video recording, however I personally don’t like how the iPhone processes faces through its HDR. It captures literally all the details of the face, even if one doesn’t want it to and sadly there is no way to turn off HDR in newer models. HDR Videos or Dolby Vision Videos however are very well captured. The phone has a very good stereo setup that has noticeable bass. Consuming media on the phone is a delight. The USB C is a valuable addition that helps me use the same USB C Earphones that I use with my Samsung. The phone along with my Apple Watch SE and Airpods Pro makes a great combination.",
            "most_positive_helpful_count": 53,
            "most_negative": "Without use kiye hi phone heat hota rhta h Battery b kb ud jari kuch pta ni chl ra itna gnda experience rhe ga I phone ka to mein kbhi na leti.. am disappoint 😠😡",
            "most_negative_helpful_count": 97,
            "most_neutral": "Received a refurbished phone in the place of new phone",
            "most_neutral_helpful_count": 9
          }
        }
      },
      "insights_tab": {
        "sentiment_wordcloud": {
          "positive_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "positive_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "positive_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "negative_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "negative_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "negative_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "neutral_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "neutral_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "neutral_trigram": [
            {
              "word": "",
              "count": 0
            }
          ]
        },
        "emotion_wordcloud": {
          "joy_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "joy_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "joy_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "surprise_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "surprise_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "surprise_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "neutral_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "neutral_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "neutral_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "anger_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "anger_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "anger_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "disgust_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "disgust_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "disgust_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "sadness_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "sadness_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "sadness_trigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "fear_unigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "fear_bigram": [
            {
              "word": "",
              "count": 0
            }
          ],
          "fear_trigram": [
            {
              "word": "",
              "count": 0
            }
          ]
        },
        "review_helpfullness": [
          {
            "rating": 5,
            "helpfull_per": 43.73
          },
          {
            "rating": 4,
            "helpfull_per": 59.42
          },
          {
            "rating": 3,
            "helpfull_per": 30.77
          },
          {
            "rating": 2,
            "helpfull_per": 47.37
          },
          {
            "rating": 1,
            "helpfull_per": 71.23
          }
        ],
        "emotion_analysis": [
          {
            "disgust": 2.9,
            "anger": 1.3,
            "fear": 0,
            "sadness": 12.9,
            "joy": 28.2,
            "surprise": 6.9,
            "neutral": 47.8
          }
        ],
        "correlation_analysis": {
          "rating": {
            "rating": 1,
            "helpful_count": -0.11,
            "anger": -0.32,
            "neutral": 0.1,
            "sadness": -0.52,
            "disgust": -0.24,
            "fear": -0.04,
            "joy": 0.41,
            "surprise": 0.06
          },
          "helpful_count": {
            "rating": -0.11,
            "helpful_count": 1,
            "anger": -0.02,
            "neutral": -0.06,
            "sadness": 0.17,
            "disgust": -0.05,
            "fear": -0.03,
            "joy": -0.03,
            "surprise": -0.02
          },
          "anger": {
            "rating": -0.32,
            "helpful_count": -0.02,
            "anger": 1,
            "neutral": -0.1,
            "sadness": 0.04,
            "disgust": 0.29,
            "fear": 0.17,
            "joy": -0.25,
            "surprise": -0.09
          },
          "neutral": {
            "rating": 0.1,
            "helpful_count": -0.06,
            "anger": -0.1,
            "neutral": 1,
            "sadness": -0.31,
            "disgust": -0.11,
            "fear": -0.01,
            "joy": -0.53,
            "surprise": -0.22
          },
          "sadness": {
            "rating": -0.52,
            "helpful_count": 0.17,
            "anger": 0.04,
            "neutral": -0.31,
            "sadness": 1,
            "disgust": -0.04,
            "fear": -0.01,
            "joy": -0.37,
            "surprise": -0.06
          },
          "disgust": {
            "rating": -0.24,
            "helpful_count": -0.05,
            "anger": 0.29,
            "neutral": -0.11,
            "sadness": -0.04,
            "disgust": 1,
            "fear": 0.04,
            "joy": -0.23,
            "surprise": -0.15
          },
          "fear": {
            "rating": -0.04,
            "helpful_count": -0.03,
            "anger": 0.17,
            "neutral": -0.01,
            "sadness": -0.01,
            "disgust": 0.04,
            "fear": 1,
            "joy": -0.15,
            "surprise": 0.01
          },
          "joy": {
            "rating": 0.41,
            "helpful_count": -0.03,
            "anger": -0.25,
            "neutral": -0.53,
            "sadness": -0.37,
            "disgust": -0.23,
            "fear": -0.15,
            "joy": 1,
            "surprise": -0.18
          },
          "surprise": {
            "rating": 0.06,
            "helpful_count": -0.02,
            "anger": -0.09,
            "neutral": -0.22,
            "sadness": -0.06,
            "disgust": -0.15,
            "fear": 0.01,
            "joy": -0.18,
            "surprise": 1
          }
        }
      },
      "cluster_analysis_tab": {
        "sentiment_data": {
          "X-axis": [
            4.8,
            6.34,
            -8.65,
            -11.92,
            2.41,
            -4.5,
            1.79,
            -12.29,
            -11.31,
            -5.13,
            -0.68,
            -7.08,
            -0.01,
            -8.25,
            -0.29,
            -1.84,
            7.13,
            -10.59,
            2.9,
            -10.93,
            3.58,
            2.71,
            -2.68,
            -14.36,
            3.37,
            -0.07,
            0.3,
            -0.67,
            -13.04,
            -1.14,
            -7.21,
            1.42,
            -7.64,
            4.6,
            -12.26,
            3.45,
            -10.45,
            -7.51,
            -7.09,
            1.95,
            -2.82,
            6.19,
            -5.26,
            -10.79,
            3.59,
            3.85,
            -3.92,
            -0.24,
            -11.47,
            -13.82,
            7.61,
            2.45,
            -6.31,
            1.42,
            5.87,
            -9.11,
            5.95,
            -2.22,
            -13.14,
            -12.21,
            -11.67,
            -11.92,
            4.02,
            -0.36,
            -14.96,
            2.29,
            -3.4,
            0.19,
            5.81,
            -4.03,
            3.6,
            1.66,
            4.51,
            3.4,
            -2.5,
            -10.34,
            0.03,
            -2.2,
            2.27,
            -1.35,
            -6.94,
            4.28,
            -5.41,
            5.04,
            2.18,
            1.52,
            -5.81,
            5.87,
            6.71,
            -9.19,
            4.49,
            3.76,
            -11.76,
            1.12,
            -9.74,
            -12.21,
            5.39,
            5.95,
            3.37,
            3.45,
            -5.49,
            -12.5,
            5.89,
            -0.73,
            3.46,
            4.61,
            -4.3,
            -2.53,
            6.68,
            3.95,
            3.38,
            -9.7,
            2.33,
            6.01,
            4.09,
            -14.89,
            0.65,
            3.38,
            2.32,
            -0.47,
            3.38,
            -11.67,
            -0.16,
            -10.2,
            1.11,
            -1.46,
            -11.31,
            2.82,
            2.25,
            2.81,
            2.11,
            -14.71,
            -4.84,
            3.5,
            -1.66,
            -11.29,
            -11.66,
            -2.34,
            3.9,
            -6.84,
            1.99,
            -15.39,
            -12.92,
            -10.73,
            -4.11,
            -14.03,
            -3.04,
            -7.17,
            2.42,
            -14.7,
            -2.64,
            -2.77,
            -3.92,
            -12.12,
            6.12,
            -5.09,
            2.37,
            -13.75,
            3.96,
            -8.17,
            -14.8,
            -2,
            0.54,
            -0.18,
            -14.8,
            2.55,
            0.41,
            -12.59,
            0.79,
            -6.94,
            -13.91,
            0.48,
            -7.59,
            -7.45,
            -0.83,
            -4.53,
            -10.21,
            -12.21,
            -1.52,
            -10.79,
            -5.98,
            -2.74,
            -6.26,
            -1.55,
            2.67,
            0.69,
            2.35,
            -7.52,
            -1.69,
            -3.99,
            2.63,
            -6.19,
            -12.05,
            5.39,
            1.49,
            -13.79,
            -0.45,
            2.95,
            5.21,
            7.3,
            -15.29,
            -14.78,
            -5.95,
            -8.89,
            4.8,
            -7.11,
            1.36,
            -5.63,
            -0.33,
            -7.51,
            2.49,
            -12.25,
            -13.47,
            3.66,
            4.22,
            -3.1,
            -0.36,
            -13.44,
            5.17,
            5.53,
            -2.52,
            -7.15,
            6.74,
            -2.73,
            -7.84,
            3.59,
            -3.92,
            -13.13,
            4.57,
            1.2,
            1.12,
            4.43,
            -0.93,
            2.29,
            -14.21,
            -2.27,
            2.16,
            -10.79,
            -2.42,
            -13.84,
            -11.24,
            -1.96,
            -5.46,
            -3.39,
            -0.84,
            6.58,
            6.67,
            1.55,
            -12.44,
            -0.21,
            -12.44,
            2.12,
            3.11,
            -2.73,
            1.13,
            4.91,
            -12.5,
            -1.11,
            -2.25,
            -4.28,
            -10.56,
            2.02,
            2.46,
            5.91,
            3.16,
            -11.8,
            4.99,
            -1.37,
            2.99,
            3.87,
            -7.73,
            8.31,
            0.79,
            7.09,
            -8.37,
            4.04,
            4.95,
            -10.84,
            -8.82,
            -1.36,
            6.81,
            4.08,
            4.49,
            8.58,
            -8.7,
            -0.7,
            3.59,
            -6.69,
            1.99,
            6.69,
            4.68,
            3.97,
            -8.71,
            7.79,
            4.65,
            5.32,
            -6.01,
            -0.14,
            0,
            3.88,
            3.47,
            -4.68,
            -3.04,
            2.05,
            -3.83,
            -3.31,
            1.2,
            3.72,
            -12.52,
            1.89,
            4.32,
            -10.21,
            1.46,
            -1.1,
            -12.36,
            4.41,
            5.41,
            0.41,
            -3.17,
            -11.83,
            0.26,
            3.29,
            -9.21,
            -3.44,
            1.29,
            3.59,
            0.25,
            0.37,
            7.85,
            -11.78,
            7.56,
            -7.71,
            -0.98,
            -10.68,
            -6.66,
            -2.71,
            -1.54,
            -3.6,
            2.16,
            -2.46,
            4.12,
            -13.08,
            -2.98,
            -15.54,
            6.53,
            -3.29,
            -2.51,
            -6.06,
            -4.47,
            4.16,
            7.48,
            -6.12,
            4.52,
            -8.15,
            -5.52,
            5.72,
            5.59,
            -4.03,
            -4.67,
            3.13,
            -5.5,
            0.62,
            -7.64,
            -12.59,
            -2.59,
            -6.23,
            -10.16,
            -11.17,
            -13.8,
            0.27,
            -2.76,
            -12.78,
            -10.15,
            1.43,
            4.38,
            -1.08,
            -5.73,
            -4.52,
            4.48,
            -0.99,
            -1.58,
            -5.04,
            -1.46,
            -9.8,
            -5.23,
            -6.24,
            -8.39,
            -5.42,
            -0.68,
            5.58,
            3.49,
            6.66,
            -2.87,
            -4.19,
            -0.28,
            4.47,
            -0.17,
            -5.12,
            -13.5,
            -7.24,
            3,
            7.72,
            -1.68,
            -4.67,
            5.42,
            -10.94,
            -1.98,
            2.73,
            -3.24,
            -8.38,
            0.31,
            2.41,
            -3.9,
            -2.23,
            6,
            -11.67,
            0.81,
            -6.02,
            3.21,
            0.34,
            -5.53,
            2.77,
            -13.95,
            -13.79,
            2.43,
            -13.98,
            -11.84,
            5.6,
            -10.85,
            -15.28,
            -7.35,
            -3.36,
            -13.85,
            -5.82,
            -1.61,
            4.41,
            -6.99,
            -3.23,
            -4.31,
            -9.96,
            -3.1,
            0.07,
            0.37,
            1.17
          ],
          "Y-axis": [
            13.33,
            -5.41,
            -11.7,
            -6.04,
            12.22,
            4.9,
            -10.57,
            -5.91,
            -12.43,
            11.2,
            9.31,
            0.5,
            -7.66,
            -9.1,
            10.08,
            9.43,
            -6.22,
            -9.03,
            14.59,
            -8.04,
            12.33,
            13.16,
            14.06,
            -6.39,
            -4.59,
            -7.36,
            13.58,
            8.44,
            -6.61,
            -6.48,
            -4.95,
            7.6,
            10.59,
            10,
            -7.79,
            12.99,
            -5.4,
            -6.24,
            0.48,
            7,
            14.89,
            -8.52,
            13.09,
            -3.44,
            6.45,
            4.71,
            -6.27,
            -10.29,
            -7.86,
            -7.14,
            7.59,
            12.02,
            -1.62,
            11.48,
            -6.75,
            -6.61,
            -4.86,
            -10.04,
            -7.12,
            -11.44,
            -1.88,
            -8.71,
            8.65,
            -11.24,
            -5.23,
            12.5,
            12.46,
            5.89,
            4.42,
            3.74,
            -10.13,
            7.53,
            -7.28,
            4.05,
            -9.87,
            -10.41,
            8.44,
            8.28,
            4.3,
            8.83,
            -9.9,
            5.21,
            7.03,
            -10.95,
            15.83,
            6.33,
            -8.34,
            -6.02,
            -5.05,
            -5.09,
            5.3,
            -4.51,
            -7.5,
            10.51,
            -6.11,
            -10.48,
            1.53,
            8.96,
            10.87,
            2.13,
            2.73,
            -11.29,
            6.93,
            -6.65,
            -11.26,
            7.73,
            4.14,
            7.95,
            -8.66,
            -7.01,
            7.09,
            -7.88,
            8.59,
            -7.4,
            9.21,
            -9.16,
            -8.05,
            -13.01,
            -7.73,
            -12.08,
            2.65,
            -8.52,
            -11.67,
            -9.2,
            12.56,
            7.7,
            -4.05,
            10.21,
            -9.34,
            14.57,
            -4.59,
            -7.23,
            2.01,
            -6.63,
            8.49,
            -8.48,
            -12.1,
            14.1,
            -10.94,
            -11.16,
            -9.98,
            -6.72,
            -8.32,
            -6.39,
            6.99,
            -2.71,
            4.03,
            -2.24,
            -10.8,
            -4.85,
            10.9,
            15.31,
            5.51,
            -8.35,
            -5.78,
            11.09,
            -7.18,
            -7.44,
            11.17,
            -1.2,
            -5.12,
            5.07,
            12.81,
            -11.58,
            -4.88,
            6.04,
            -9.9,
            -9.41,
            14.92,
            7.08,
            -5.94,
            -6.79,
            -6.29,
            -6.39,
            14.81,
            3.04,
            -4.76,
            -11.25,
            11.08,
            -11.38,
            -10.36,
            7.29,
            3.05,
            6.9,
            13.52,
            15.16,
            3.53,
            -6.04,
            7.47,
            11.25,
            -3.99,
            -0.55,
            -5.47,
            -8.57,
            2.26,
            -7.92,
            11.9,
            -12.17,
            4.84,
            8.18,
            -6.78,
            -9.64,
            -2.82,
            -7.3,
            9.68,
            -10,
            9.52,
            1.72,
            11.82,
            -7.21,
            -4.15,
            -3.15,
            -5,
            6.98,
            -7.42,
            12.53,
            11.84,
            -6.6,
            -8.68,
            -6.51,
            13.58,
            -6.21,
            -10.24,
            11.89,
            -9.21,
            -5.7,
            4.81,
            -8.01,
            -8.83,
            14.04,
            7.91,
            -7,
            10.41,
            -5.84,
            -9.77,
            7.33,
            15.12,
            -10.06,
            2.88,
            -2.81,
            -11.26,
            0.84,
            -5.46,
            11.68,
            6,
            -5.82,
            5.82,
            10.25,
            -4.49,
            -7.01,
            -4.36,
            -5.35,
            -11.63,
            3.52,
            14.78,
            -12.25,
            -8.86,
            0.76,
            10.77,
            -5.81,
            -7.19,
            10.03,
            -7.44,
            6.5,
            -5.77,
            -6.93,
            -4.82,
            9.15,
            4.51,
            -11.85,
            6.65,
            -6.55,
            5.58,
            8.38,
            -2.02,
            -9.87,
            -11.87,
            -8,
            -3.6,
            -8.84,
            9.6,
            -9.67,
            -10.44,
            8.8,
            -11.57,
            4.45,
            -11.11,
            -1.53,
            13.86,
            -7.16,
            -10.44,
            11.42,
            -3.76,
            -9.7,
            -6.14,
            -10.94,
            12.15,
            -11.67,
            -11.42,
            12.76,
            2.3,
            5.79,
            8.81,
            -10.99,
            5.79,
            13.89,
            -6.83,
            -12.27,
            -8.07,
            -10.97,
            5.91,
            -8,
            8.72,
            8.38,
            -3.23,
            -11.1,
            12.08,
            4.07,
            8.97,
            -5.88,
            10.23,
            -10.71,
            -0.35,
            10.58,
            3.69,
            -10.42,
            10.76,
            -7.83,
            -9.63,
            -9.2,
            -6.24,
            -0.19,
            3.52,
            -11.55,
            -6.44,
            15.01,
            4.35,
            6.48,
            5.11,
            5.76,
            -10.37,
            -5.87,
            6.24,
            -9.05,
            -6.61,
            9.95,
            5.57,
            -0.11,
            1.13,
            -9.12,
            -7.75,
            1.58,
            7.76,
            -6.15,
            8.4,
            6.66,
            6.42,
            7.8,
            -1.26,
            11.5,
            3.49,
            3.27,
            -6.27,
            -11.75,
            4.84,
            -1.33,
            -10.67,
            -9.12,
            -6.13,
            9.41,
            9.88,
            -4.07,
            -4.43,
            12.41,
            5.52,
            11.91,
            4.3,
            -5.74,
            3.04,
            12.73,
            10.06,
            9.63,
            10.55,
            -10.47,
            4.29,
            -11.23,
            -9.72,
            -4.91,
            6.46,
            -10.57,
            8.6,
            9.81,
            4.6,
            9.5,
            -6.96,
            -9.18,
            13.49,
            2.84,
            -11.75,
            -5.86,
            -9.81,
            -8.54,
            4.09,
            9.68,
            4.7,
            -12.66,
            10.48,
            -10.11,
            11.21,
            -8.49,
            5.95,
            5.79,
            3.27,
            9.26,
            7.3,
            -11.96,
            13.22,
            4.25,
            -7.64,
            7.67,
            5.19,
            -9.62,
            -6.44,
            -9.62,
            5.7,
            -4.51,
            -4.4,
            -6.93,
            -5.34,
            -10.14,
            7.14,
            9.61,
            -4.43,
            -8.27,
            5.53,
            -11.41,
            -0.28,
            3.17,
            8.45,
            -2.75,
            7.84,
            2.27,
            -11.27,
            12.6
          ],
          "sentiment": [
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            1,
            1,
            0,
            1,
            1,
            -1,
            0,
            0,
            1,
            -1,
            0,
            -1,
            1,
            1,
            0,
            0,
            1,
            1,
            -1,
            -1,
            1,
            0,
            -1,
            -1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            1,
            0,
            0,
            1,
            1,
            0,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            1,
            0,
            -1,
            -1,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            0,
            0,
            1,
            1,
            1,
            1,
            0,
            0,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            0,
            0,
            1,
            0,
            1,
            1,
            1,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            1,
            1,
            0,
            1,
            1,
            1,
            1,
            0,
            1,
            0,
            -1,
            1,
            1,
            1,
            1,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            0,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            0,
            1,
            1,
            1,
            1,
            0,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            0,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            0,
            1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            -1,
            -1,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            1,
            -1,
            0,
            0,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            -1,
            -1,
            -1,
            0,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            0,
            1,
            -1,
            0,
            0,
            0,
            -1,
            1,
            1,
            0,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            0,
            1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            1,
            1,
            0,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            0,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            1,
            0,
            0,
            -1,
            1,
            1,
            1,
            -1,
            1,
            0,
            1,
            0,
            1,
            1,
            1,
            0,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            0,
            1,
            1,
            1,
            0,
            1,
            -1,
            1,
            0,
            1,
            1,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1
          ],
          "reviews": [
            "iPhone,Awesome",
            "Got Defective Product.,I got defective product, it has two dents on screen which are very small and process to return/refund initiating is very difficult, i need to visit the apple care for testing the product they found defect and gave written email in which they denied that we don't have any collab with these third party seller.",
            "Review,Security features",
            "Nice,Nice",
            "Iphone 14,Good product",
            "Good camera good performance,Camera and performance is superb but battery backup could have been better except tht its a good smartphone and good build quality",
            "Heating problem,1 hrs use krne pe bahut heat hota h charging me lgane pe v heat hota h",
            "Nice,Good phone 9",
            "Be care full when package received,I like the product very much",
            "Worst phone don't buy guys,In thus price range better to go for samsung s24 or ultra apple is remaking the same iphone Xr for years with some changes that's it its a loot businesss",
            "Loved it ❤️,Buying an iphone with my first salary is the dream i manifested it and it happened. I’m writing this review after 8 months. Camera quality everything is good. There is nothing to say about iphone the best always ❤️. But what i observed is after IOS 17 battery started to drain like for 2 days one percent is dropping after that it stopped.Now my battery health is 93%. This is the only concern with iphone remaining all aspects it is worth the money.",
            "Camera is pretty impressive,",
            "Performance is good but battery performance,I am using it from 18 January 2024 only in 2 and half months battery health is 99% showing😣",
            "Dimag,Dimag",
            "Review after 1 years,1) Display - 4/5 2) durability - 3/5 3) Battery -2/5 4) iphone11 > iphone6 > iPhone14 As we are addicted to apple we are using iPhone else no reason to buy this mobile",
            "Pushing the Boundaries of Innovation,The iPhone 14 marks another leap forward in Apple’s relentless pursuit of innovation and excellence. From its sleek design to its powerful performance and advanced features, this device sets a new standard for what a smartphone can be. Design: The iPhone 14 boasts a stunning design that seamlessly combines form and function. With its refined edges, smooth curves, and premium materials, it exudes elegance and sophistication. Apple continues to lead the industry in design innovation, and the iPhone 14 is a testament to their commitment to craftsmanship. Display: The display on the iPhone 14 is nothing short of breathtaking. Featuring a vibrant OLED panel with true blacks and rich colors, every image comes to life with stunning clarity and detail. Whether you’re streaming your favorite movies, browsing the web, or playing games, the display provides an immersive viewing experience like no other. Performance: Powered by Apple’s latest A-series chip, the iPhone 14 delivers unparalleled performance and efficiency. Apps launch instantly, multitasking is a breeze, and graphics-intensive games run smoothly without any lag or stutter. With improved battery life, you can stay connected and productive throughout the day without worrying about running out of power. Camera: The camera system on the iPhone 14 is a photographer’s dream. With advanced computational photography features and enhanced sensor technology, it captures stunning images with incredible detail and dynamic range. Whether you’re shooting in low light or capturing fast-moving subjects, the iPhone 14 ensures that every photo is a masterpiece. Features: The iPhone 14 is packed with a plethora of features designed to enhance your daily life. From Face ID for secure authentication to 5G connectivity for blazing-fast internet speeds, every aspect of the device is meticulously crafted to provide the ultimate user experience. And with iOS 16, you get access to a wide range of new features and improvements that further elevate the iPhone experience. Conclusion: In summary, the iPhone 14 is a triumph of design, engineering, and innovation. With its stunning design, breathtaking display, blazing-fast performance, and advanced features, it sets a new benchmark for what a smartphone can achieve. Whether you’re a tech enthusiast, a professional photographer, or a casual user, the iPhone 14 is sure to exceed your expectations and elevate your smartphone experience to new heights.",
            "Defective Piece,Fake seller, I got a defective iphone and it was really the toughest thing to get it return, so never buy any expensive electronics online, i learnt a lesson so recommending everyone to follow the same",
            "Used product,Used product",
            "Iphone,Recently bought this product phone is good but Battery 🔋 is not available.  I did not expect this kind of product",
            "Excellent product,Excellent product",
            "I love iPhone,Best",
            "Trust,As usual an iPhone as it has to be",
            "Apple product. That's all,Go with the flow. If you want to show off buy it. If you are an existing android customer never buy an apple product untill and unless u have security trust issues.",
            "Good,Like it",
            "Everything is good ,,No problem in this mobile 14.Also Quick service from Amazon thanks from Shailesh Nanavati",
            "Poor battery,Poor battery support and battery life. It decreases to 96% within 6 months of moderate usage. Battery can not support for 24 hours.",
            "Great buy,I don’t recommend to buy , iPhone because prices keeps on dropping buy this in sale only to get maximum benefit, I bought it for 70k now it is 53 k so loss…🥹",
            "Best purchase,Even though I was doubtful at first that I should buy iPhone online or not I made the decision to go for it on Amazon and frankly it was the best decision ever. Iphone is a complete gamechanger and the camera quality is so much better than any phone I have ever used.",
            "Good,No words",
            "Battery,Battery backup not good Finger print sensor needed",
            "Not valuable for money,Gets hanged in 3 months only what is this APPLE",
            "Worthy gift for better half,Bought the 256gb iPhone product RED. The color is striking and the phone is performing well. Best gift to better half for 10th anniversary!",
            "Superb,Superb phone",
            "Satisfied,Happy with the i phone 14",
            "Good,Very good product",
            "Elegance of iPhone,It’s really awesome when I switched from Android to iPhone then I realised why iPhone creates cult among its user !",
            "It Is looks old,It's looks old",
            "Value for money,Good",
            "Good camera,",
            "Awesome phone,I gifted this to my wife she was really happy to see this phone and the blue colour is Amazing",
            "Awesome product,Amazing product, it's a must buy u should pick it for sure, apple is a life style now, go for it for sure",
            "Faulty product,Faulty product received. It had calling issues, disturbances and cracking noises during calls that were so loud that other side was never able to hear calls.",
            "i Phone is always Excellent,Using from 5s to 7... Now this 14 is Superb ...unmatchable..",
            "Perfect,After using XR , this one is best",
            "happy with the phone but unhappy with Amazon and vendor,unhappy because no cost emi still charging gst + interest which was useless decision to buy the phone from the Amazon.",
            "Phone is very nice,Good performance",
            "Review,Battery charge is less",
            "Exchange value is unexpected low,Exchange value is farji thak h sabhi 34000 ka phone 10 mahine age inki rate 7700 laga rahe h thag h",
            "🍎 Name is enough,Just Wow, amazing product",
            "Good,Good",
            "Performance,Average phone",
            "iPhone 14,Good Phone",
            "Go for it,Camera is wow",
            "Value for money,What to write of an iPhone?? Best as always",
            "Don't buy i phone from online,I brought iPhone 14 from Amazon. After 6 days mobile shutdown. didn't switching on. And I went to apple service center. they had denied to replaced my phone. they forced me to repair my mobile. after that i I had contacted Amazon. They had  refunded my money but it took 1 months credited money in my account.",
            "Satisfactory purchase,Go for it",
            "Defective itam 😕,Defective product delivered",
            "Satisfied with the product received but has some negative opinion,I am completely happy with the product however the things which was unsatisfied is that it took more than a week to deliver even after paying in full before delivery and also the bill which was provided after opening was halfy printed as it appears to be half cutted may be printing error the main parts of billing information was not present I hope the next order will avoid any kind of error in future …",
            "good,great",
            "Delivered on time,Received in perfect condition",
            "Supr,Best All Time IOS",
            "Great product,Great product",
            "Apple Just Wow wow wow!,Awesome phone and Amazon only fulfilled my wish. Thank you for fulfilling my dream.",
            "Nokiya 3310,Accha per thika he hai bus thoda mahenga hai pe chalega lena to hai he nah bus mai Aya pe timepass kr raha hu merko samaj nhi aara tha ke kya kru to mai review likh diya Thanks 🙏🏻👍🏻",
            "👍,👍",
            "Good,Packing was good . It’s an iPhone so works well .",
            "Obviously worth it.,Switching from an android to an iPhone was one of the best decisions.",
            "Great buy at great price !,Great phone at an excellent price ....great performance.... excellent camera.. smooth high quality... wonderful..it's iPhone..... So it's enough said !!",
            "Excellent phone,Better than One Plus",
            "Best phone,Camera quality is awesome",
            "Emits heat and the battery drains !!!,The phone emits a lot of heat and the battery drains immediately --  I given return and i will try  Iphone 15",
            "Very happy,The blue colour looks amazing, very happy to purchase my 1st Iphone🥰",
            "Phone is not working,Recently took I phone 14 it’s not working now",
            "Good product,Best product ever used best of the best in the phone market worth it for the price  top class quality",
            "Delivery period too long,It is showing almost 24 - 33days to deliver it which is a lot of time , sadly I'm disappointed 😔",
            "Feels like a duplicate product,Not sure how to check authenticity of the product",
            "Loved with the colour,After using 4months the review Previously I have heard lot of rumours about the iPhone not to buy on sale but when I bought this it was completely game changer for me. Specially the camera quality and Siri does half of my work. I am happy with the purchase. Thank you Amazon for serving the best.",
            "Buttery smooth,Using iphone 14 for over a week now, its just buttery smooth as expected the display is so amazing and the animations are done so precisely that you will actually forget that this has 60hz display. In term of camera quality back camera is really good, I don’t like the selfie camera that much but i am not a selfie person so its fine with me. Battery is also good will give you upto 6-7hr backup",
            "Fantastic!.,The best thing about this phone is its long battery. With normal use it can go beyond 48 hrs.",
            "It's visually appealing and upgraded device, surpassing my old iPhone 12,Pros:   Good Looking (4/5): The Blue color variant adds to the aesthetic appeal, making the iPhone 14 an eye-catching device.   Better than iPhone 12 (4/5): The iPhone 14 exhibits improvements over the iPhone 12, contributing to an enhanced user experience.   Good Camera (4/5): The camera performance is commendable, capturing high-quality images and enhancing the overall photography experience. In summary, the Apple iPhone 14 in Blue is a solid choice, offering a sleek design, improved features compared to the iPhone 12, and a reliable camera for capturing memorable moments.",
            "Rahul,",
            "Very nice 👌,Nice mobile phone",
            "Good Phone,I switched from Android, and there is not any changes that I feel, performance is same , camera is same , charging is too bad than Android. I play games a lot. P.S :- Don't compare with Android of less than 30,000 rupees. I was user of Snapdragon Gen1+",
            "Heating Issue Sometimes,Faced the Heating issue many times . Rest is Good . Checked on Apple site Product is Original .",
            "A Small Chip On The Side Of My New Iphone,The Iphone that I have purchased has got a small  chip on the side of my iphone . This has kind of ruined the iphone experience for me... After paying 60k for a new phone, the least you do is to expect a phone with perfect conditions in all aspects … having said about this small physical blemish, the overall performance of the phone has been nothing short of phenomenal and spectacular .. iPhone truly is amazing and iconic",
            "Wonderful phone,This phone is a gem. Photo clarity is awesome. This is the phone to use for ages given now iPhone has moved to type c port, this is the last generation of lightning charger.",
            "Slowness,Slow",
            "Cheating with customer their replacement policy is fake,Last week buy iphone the camera was not working when request for replacement they completely denied and redirect to apple store but why you mentioned 7days replacement???????",
            "Don't Purchase Please,Purchased in 2023 now it has seen  colour fade slowly ...Service Centre and Apple Support teams does not take any responsibility for this manufacturing issues.. Suggesting all not purchased this one",
            "Uses,So beautiful,So elegant,just looking like a wow.Seriously you don’t have to read out all comments because it is apple.Everything is outstanding.Value for money depends on user.Otherwise no restriction,just go for it.",
            "Nice phone.. lovly,9,/10",
            "best,brand new condition  all ok but i face delavery problem but its ok phone is good pakaging all are good",
            "Good product,Nice",
            "It’s iPhone,Just a small phone you need for every day, work, entertainment and overall a good phone. iOS is one of the best systems overall in the market. Best display best battery best sound best design",
            "Definitely a must buy,Everything looks good",
            "The perfect one,Good product delivered on time",
            "Superb product,This is one of the finest product I have purchase. Amazon is just superb with their service. I has exchange with my smartphone they in fact not check my phone is their any damage or not simply exchange with my phone without a single question. Love u Amazon. Love u apple.",
            "Iconic phone,Features and robustness of the phone .",
            "Amezing,Just love it .. i fall in love with this iPhone model",
            "Quality of charging cable not good.,I don't recommend others to purchase this phone on online offers, they sell you in less price but the quality of accessories they give you with is phone is compromised. Charging get damaged within 6 months from purchase.",
            "It's soo smooth,The camera quality is just 🔥. The battery is also good.",
            "Excellent,On time delivery and smooth process",
            "best,best mobile phone",
            "Good phones battery issue,Battery issue",
            "Heating,The device is very good. I have only one problem and its the heating of the phone while charging and playing games. Overall its a good product in all aspects.",
            "Dream phone !,I wanted this phone since long ! Now I had it in offer !",
            "Very best iPhone,Camera quality is best Displace very smooth battery life is best giving one day sensor is very best hhvbb hvb",
            "Just an iphone,Back camera is nice Front camera is not upto mark 60hz display in arround 50k does hurt Performance wise owsome If you have budget then please go for 15 series",
            "Worst Calling Experience,Pathetic experience... Unable to hear any sound WhatsApp doesn't work, Facetime doesn't work, regular calling doesn't work. Waste of so much money in buying this useless device.",
            "After 1 year display not working,Display not working my phone is 1 year 3 month old & it display not working The phone was kept in charging & after some time display not working",
            "Genuine product love it,Everything is good Best phone ever",
            "Thiss product was so nice,iPhone products was veryy useful for everyone it was veryy bestt product everr",
            "Best phone,I am new user of iphone and the Best phone ever, luxurious look and premium quality, security and saftety are awesome.",
            "Worst experience… pls dont buy from Amazon,Its just 2 days and the device is overheating…. Amazon service is worst…. they routed me to Apple service centre instead of replacing the phone",
            "Really good phone,It's an absolute all rounder. I mean you know about apple right, it has never disappointed me this time neither",
            "Thankyou Apple ❤️🫶🏻,",
            "Good,As everyone knows it is very Good mobile, but how ever you use battery health percentage will keep decreasing, for me this only issue with iphones",
            "Satisfied,I am using it since January, and completely satisfied. No doubt on product originality from seller end. However facing some heating issue while continuous network usage.",
            "USB Data Cable,Mobile Phone is Okey but USB Data Cable not good as you provide inbox 👎",
            "Bekar Phone hai,Not worth it",
            "Good phone,Phone is absolutely good it hang only while it is hot overall display is very awosome and its very smooth while it charge at good speed",
            "Very nice product,Good product as expected with a very reasonable price",
            "Majha aagya,Waah yr mast phone hai",
            "Bad product,1Accereise missing",
            "iPhone 13 in 2024 still worth it,I bought it in 2024 and I'm really pleased with the updates from Apple. Appreciate it. Great product. Worth buying it.",
            "One of the best iPhones made,At this price point it's one of the best phones you can get! iOS is smooth as always and the camera setup as absolutely clinical. The downside tho is the minimal battery life but it can get you through an entire day.",
            "Perfect in every way,Perfect",
            "The beast!,Purchased it long time ago but this is my 2nd iphone 13. I bought this for my father. He is very happy",
            "Mobile heat and battery 93% just in 1 month,Mobile heat and battery 93% just in 1 month.. Kindly contact me how to change product",
            "iphone 14 is batter than this,All version of iphone is batter than older version so it's creat confusion between the customer that which one is batter",
            "very poor quality,the phone has serious network issues... with high speed 5g there is very slow internet but the same sim gives wonderful performance and network connectivity on other phone",
            "Ok,Good one",
            "Camera & performance,Great quality in wide angle and potrait mode no matter in temperature device although works normally. I like the build quality.",
            "Screen white,Using  continuously  2 year and after updated screen is white facing problem and not working  service centre is delhi and away from my home town .",
            "Fantastic Upgrade,I recently upgraded to the iPhone 13, and I couldn't be happier! The sleek design, stunning display, and lightning-fast performance make it a standout device. The camera quality is exceptional, capturing every moment with clarity and precision.",
            "A Good Product,A Good Product with a Good quality",
            "Delivered safely,Not mentioning product features because everyone can read it. This is the highest value item I purchased on Amazon and kudos for safe and timely delivery.",
            "Do I need to say something? Its apple at it's best..  Happy!,Great product.. I love android and apple both, both have different characters I see. When it comes to iphone 13, I love the camera( great pictures), sound(like a surround sound), software, quality, smoothness etc it offers and with style and premiumness. It's not only about the style but really and honestly, overall the product is great. One should use it and realize how great and satisfying this brand and product is.. Great brand.. Go fot it if you could, you'll not regret..",
            "Device heating,It’s tooooo much heating in normal usage only….. I think this piece have some default because my friend also have same but not heated too early can my iPhone can be replace by new one.",
            "Totally disagree,Okay",
            "Too much heating battery health decrease very fast camera is also not good,Bahut zada hang ho raha battery health bhi kam ho raha bahut jaldi mai suggest karunga aap iPhone 14 buy karo",
            "ok,ok",
            "Good,Good one original product",
            "Good,Feature are good ,colour is not according to. Me",
            "So far so good,Writing this review after using the phone for 5 months. Pros - camera clicks amazing pictures, video recording is the best I've seen in a phone so far compared to my previous phones. Stable videos with no shaking - battery life is good. Lasts an entire day with medium use. I don't game on the phone. Charging is as quick as it is with phones that use USB C. - display is soo good. So bright - built is solid, dropped phone a couple of times once with the cover and once without and not even a scratch. - listening to music and watching videos is a hot cos of how good the speakers r. Crystal clear with the right amount of bass and treble. Cons - phone is a tad heavy and using it for hrs on a stretch can result in pain in the wrist or fingers Got the phone in Diwali sale on discount so bang for buck if u ask me",
            "I phone,I love it",
            "camera,Iphone 13 was good but after using 3 to 4 month it start heating. Camera quality is good even better than phone 15( I personally feel that).",
            "Mind blowing,Phone is absolutely amazing",
            "iPhone 13,Heating problems… jab bhi phone open karta hu heat karne lagta he … bekaar he ye phone",
            "Amazing,",
            "No-nonsense Apple.,I have gotten an iPhone 13 256 GB version for 58000 INR (No cost EMI). This is not my first iPhone, my mom gave me her used iPhone 4 many years ago back in 2014. I purchased it because I had a nice experience with my previous phone, and also felt that I wanted to try a fundamentally different smartphone experience. I've flashed custom ROMs on Androids, the works, but felt that I was tired and needed something different. I also had the perception of iPhones being well-made, no-nonsense phones and this was something I wanted to experience and see what it was like. Anyways, here are my impressions: Pros 1. The phone isn’t too difficult for me to use. Maybe it’s because I owned one long time ago and also because I was using an iPad. 2. I love how iPhones end up having the most timeless designs. The phone feels beautiful to hold and use with its premium glass back and lovely ergonomics. Volume Button placement is very awkward but I can get used to it. 3. I love the fact that you have a physical silent mode switch on the side. I thought this was something that was phased out and was quite surprised that it wasn't the case. 4. The phone feels very nicely optimized. The UI and the customization features enable you to have a good smartphone experience. There's no lag. 5. The camera quality is amazing. The photos this phone takes are beautiful. Even randomly clicked pictures are amazing. 6. Aside from one major issue which I faced, there was not a major paradigm shift moving from Android to Apple. Cons 1. Transferring WhatsApp from Android to iOS is a pain in the neck. I really wish apple didn’t have these weird walls preventing a seamless transfer of chat history to happen. I managed to do it but it took an unnecessarily long amount of time. 2. I think that moving from android to iPhone there are some thing you're going to miss. I for starters immediately wanted to customize the keyboard size to suit my larger hands. I was not able to do this sadly. Same goes for the lack of the back button - though swiping back works 99% of the time. 3. There were a few minor bugs in the phone. The keyboard would randomly swipe down for no reason. The text cursor would weirdly blink occasionally when typing. 4. The keyboard took some time to get used to. I was not very happy with that side of the experience. I was expecting it to be much better. Verdict As someone who moved away from Android to an iPhone, I'm happy to have made the switch. I wasn't expecting the experience to be this good honestly. I personally made the switch to an iPhone becuase I wanted a fundamentally different smartphone experience than what Android offers, and also to see what the other side of the pond looks like. Would I say that I'm satisfied? Hell yes. However, I would also think that while slightly different from a well polished Android, there doesn't seem to be much about it that makes it too different. From a functional perspective at the end of the day, you are using a phone, and ultimately an iPhone and an Android can do the same exact things without much issue. This is not to say that Apple phones are bad or Android phones are different or anything, rather from a functional perspective there isn't much of a difference. I purchased this device for an inflated price of 58k for the 256 GB model. I think that I've gotten my money's worth, given what I was looking for when I made the purchase. But does this necessarily count for everyone? I don't think so. The iPhone is an excellent, well-polished, no-nonsense phone, but there are many folks who would be okay forgoing some of that because all those traits that make an iPhone great come at a steep cost. An Android phone at 30k would lack the novel iOS experience and maybe 70% of the above traits, but for 30k you saved you can take your spouse/significant other out for a good meal, buy some shares on the stock market, maybe pay your rent, and order a decent pair of earphones to go along with your phone. You don't get the above things as well as the status symbol perks you get with an iPhone, but you do get peace of mind. So ultimately, would I recommend this device? Objectively yes. It is an excellent device. The best device I've ever used is the OnePlus 7, and I'm not joking when I say that this phone comes close. But at the same time, from a functional perspective, it doesn't make sense at this price point. It's just a smartphone at the end of the day. A damn good one yes, but it is a smartphone. My point being, Unless you have a massive reason to switch to an iPhone and are also able to completely afford it, switching doesn't make too much sense. So the phone is a good phone, but outside of the above parameters I honestly don't think there's a strong enough reason for anyone should buy it. So unless you can afford it, don't run around taking long EMIs for this device, even if it is an excellent product.",
            "Great,No words about the product as it's good and lovely since Apple is a very  branded and loved brand all over the world",
            "Value for money,I phone 13 is excellent value for money. Sturdy hardware, stable OS. Excellent camera. Battery could have been more. Overall fully satisfied.",
            "Good product,Good product",
            "Amazon failed in customer service,Within 6 months of purchase when I first time put the vibration motor it’s not working. Requested Amazon for replacement, they denied.   Recommend to buy apple product from apple stores",
            "Worst phone,Waste of money pls go for Samsung or any other better hardware better than I phone orcgo for latest version of iphone",
            "Good,Product was good...but disappointed is that apple company provid the charger also in box.",
            "Good,Good without any issues.",
            "Happy purchase,Happy using iphone",
            "Very good quality,Display are superb and processing speed are really very fast",
            "Nice,",
            "Best phone in this budget,I recently buy this product and I was amazed with its camera quality and over all working",
            "Nothing special,What do you want to hear about iPhone,if you are reading this review,it means that you have already done enough research to buy it.so, congratulations for your new iphone🎉",
            "Mengha,Hadd se jaada mengha hai iPhone 15 72 ne mil jata hai kharid lo kuch orrr ye nahi.  Ok th",
            "Beautiful,",
            "Everything is awesome,I think this a great phone I have ever seen",
            "Very bad,Data cable tuti hui nikli",
            "Thank you amazon,Great product",
            "Best price,In good condition my new iPhone is absolutely delivered safely",
            "It never lags .,The big difference between ios and android is that ios never lags , it feels so smooth , and voice control , gesture control , custom commands so manny things are there . And obviously camera quality is also good .",
            "Very good,Very nice",
            "Battery drain fast,Twise a day charging",
            "Value for money😊Happy with it,",
            "Good,Value for money",
            "Iphone,Do I need to write a review for iPhone ? People still gonna buy it anyway. Little bit disappointed from macro lens otherwise who criticize Apple.",
            "Always a king,Best experience in using when compared to android. Camera audio quality is always a top.",
            "Awesome,So beautiful so elegant just looking like a wow",
            "Delivery made within the time,Nice product",
            "Effortlessly sleek and powerful,Overall, the iPhone 14 Plus is a masterpiece of engineering and design, combining cutting-edge technology with unparalleled craftsmanship. From its gorgeous display to its powerful performance and advanced camera system, this device sets a new standard for what a smartphone can be. If you're looking for the ultimate mobile experience, look no further than the iPhone 14 Plus.",
            "Genuine product,Packaging and delivery experience was good Gifted to someone one he is happy",
            "Sahi hai,Sahi hai",
            "Best for Battery Screen size and Camera in this price,This is my first iPhone experience and I loved using this. Camera quality is decent and big screen size fullfills my content consumption demand. Battery backup is also great. It is smooth in use.",
            "Wow,Very good nice upgradation from 13 to 14 All r good Battery life very good Camera is excellent Design is excellent",
            "Camera 📸 beautiful,Battery is fast down but phone is most accessories and I'm very happy I like it  iPhone 15 🔥🔥  bahut accha h You buy this",
            "iPhone is iPhone always,",
            "Iphone review,Very good quality n safely delivered",
            "Overall Good,The phone is good the size of the phone for those who want a sleek one is too big and heavy meanwhile the performance of the phone is good except sometime the Face ID takes time to open.",
            "Value for money,Product is good as it described in its details. Happy to have it in such a low price.",
            "Rate this iPhone 14 camera,",
            "Slowly downloaded processor’s comparison is disappointment,Very slow compared in one 12 download speed separate apps very very death slow one plus 12 is worth for iPhone  only build quality is satisfied but overall 16 gb ram snapdragon gen 3 processor android 14 version so much better in one plus 12",
            "Worst timing in the entire history of gaming,This is the worst mobile, i have bought it for 80000 rupees but it gave notification at the most important time. I almost did 1vs4 in BGMI. Only 1 noob player was standing at that time a notifica came. This hulululu mobile is just a piece of trash",
            "Camera,Simple saying awsm no comparison",
            "Nice,Simply awesome",
            "Don’t bey,Not good phone hanging issu.over Hiting .Microphone properly not working. Overall android good. Bey Oneplus 11r.nothing 2",
            "Excellent,Its really a goodone Excellent Battery performance Every thing ok But at the beginning it seems larger than others with 6.7 screen in course of time i felt its ok now",
            "Good,Good and delivered before time as well",
            "iPhone14 plus,Very good product, Go ahead and take it",
            "After one month heating,Apple product one month after heavy heating. One of the brand mobile. But high cost price Please use that much amount  good think others uses.",
            "Good Phone,Very good phone",
            "Premium gadgets,Excellent Phone",
            "Ok,Ok good",
            "Apple is apple,Good",
            "Nice product, nice battery backup…camera obviously cool.,Product packaging was too bad. Should improve and give proper wraps for products like this.",
            "I got in very good price on amazon.,",
            "Fantastic phone,Original I phone",
            "Chapri Pooki,",
            "best,My first iphone . I loved it. Impressed with the battery life. very smooth to handle. overall superb phone",
            "Camera quality best hai,",
            "iPhone 14 plus,Great phone",
            "what for every penny. 🤝,what for every penny. 🤝",
            "Mobile is hang and slow ,very poor performance ,don't buy it 14 +,,Waste of my money, i am playing pubg but very hang and slow  porpamans, please don't buy this is mobile, i was cheated Amazon",
            "Awesome,Writing this after 7 months, go for it",
            "Goood,Goood",
            "Thanks to amazon,Happy with my phone, delivery safe, original phone, good price, thanks to amazon",
            "Touch problem,Phone screen touch not working properly Very slow touch",
            "first iphone,android is far better in user experience . waste of money after few days of usage still waste of money",
            "Iphone 14 plus,",
            "Very good,Everything is too good.",
            "Hang,Phone hanging",
            "After sale service,I ordered this phone in July, 2023. The delivery was fine. It also started working as it should. But the charger stopped working about ten days ago. The phone itself stopped working yesterday. Having ordered it from Amazon, I do not know how to go about complaint about it or even requesting for customer support. Had I purchased from an Apple Store , I could have at least taken it up with them. Any solutions possible? Subramanian",
            "Apple catalog completed,I have all the apple products except for the iPhone. This is my first iPhone after sticking to android for 12 years. Main reason was for battery and I give full marks to apple for optimisation Soft ware and hardware complement each other. I know most of them debate android vs apple, my opinion is that apple maintains consistency and keeps on optimising its OS and also has clear vision on privacy I’m happy overall",
            "Waste of money, not value for money,Good quality & performance, but not value for money",
            "Kidney,The iPhone is very good but my left side of abdomen is hurting after I sold the kidney. Nice iPhone by the way. 🙂",
            "Hats off to Apple. The 14 Plus - a class apart phone.,Its a big myth that Android phone are better than iPhone. I was with samsung flag ship mobile previously and Samsung never come even close to iPhone in any aspect. After saying this, there is no need to discuss any other android phones in the market. You only understand this beauty only once you use it. Go for it. The battery life is outstanding. The display, look and feel and the seem less fluidic way of its presence is immaculate. The 14 Plus - a class apart phone.",
            "Vhjjjjbcgh,",
            "Product problem,This mobile is in internally problem but company said, this is not part of our warranty. Very bed experience. Hate this online shopping.",
            ",good phone , value for money and best battery life.camera is perfect. camera is perfect.camera is perfect. camera is perfect.camera is perfect.😊",
            "Good buy,Good buy",
            "Extremely bad experience,Most of the apps hang very often. I have to either delete and reinstall the apps or switch off the phone and restart Battery life is extremely short The handset becomes hot if I use it continuously for 5 minutes",
            "iPhone is iPhone,What expected received and price better in Amazon",
            "I am “Yellower”,Love this version of iPhone 14. Magnificent colour on such a classy phone🤞 I love using it for the last 6 months🤩",
            "Phone not working, display/touch not working, purchased two days back only.,Phone not working, display/touch not working, purchased two days back only",
            "iPhone 14 Plus review,It such a nice phone I am using that phone since las one month and battery backup is such better that other android phones and graphics and video quality is much better such nice phone in 70 k …no compare with any other phone",
            "Network  port issue,Service centre says pay 15k for this issue.. it's not even 5 months we got this  paying so much",
            "Apple is a proven product..,Good product",
            "Iphone 14plus,Front Camera very poor",
            "Original product,The original iPhone product received as expected.",
            "good,they give original products too good u can trust them",
            "Worse camer system,The images clicked through from camera does not looks up to the mark and picture comes like a 15k phone . I really disappointed by the worest camera system of 14 plus model.",
            "I phone,It's awesome",
            "Original product,Amazing experience.. delivered on time very next day I ordered.. original product.. Thankyou Amazon.",
            "EXTREMELY BAD BATTERY. DO NOT PURCHASE,Have used this product for about 11 months now. Battery performance starts sinking from the 9th month. Now at 100% charge and normal daily office use ( WhatsApp / LinkedIn / Mails / Calls / minimal photography / almost no videos ) battery lasts from 9 am to 6 pm at 100% charge. Apple service centre says battery good upto 500 charges. Assuming 1 charge a day, you may need to replace battery at a cost of approx Rs 7000/- after a little more than one year use. Need to carry a charge bank with you if using heavily with photo and videos. Not worth Rs 80k. Avoid purchase.",
            "Original,Great product and long life battery value for money 💰",
            "Apple operating system so primitive..,I don’t know why Apple phones are a craze..Notifications panel is a khichadi no organisation of messages like android.Phone app is so old ..no gallery and file manager integration call drops are frequent.if u use camera for long or heavy use it heats pretty well as well as on charging. Only battery back up is great along with video recording.Android is so advanced in most aspects.Truecaller doesn’t work have to pick all calls. wi if ko settings so jakar he off kar sakte ho..Spending so much money on it is waste..",
            "I phone 14 plus is India variant or global,I love the mobile Camera battery lovo love love love love love love love love love love love love love",
            "Selling defective products,Seems seller is intentionally selling defective iPhone products at premium prices. Don’t buy. Everything is wrong on this platform…. Not Satisfied.",
            "Amazing Game Performance,Best Gaming phone, no one can beat",
            "Awesome battery really what an iPhone needs,Best one go for it, used for 2 months",
            "Wonderful,Best",
            "Battery backup,Bro battery gets exhausted so fast. Just half and hour back it was 56% now it is 42% What is wrong?",
            "Great,Best experience",
            "Very bad experience,Mobile using my wife network issue continues.. and also rear camera photo not  up to mark  Don't online  get",
            "Waste,Am not satisfied fr dis product. This is my first experience f dis iphone. Totally wasted my money to buy this product. Overheating is the main prblm and this ph is stuck when i using... Don't buy this waste product. Samsung and OnePlus is far far better than to compare with iphone 14 👎",
            "Rs 10k Android phone is better than this product,Overheating issue.. Don't buy this product please.. If anybody really love to lost 77k than go for this rubbsih.. Camera doesn't match up to even Android phone cost 10k Pathetic experience..",
            "Best iPhone and best shopping app. Guaranteed brand new iPhone,Original iPhone delivered. You can order with out any doubt. Even got replacement offer if received defective or faulty product. Thank you Amazon I am happy",
            "Average,Heating",
            "Awesome product,Good Thks Flipkart",
            "usual apple Q,stunning battery life - so far the best ever. rest is usual apple quality.",
            "Smooth Transition to iPhone 14 Plus,I recently made the switch from Android to the iPhone 14 Plus, and it has been a remarkably smooth transition. Here are some key points about my experience: 1. Seamless Setup: Setting up my new iPhone was a breeze. Apple's migration tool effortlessly transferred all my contacts, photos, and apps from my Android device. It was a stress-free process that ensured I didn't lose any important data. 2. Intuitive User Interface: The iOS interface on the iPhone 14 Plus is incredibly user-friendly. Navigating through the device, customizing settings, and finding apps is straightforward, even for someone who was accustomed to Android. 3. Performance: The iPhone 14 Plus packs a powerful punch. The device runs smoothly, and apps load quickly. Multitasking is a breeze, thanks to the robust hardware and optimized software. 4. Display: The OLED display on the iPhone 14 Plus is stunning. Colors are vibrant, and the screen is sharp and clear. It's a joy to use for watching videos, browsing, and gaming. 5. Camera: The camera quality on the iPhone 14 Plus is exceptional. The photos and videos captured are rich in detail and clarity. The advanced camera features and modes provide ample opportunities for creativity. 6. App Ecosystem: The App Store offers a vast selection of high-quality apps that enhance the iPhone experience. I found all my favorite Android apps and discovered some excellent iOS exclusives. 7. Privacy and Security: Apple's commitment to user privacy and security is evident. Features like App Tracking Transparency and Face ID add an extra layer of protection. 8. Battery Life: The battery life on the iPhone 14 Plus is impressive. I can comfortably go through a day of heavy usage without worrying about running out of power. In conclusion, my transition from Android to the iPhone 14 Plus has been a positive one. The device offers a premium experience with a top-notch camera, excellent performance, and an ecosystem that keeps everything well-integrated. If you're considering the switch, I highly recommend it for a seamless and satisfying smartphone experience.",
            "Battery is good,Battery is long lasting",
            "colour,excellent",
            "Beast Iphone,I love the powerful battery",
            "The Mobile is Good,Dear Sir we received the box and when I open that the charger plug not in the box Please send the charger plug",
            "Best phone ever,Battery is the best.",
            "Worst mobile,It has many bugs problem I’m going to service center they just clear bugs and after some day it start many problem again and Again now they said mobile Bangalore bhejna padega 20-25 dino ke liye",
            "Nice,A1 product",
            "Camera lenses damage,Had camera issue in 6 days of purchase without any physical damage",
            "IPHONE 15 is good upgrade from 12.,1. Good display - • Peak brightness is good and good visibility even in broad day light. • Clarity of the picture is good. 2. Excellent camera update - • Portrait mode pictures are great. • Resolution of the picture has improved and can see more details. 3. Dynamic island - • As a first time experience, it is exiting to see a separated put notch hanging and videos playing around it. Gotta see its uses in long run. 4. USB - C • Gives us option to use other android chargers when needed. Great relief for apple users. Don’t have to be extra careful while packing :-P 5. Colour - i bought it for my wife and pink colour was perfect. Note: This review is considering my previous phone was iphone 12.",
            "Very good product I liked it so much best phone ever,Value for money everybody should purchase this  (If you are rich enough)😂😂😎😎😎😎😎😎😎😎😎😎😎 performance is also very very good purchase it mann",
            "Heating machine,There could hardly be a more hardcore Apple bhakt than me, but I am disappointed. This phone while being an absolute beauty is unfortunatey a heating machine. DISAPPOINTED.",
            "Does it’s job :D,I switched from android to iOS but the entire process was really smooth, good batt life as of 3 months old, still lasts entire day.",
            "The device I almost lost within a week.,I had an interesting experience with the new model. The corners are noticeably curvier compared to the previous version, making the device sleeker. Unfortunately, the phone slipped out of my pant pocket while I was in an auto, and I only noticed after returning home. I quickly grabbed my iPad, locked my device, and used the ‘Find My’ app to track down my phone. Thankfully, it ended up in the hands of someone who wasn’t very tech-savvy and couldn’t figure out how to turn it off using the key combination. This allowed me to successfully locate and retrieve my device. Overall, it was quite an adventure. Now I slapped a rubber case on it and it’s not going anywhere.",
            "Nice,Very good looking this phone 📱 Display resolution fantastic Value for money Thanks Apple   And Thanks Amazon   Superb   Looking good",
            "Expensive phone,It is literally just a phone with an Apple logo on it. My sister forced me to buy this otherwise I would have bought poco 😂",
            "Very good product,Overall very good product, specially long lasting battery, image & video quality, display quality are very clear.",
            "PHONE HEATING WITHIN MINUTES OF USE,We have brought Apple i phone, in hope to get a good phone after spending heavy money it,s great disappointment that the phone is heating up heavily even for 02 minutes of use,the battery dried up automatically when idle with in one hour.Such defective piece apple and amazon are selling after taking high prices,great disappointment. Now after purchase we have to run to service center to repair brand new phone.. Misery of the situation.",
            "Overall good,Heating issues",
            "Great buy,Excellent product",
            "Good,I am using before 14 pro max it was better than this also 13 series used it was also good",
            "eSIM,eSIM not working, what I do now. Very disappointed.",
            "Just for Show off in Indian market,Iphone in indian market is a closed box. Just for status quo, it offers nothing. I had to sell it off at loss and bought samsung. No customizations, no true caller, all it offers is security but at what cost ? ? After using it for 10 days i felt i have traversed back in time to year 2000 - you will have to pay for everything, even for a simple ringtone. If you have been android user from long time, i would suggest never switch to ios, you will hate it after all phone is our daily companion these days.",
            "Phone have heating problems,Phone is not good camera and heating problem",
            "Heating Issue,My iphone is having very much heating issue. It will suddenly start heating up, have to remove back cover to make it cool down. Camera is also not that good rest things are fine",
            "Scratch,Scratch on a new phone",
            "My Honest review,",
            "Amazing Phone,It was a pleasure to walk around. The camera is also good.",
            "Heating issues,We are paying huge amount to buy iPhone but they are not coming up with innovative solutions control device heating, device heats up massively, sometimes I feels holding a nuclear plant in hand,",
            "camera mind blowing........,camera mind blowing",
            "This is iphone yes I know,Best iphone in cheap price",
            "Worst iPhone till day,iPhone has been worst now, their customer service is also pathetic. It is time to leave their ecosystem. Worst experience",
            "Heating Issue,Facing heating issues. Camera quality is not impressive. Device getting heated up too much for just 5 minutes of photo session.",
            "It’s Fantastic,I’m glad I’m back to using iPhone again.",
            "Geniune product,There are pros and cons to this model, but i am satisfied.",
            "transfer from android issue,I am trying to transfer data from android phone to iphone and following the instruction given but it is not complete and giving troubles.",
            "Refurbished,Received a refurbished phone in the place of new phone",
            "Unsatisfied with the Heating issue.,Overall it's okay except the heating issue. Device got automatically heated up after watching a video at high quality.I hope apple will fix it in upcoming updates.",
            "Worst phone ever 71 thousand trash,This phone is worse very poor all phones of apple are trash this is the worst phone ever nokia is better that it",
            "Apple,Bhut hi khrab phone hai bhai koi mat lena",
            "Bekar,Eak no ka bekar phone hai. PTA nhi Maine Kyu buy kiya, heat krta hai, camera quality to Eakdm bekar hai",
            "Nice,Like all other iPhones with few new features.",
            "Good phone,Phone is good. But Charging cable became faulty in few days only. Hope it will be replaced",
            "For all things,Good quality of photos and videos. Quality  of voice calling is good battery backup is good for normal phone user time over all my first this is my first I phone",
            "Works,I had an Iphone 12 and I switched to iphone 15. Honesty I do not feel any difference and does feels like holding the same device.  Dimensions are a bit sleeker this time.  Major camera improvements and the island is actually useful untill noticed.  I had options to buy s24 or this. I need consistency in life. I love the purchase . I still has the top 5 cameras compared to smartphones.",
            "No heating,Koi heating issue ni hota even mere pass I phone 14 b h shuru me hua tha wo heat or wo b sirf chrging k time pr ab to wo b ni hota ek dum Thk h mze me lo",
            "Worth buying,Awesome phone with awesome features. Specifically in love with photo and video quality of camera. Battery back up is decent so far used. Let’s see how many years battery lasts with optimal performance. User interface is far better than previous models. Value for money.",
            "This is an excellent product from Apple!,It beats all the other Android flagships in the market hands down. Go for it if you're looking for a long lasting and reliable product.",
            "Not charging within 15 days of buying,Not charging within 15 days of buying.",
            "Just hype,The device has heating issues has not much to offer when compared to its predecessors. It's just ornamental upgrade",
            "Excellent,Good product",
            "Heating,Without use kiye hi phone heat hota rhta h Battery b kb ud jari kuch pta ni chl ra itna gnda experience rhe ga I phone ka to mein kbhi na leti.. am disappoint 😠😡",
            "Great phone,Got great deal",
            "It's works very well,It's a good product",
            "Got a brand new phone loved ir,Ordered iphone today. Loved the Amazon service. The model number started with an M and battery capacity was at 100%. Loved the color",
            "Good,Purchased iphone 15 from store, its worth the price as i have upgraded it from iphone 11..the camera has major improvement than its previous model",
            "Simply awesome go for it,",
            "Packaging and product,Worst package from Amazon,  iPhone 15 has heating issue",
            "Almost perfect,Everything is better than my iPhone 12 except cell reception which is way worse here",
            "Has its pros, has its cons.,A decent premium smartphone, could've been a banger but cuts few of the most important things, hence lacking it's full potential.",
            "I switched from 13 to 15,I was using iPhone 13 and switching to 15 was a good choice I guess! The phone have  better camera than 13 as the lens are bigger with more megapixels also the Dynamic Island makes it more fun and engaging and the gaming experience is pretty smooth and amazing as it’s having iPhone 14 Pro Max chipset.",
            "Nice phone,Nice",
            "Iphone 15,All experience is nice only issue with battery and heating  otherwise very nice performance and clean using experience and best performance",
            "iPhone 15 is a value for money phone for those whose budget is between 70k and 80k,Got this at 71k from Unicorn store. Previously, I have used XS Max and 12. Apart from iPhone 15, I am also using iPhone 14 Pro. I would say that all the reviews here are not totally true. Charge heating issues have been resolved, and the phone works totally fine. I would recommend this to people with budget upto 80k. USB C is a plus point.",
            "Night pics are awesome,",
            "Overhyped I would say,Initially happy on starting that I finally owned iphone that too latest model. I know price to feature ratio is low, but still chose this as every one said there will be no lag in playing bgmi or pubg. But in reality, there are frame drops even on basic settings. Probably optimization issue but still, we paid hefty price. New update: Bought honor 90(12gb ram, 512gb memory) for my dad at 22k and it is faaar superior to this, be it camera, performance, screen, Ram management or storage. It's curved screen with higher level of brightness and smoothness kicks the iphone out. Only plus is iphones dual speakers. Don't purchase blindly. Mainly if you are some one coming from Android. You have to pay hefty for supported gadgets too. Think thrice before purchase.",
            "good phone,good phone being using it for a while maybe i will go for the pro max one for better batttery life but its a nice phone to",
            "Good buy,The temperature of the phone is getting higher after using it for mire than 15-20 mints. But the heat is not 'out of expectation' level. Good phone.",
            "Go for it,This iPhone is amazing for office or just simple casual use. It offers a lot of new features like the  Dynamic Island. It is on the 14 pro and pro max models but now available on regular versions. In my opinion, it is perfect for its cost. No heating problems from my side. Thanks.",
            "Battery health not good,I bought this phone in Nov 2023. Within 3 months, battery maximum capacity reduced to 98%. I am really unhappy with the product.",
            "WhatsApp chat a problem,I am sorry to write this but it is required to know that iPhone does not allow the WhatsApp chat history to transfer into it from Android. It is a sad part.",
            "Good product,Wonderful product with good features. Worth to buy.",
            "Please check and take,I recieved a used iPhone the box was already unboxed and not sealed and there were minor scratches on the screen as well as back please check serial number and verify it on Apple website",
            "Picture Quality is good.,",
            "Good,Woooooooow very bootyful camera phone with no use dandia island and bery very dangerous processor phone only for risthedaro ki gand jalane lai liye",
            "Genuine device delivered as expected and on time!,Genuine device delivered as expected and on time! This was a surprise gift to my brother and he surprisingly loved it.. ❤️",
            "Value for MOney,value for money invested is not worth with minor cosmetic changes and very basic memory upgrade",
            "Recommended,Recommended for those who are obsessed with Apple products. I'm not. Bought it for my wife. She is happy, so am I.",
            "Nice phone,Every thing is good camera display software all is good",
            "good to buy,very happy to buy after moving android to iphone . Camera is goood and perfomance also good battery life is also good.",
            "Perfect,Amazing. it came fast Super happy with my purchase And the customer support is perfect. Highly recommended and the phone came in a factory packed condition",
            "Money wasted,Don't buy this phone, go for samsung instead will give overall good experience. Samsung S24or S23 is sufficient for daily media consumption and photography",
            "Good phone But heating issues,Hi… I ordered new IPhone and received it yesterday… heating a lot ..while transferring files from old phone",
            "Always Good,Amazing and Cute",
            "Awesome phone,The perfect phone now with hassle-free Type C charging. The camera is outstanding. Performance - A16 bionic is a booster, and Dynamic Island is soothing to the eye. Also, it's so smooth that it never feels like a 60 Herts refresh rate. Thats it.",
            "This is called Apple,One word. Awesome 👌",
            "Hardware crash and poor after sales,The iPhone 15 hardware (mid system) failed after 2 weeks. I went to the service center they are repairing the phone from last 1 week but not replacing it with a new one. Poor quality phone hardware and overall bad apple service experience. Not recommend!",
            "Worth the hype,I had Samsung Note 2 for 3 years. Then S7 for 4 years. Finally Mi11X for 2 years. Familiar with Galaxy S23 and other similar phones Android was a beast. But I was bored. Confused btw iphone 15 plus and 14 pro max. Pro: Light weight Best Music output(on Bluetooth) Call quality is awesome Clean UI(it’s simple and focused) Very Customisable, The UI is 🔥 Decent photography for daily stuffs Smooth and snappy All my data backed up seamlessly. Transition was hassle free Streaming is awesome. Battery goes on for 2 days. Cons: The keyboard is confusing. I am struggling to type. I need to get used to it. Over-Priced Camera could have be better. I miss the Galaxy Pro options. I feel the phone is bit overpriced. Love using it. Wanna hold it for another 4 years.",
            "Best mobile,A really good phone better than samsung s24 in terms of performance and camera do buy this you will never fell regret",
            "Poor front cam quality,Poor front cam quality",
            "Camera quality,Camera quality, very bad night photos green symbol for photos. So please request waste of money….! I phone 15 night photos",
            "Worst,Worst phone , the phone is hanging , and heating issues not worth to the amount , don’t buy it",
            "Worst experience,Don’t buy this device from here.",
            "Best camera,",
            "This is my dream,What a phone i loved it send it fast I egarly waiting for this opportunity go god I am so happy to share this",
            "Loved it!!,Perfect product, Value for money.",
            "Worthy,Dianamic island makes this phone special than Iphone 14. price is same as 14 but this island make us feel like pro. Battery life is also good, we can use mobile up to 48 hrs in single charge.",
            "Best phone,",
            "best phone i ever used,best phone i ever used",
            "Best for an average user.,Go for this without a doubt instead of the 14 pro or previous ones. The camera is really the better one than all the previous versions. If you’re willing to give up on Always On Display, High Refresh Rates (iOS is optimised and you won’t feel any difference if you’ve never used a phone with high refresh rates.) and a Macro Lens then this is the one. The feel in hand is also amazing, you wouldn’t know unless you’ve held one. Type c is also a game-changer than all the previous versions.",
            "CAMERA,CAMERA NOT WORKING WITH IN 4-5 MONTHS",
            "Fantastic,One of the best iPhone ever…❤️",
            "Camera and battery and performance,Best in business.",
            "Excellent choice in the 15 lineup,It's been almost 3 months I have been using the 15 plus. It works flawlessly. The battery works for almost 1.5 days with regular usage(Better than the 15 Pro Max). Only the drawback of this phone is its 60hz display, if you are a casual gamer then you might not find any difference, but if you are a hardcore (full-time gamer) then I suggest you go for the Pro variants.",
            "Amazing,Value for money",
            "Quick delivery ,,All as expected",
            "Best mobile,The great mobile with amazing features, build quality is so good, amazing camera with stunning pictures. Good battery life,good performance.",
            "Super,Need the link to get it for ₹1,amazing.camera Quality is very good Good,value for money costly suggest able Follow it",
            "Genuine,Genuine product. I was hesitant at the beginning to order an expensive product online, but this product on Amazon is genuine and very happy. Got it for 74,990",
            "Good Product,Let me say this product exceeded all my expectations.",
            "Very good,I like it very much",
            "Best IPhone,I really like the phone. It’s fast, smooth and camera is really awesome, battery backup is good, everything is awesome except one thing that is sometimes it will heat. It’s been month that I am using this iPhone",
            "Game changer!!,iPhone 15+ is really a game changer and made an impact. Literally it is the best of best in plus variants. I upgraded iPhone 13 pro max to 15 plus and the only thing i felt disappointed was screen refreshment rate as we know pro variants provide 120Hz while basic models only provides 60Hz. Apple should improve screen refreshment rate in basic models also atleast we are paying 80k. anyway if you are looking to buy new iPhone then i'll absolutely suggest you to buy this phone. Im using 15 plus since january 2024 when i switched phones i really got that upgraded feeling and especially the battery performance is at its peak and one more thing the camera quality is on another level both video and photo (night mode). in hand feel is very light and weightless with thin bezels.",
            "Awesome,Awesome",
            "Wonderful design and love the matte finish,Although I would love a glossy side like the Pros but still it’s amazing.",
            "A must upgrade,Have been an iphone user from long, and loved the upgrade.",
            "very nice phone,smooth experience",
            "iPhone 15 Plus: Impressive Device with a Caveat,I recently purchased the iPhone 15 Plus from Amazon and overall, I'm quite pleased with the product. However, there's a significant drawback that potential buyers should be aware of. One of the drawbacks, though, is the lack of replacement options through Amazon. Unlike some other products where Amazon offers hassle-free replacements, with the iPhone 15 Plus, customers are required to go through Apple's service center for any issues that may arise.",
            "Great,Nice camera and smooth operating system battery backup is awesome",
            "Amazing product go for it.,Battery is long lasting compared to other models. Overall a balanced product.",
            "Very helpful, protective & secured having a long battery life , good looking phone,I like most this product.",
            "Just Awesome,Just Awesome!! After ordering this iPhone 15 Plus, I was not sure about it, too many things were going on in my mind based on social media. After receiving and verifying it on the Apple official site found it's a genuine product. Verified- Before Activating status was \"Not Activated Yet\" and After Activating the status is: \"Active and March 2024\".",
            "The best iPhone to get,If you're getting an iPhone, the Plus models are the best value for money. They offer all the important feature backed by incredible battery and a good enough camera. The Pro and Pro max models have all the best features, but after a while, those features aren't as important (to me). When I compare my main phone - a 15 Pro Max to this, I find this one to do pretty much all I need or want out of the phone. There are some notable omissions like the high refresh rate screen, but you get used to that as well.",
            "Phone refresh rate,I was using android phone all the years got bored and bought iPhone 15, although phone is flawless but still in this budget refresh rate should be 120 HZ, 60 Hz seems slow as I was using one plus 8t with 120 Hz. I did not like phone speed and camera in low light is also issue",
            "My iPhone 15 Plus is so cool and great! 🙌🏻👌Battery,Camera and settings are very nice.,I have gained a very good experience with my iPhone 15 plus. Actually I purchase this iPhone 15 plus for daily use purpose or you can say that I want to use this iPhone 15 plus as per my all requirements which I can do with this iPhone 15 plus. It’s my first and newest iPhone in my life. I’m feeling great times with this iPhone 15 plus. I have been choosing this iPhone on YouTube reviews and google search on this iPhone 15 plus model. Thanks a lot!🙏🏻",
            "Not fake,Recently bought it at the best price from Amazon",
            "Camera quality,All in one power pack mobile and most important Battery backup very impressive. Camera quality video quality is next level",
            "15 plus ki originality kya h,Original ki koi guarantee, nahin",
            "Fraud,Fraud",
            "Great product,Value for money. Battery backup is exceptional",
            "Bibhu,iPhone 15plus a nice photo and beautiful picture ana video my best choice iPhone 15 plus camera a amazing photo and beautiful video",
            "Its overheating and network issues,The product is not up to the mark and now i dobt even know how to replace and get new one. Amazon has declined to replace and asked to go to apple for replacement",
            "World's best phone,From amazon i get best deal and i phone 15 plus is world's best phone. I enjoyed many useful app which is only provide by apple.",
            "Fabulous,Iphone 15 plus is very well packed with features, Specially dynamic appearance on the screen",
            "Best mobile,It is best for picture quality and good sound for musice.overall performance very good..",
            "Incredible Phone. Recommend buying this phone if budget is not a concern.,The Apple iPhone 15 Plus is a little on the higher side of budget but it’s a great phone. The battery life is amazing, and offers over 15 hours of Screen On Time and over 36 hours of Standby Time and takes a little over an hour using the Apple 20W USB C Charger to completely charge. The lack of 120Hz display for the price range doesn’t make sense but I barely notice the 60 Hz display even when I use it next to my Samsung Galaxy S20 with its 120Hz display. There are a very few instances when the software doesn’t work as intended but nothing that’s majorly noticeable or work hampering. The 256GB Storage along with eSIM is a great use case for me. The Camera is usually very good with brilliant video recording, however I personally don’t like how the iPhone processes faces through its HDR. It captures literally all the details of the face, even if one doesn’t want it to and sadly there is no way to turn off HDR in newer models. HDR Videos or Dolby Vision Videos however are very well captured. The phone has a very good stereo setup that has noticeable bass. Consuming media on the phone is a delight. The USB C is a valuable addition that helps me use the same USB C Earphones that I use with my Samsung. The phone along with my Apple Watch SE and Airpods Pro makes a great combination.",
            "Battery Backup not as expected,Battery consumption is good when like watching movies. But Battery drops significantly while using like Facebook/Insta/Youtube.",
            "Phone Hanging and Heating problem,With in 10 days after buying.. the phone was hangout during calls and Heating problem was also there…",
            "Excellent product for the money spent,- Quality is really good like always with the Apple products. - Very beautiful, great quality and performance. - Prices will be good when you have some extra discounts with the offers from credit card, else I would suggest you wait till you have an offer with credit card or Great Indian festival/republic day sale or when a new version of iphone is launcing",
            "❤️🥹,Camera Quality is just Like…. Boom💣😃 Only cons I Noticed according to my preference is heating issue. Its something which Disappoints me otherwise good processor, Better battery capability also an perfect RAM management.",
            "Apple means satisfaction,Thanks to Amazon for fast delivery",
            "Best value for money,Its Osm",
            "Heating issue while charging,It's heating while charging",
            "Product is good but features are not working properly.,My iPhone is delivered in good condition. I am using location service in WhatsApp regularly. Apple Maps not working properly. I installed google maps but end up with difficulty to make it default maps, location service. Apple may have to fix this issue. Or if I missed something then I will have to in coming days.",
            "Awesome 👍,Big screen and good camera. What more is required",
            "ITS A BEAST,Switched from Android (S21 fe, one plus 7T my last 2 phones). I was waiting for S24+ but as i heard its coming with Exynos, I bought 15plus.. I was highly sceptical about the 60hz as i was coming from 120hz s21fe.. and tbh, in merely 30minutes i got used to it and believe me iPhones are wayyyy smoother than anything else, most probably bcoz of the High Touch Sampling rate and awesome animations.. Now coming to best part, which was the Main reason for me to opt 15plus… BATTERY LIFE.. this phone is a beast.. 2days with my usage easy.. Rest i mean, Screen Quality is awesome, Speakers are Fanstastic, Camera is pretty damn good (but i miss my 3x telephoto from samsung), iPhone experience is just flawless (no lags, no stutters, nothing whatsoever), Haptics and vibration motor is Great as well.. i means its a allround phone, got it for 63k. Cant be more happy with it..",
            "Good phone,It is a good phone",
            "Gift Pack Missing,Requested for a gift package with a special message. Unfortunately that was not taken care off. Rest everything is good",
            "**iPhone 15 Plus Review: Redefining Excellence in Every Aspect**,The iPhone 15 Plus is Apple's latest flagship smartphone, and it's nothing short of extraordinary. With its groundbreaking features, stunning design, and unparalleled performance, the iPhone 15 Plus raises the bar for what a smartphone can achieve. Here's a comprehensive review of this exceptional device: **Design and Build Quality:** The iPhone 15 Plus features a sleek and elegant design that is instantly recognizable as an Apple product. The device boasts a premium build quality, with a durable aluminum frame and a ceramic-glass back that feels smooth and luxurious to the touch. The seamless integration of the display and the slim bezels give the iPhone 15 Plus a modern and sophisticated look that is sure to turn heads. **Display:** The iPhone 15 Plus sports a breathtaking 6.9-inch Super Retina XDR display with ProMotion technology, offering an immersive viewing experience like never before. Colors are vibrant, blacks are deep, and the HDR support ensures stunning contrast and detail in every image and video. Whether you're watching movies, playing games, or browsing the web, the display of the iPhone 15 Plus sets a new standard for excellence. **Performance:** Powered by Apple's latest A16 Bionic chip and Neural Engine, the iPhone 15 Plus delivers unmatched performance and efficiency. Apps launch instantly, multitasking is seamless, and even the most demanding tasks are handled with ease. Whether you're editing 4K videos or playing graphics-intensive games, the iPhone 15 Plus handles everything with buttery-smooth responsiveness and unparalleled efficiency. **Camera:** The iPhone 15 Plus features an advanced triple-camera system, including a 12MP wide, 12MP ultra-wide, and 12MP telephoto lens. With improved low-light performance, enhanced optical image stabilization, and new computational photography features, the iPhone 15 Plus captures stunning photos and videos in any lighting condition. From crisp landscapes to detailed portraits, the camera of the iPhone 15 Plus excels in every situation. **Battery Life:** Despite its powerful performance and stunning display, the iPhone 15 Plus offers exceptional battery life that lasts all day on a single charge. With its advanced power management features and efficient hardware, the iPhone 15 Plus ensures that you stay connected and productive throughout the day, without having to worry about running out of battery. **Software:** Running on iOS 16, the iPhone 15 Plus offers a seamless and intuitive user experience that is unmatched by any other smartphone operating system. With its clean design, intuitive gestures, and robust ecosystem of apps and services, iOS 16 enhances the overall user experience and empowers you to do more with your iPhone 15 Plus. **Connectivity:** The iPhone 15 Plus supports 5G connectivity, enabling lightning-fast download and upload speeds for streaming, gaming, and browsing the web. Additionally, it comes with Wi-Fi 6E support for ultra-fast and stable wireless connectivity, as well as Bluetooth 5.4 for seamless pairing with other devices. Whether you're at home or on the go, the iPhone 15 Plus keeps you connected at all times. **Conclusion:** In conclusion, the iPhone 15 Plus is a masterpiece of design and engineering that redefines what a smartphone can be. With its stunning design, immersive display, unparalleled performance, and advanced camera capabilities, the iPhone 15 Plus sets a new benchmark for excellence in the smartphone industry. Whether you're a power user, a photography enthusiast, or simply someone who appreciates the finer things in life, the iPhone 15 Plus delivers an unparalleled experience that is sure to impress.",
            "Babu,All are good But mobile is heating when we are giving charging",
            "Just wow,This phone working so well, UI is simple and ultra smooth, screen is bright and vibrant, if you are long time android user you can switch for iphone for a new experience, battery life is also so good, one thing I really miss is call recording,",
            "Fine,Fine sett",
            "Very nice phone,I am so happy this product love it. iPhone 15 plus wonderful pictures camera quality and video quality.  So let’s go and buy it product.",
            "Awesome,An absolute delight to have this phone. This is my first I phone and it has broken all my previous assumptions of having a costly iPhone ( I thought it is not worth spending so much money on phone). Great experience till now very smooth and sharp phone and technology.",
            "Awesome product,IPhone 15pluse  camera systems are highly regarded, offering excellent image quality, especially in low light conditions.smooth operation and responsiveness to their designed processor Battery life is very good. Performance is too good.",
            "average,Tom’s Guide1 highlights the iPhone 15’s pros and cons. The pros include an upgraded camera with a 48MP main sensor, which replaces the 12MP main camera that’s been an iPhone staple for years1. The iPhone 15 also supports 2x optical zoom1. The cons revolve around features introduced a year ago1. Gadgets 3602 states that the iPhone 15 is the most exciting iPhone model as it finally gets some big upgrades2. The iPhone 15 starts at Rs. 79,900 for the 128GB variant in India2. It features a 48-megapixel main camera sensor and is powered by the A16 Bionic SoC2. The iPhone 15 now comes with Dynamic Island and USB Type-C port2. PCMag3 mentions that the iPhone 15 features a tweaked design, new display tools, an appreciable jump in performance, and a solid set of cameras at a price that’s hard to ignore3",
            "best phone among 15 models,best phone among 15 models",
            "received as committed,A product worth its price. Quality delivery ensured by Amazon adhering to the committed timelines. Thank you Amazon Team !",
            "Iphone is iphone,Dont worry about the market talks about the 15 since 6s iam using iphone i liked it iam passionate for iphones",
            "Amazing ❤️‍🔥 Best Buy of 2023,It's Fantastic. Amazing Battery Backup, Best for Videography and Photography. Amazing Software Experience. Overall it's the best till now.",
            "Battery charging issue,I recently bought Iphone 15 plus but disappointed with battery charging. It takes almost 6 hours of time to comolete 100% charging..i have trust issue now whether i received new phone or used one.. Also now i remeber the product package was sealed at the time of delivery..after 1 hour i tried to call delivedy guy but that was customer care unable reach it. I am disappointed with Iphone battery",
            "A good phone.,I liked this iphone 15 plus very much, huge battery backup, nice camera setup. Colour is just bluish white. If anyone specifically go for blue then this colour is not for you..!!",
            "Just like a wow no compere anything,I'm very happy iphone 15 plus 🥰 camera is a good battery backup most good gaming very smooth 😘",
            "Charging time mobile gets Heating,Overheating mobile on charging condition",
            "It was good,It was good",
            "Excellent,Really good product by Apple",
            "Great technology,An absolute delight to have this phone. This is my first I phone and it has broken all my previous assumptions of having a costly iPhone ( I thought it is not worth spending so much money on phone). Great experience till now very smooth and sharp phone and technology.",
            "WORTHIT,...",
            "Killer,Just Amazing..!",
            "I phone 15 plus return not allowing,Product is bad and amazonw not allowing to retune within 7 days",
            "Nice look,Performance",
            "Very much excited to join apple family,Unboxing experience was Ossum",
            "Awesome,I was just sifted from android to IOS  and just learning but it is awesoms experiance",
            "Honest Review from a usual Android User,I got this phone on 26th September after ordering the very first day of release. I must say the wait was worth it. The last Iphone had was 11 (basic model) and I was happy with it. Since then I switched to OnePlus 9pro and Samsung Z Flip 3, and then finally this. I knew it will be a good phone and delivered more than what I was expecting. I decided to go for it mainly because of the camera as they finally gave 48mp and then almost everything which a 14pro was offering. It hits it out of the park as for last 2 months I have not experience any issues. The best part is the battery life. I did see comparison vids and they all are true. I totally believe it has the best battery among all the models apple has offered. The pro models would definitely offer more but I do not see a reason to spend that much wherein this is also costly but atleast makes it worth it.. Go for it without any second thoughts.. it offers performance, look and statement for sure... 5 on 5 from me as a user!!",
            "Super,",
            "Not optimised yet,Need lot of optimisation and updates",
            "Really nice phone works fast and ios is great,The build quality the software the speed the cameras the battery life it’s all great, I’d post pics of the phone but I can’t coz I’m taking photo with it but it’s about this big in my hand",
            "Heating issue,Everything is Perfect except one Heating issue.",
            "Camera,Quality brilliant",
            "Camara quality superb,I like 15 pluse super handset photo Camara quality ammezing worthfull features are too good love this mobile better  siriers",
            "Worth for money we spent,Phone is excellent  the amount we paid for it this device is fully worth , loaded with lots of features and camera quality are some positive points , apple is doing well but fast charging should be introduce for this much price",
            "protrait 2x zooming,",
            "Iphone 15 plus,Iphone 15 plus has an excellent camera..cinematic mode for shooting videos,it is slightly larger than Iphone 15 and the older Iphone 11 which I have. It is a good buy from the brand if you're looking for practicality. Some people complained about the heating issue, it isn't much and was there when charging initially but it's probably normal as it's not affecting the performance of the phone yet",
            "Best in Best 15 plus,Osmmm Betterie life and big display , A16 chip thats why Perfect Super Power full display 15 series on top marketing",
            "Bohot garm hota he mobile,Over hiting problem update ke baadh bhi solve nahi huaa costumer care wale bol rhe hai agale updat me sahi hoga, dekhte hai kyaa hota hai🥺",
            "Nice awesome must buy,The anroid to iphone is big transformation.very proud to keep iphone with you.Its time to upgrade iphone.so buy it without any confusion"
          ],
          "user_name": [
            "Arbaaz",
            "Mohd Danish Shamim",
            "MWO SK SINGH",
            "Sujatha",
            "Marvellous ",
            "Naveen raj",
            "kavoori adithya",
            "Krishna tiwari",
            "Phone is absolutely perfect ",
            "Karan",
            "Vaishnavi Nelabotla",
            "Amazon Customer",
            "Unique",
            "Return to refund ",
            "Placeholder",
            "Gopal Dandgavale",
            "Ankush",
            "Manoj",
            "Chinni.kish",
            "Amazon Customer",
            "Azad",
            "Cajetan Dcruz",
            "Ranjith",
            "Amazon Customer",
            "Shailesh Nanavati.",
            "sumantra sarkar",
            "Rahul yadav",
            "Rimni Mukherjee",
            "Satish",
            "Koutuhal p.",
            "Giri Gaurav ",
            "Hariharan Balakrishnan",
            "SNEHA AGARWAL ",
            "Deepanshu kansal",
            "shashikant",
            "Sunil",
            "Mohamed eras",
            "Placeholder",
            "PROSENJIT MONDAL",
            "Nabi ullah khan",
            "Placeholder",
            "Amazon Customer",
            "Santhosh K.U",
            "Shantanu K",
            "Gaurav Arora",
            "Muhammed shibili",
            "RBC",
            "Bossy",
            "ROSHAN DHANAI",
            "Good quality",
            "Prabhat Srivastava",
            "Placeholder",
            "Rifat Mehraj",
            "M.M.Jalaly",
            "Abinash Gogoi",
            "Sai",
            "Very bad problem 😕",
            "Placeholder",
            "shiva",
            "Essdee",
            "Abhishek Kr Mishra",
            "Kamleshsinh Thakor",
            "Sanathan Juturu",
            "kenny smith",
            "Ajay Mishra",
            "YSM",
            "Elaine",
            "Nachiket Patil",
            "Rahul Sharma",
            "Pritam",
            "Senthilkumar",
            "Simran shrivastava",
            "Rajendra Kumar",
            "Rahul",
            "Neshim Rahman",
            "sanjay",
            "shibanimukherjee",
            "Kunaal",
            "ashutosh pandey",
            "Jayakrishnan",
            "Rahul",
            "Virendra kumar",
            "Shobhit Ranjan",
            "Amazon Customer",
            "Gangadharan Nadar",
            "Sumit S Illamalle",
            "Ankit Jangra",
            "KaushalTripathi",
            "Rajan Shibi",
            "Swapan Kumar Das",
            "Dk Gurung",
            "💫CRB.",
            "Rohit",
            "Placeholder",
            "Gopal krishna Reddy",
            "Vignesh",
            "Surajit",
            "Virag Muley",
            "Kanchan Kurmi",
            "Sarfaraj k.",
            "Amazing performance. A15 Bio chip prosessor is literally lit 🔥.",
            "Vishal",
            "Subodh Meshram",
            "harsh gupta",
            "Akok moyong",
            "Yash g.",
            "Amazon Customer",
            "pushpendra",
            "Ankit",
            "Ansel",
            "Raman Tripathi",
            "Manthan nathwani",
            "Best phone ever",
            "Nimesh Vyas",
            "Realme buds air 5 ",
            "Ayush maran",
            "Aditya",
            "koushik chaki",
            "Arif Khan",
            "Vipul Waskel ",
            "Om dhoke",
            "Amazon Customer",
            "SXX",
            "Vikas Kashyap",
            "manjunatha",
            "V C Mohan",
            "Maruf",
            "Gagan Pandey",
            "Amazon Customer",
            "Banarasi Kanya",
            "Somnath Choudhury",
            "Giri Gaurav ",
            "Shubham kumar",
            "Placeholder",
            "Sam",
            "Radha jangid",
            "Rohan",
            "NEHA",
            "Kunal",
            "Aradhya mittal",
            "Karan Jaiswal",
            "Ayasha Saifi",
            "Saurabh verma",
            "Priyanka",
            "Rahul Moghe",
            "Ra1rider",
            "Jyoti",
            "Iqbal Mansuri",
            "Rahul shivhare ",
            "Shiven",
            "Brendon Fernandes",
            "praveen",
            "Placeholder",
            "Akshay M B",
            "Lawrence Anthony Pereira",
            "suman singh",
            "Saud",
            "teja",
            "ravi singh",
            "Sumon mandal",
            "Priyanko",
            "Mahesh",
            "Ishwar",
            "Vinakshi Malik",
            "Alishba h.",
            "Atul raj",
            "Ananya",
            "Mohd Zeeshan",
            "Megharaj",
            "Happy",
            "Siraj solanki",
            "shailesh yeole",
            "Sukanya Dhara",
            "Shalin Sabu",
            "Tufel Ajmeri",
            "Mukilan",
            "Baldeep Kaur",
            "R J Sahu",
            "Very good item.",
            "Ashutosh",
            "Adil khan",
            "rahul singh",
            "Tejavath sravan kumar",
            "Very gorgeous phone his display smooth and camera is opp ",
            "Dr Rakesh Choure",
            "Kushal Achchha",
            "Amazon Customer",
            "Tushar Soni",
            "Amazon Customer",
            "AIYANKARAN G",
            "Sagnik Ghosh",
            "Mayank0802",
            "Vaibhav Tiwari",
            "Placeholder",
            "Rajesh M",
            "Umer Shaikh",
            "Joystan dsouza",
            "Raji",
            "A V Techno Soft India Pvt Ltd",
            "akshit s.",
            "Venkatesh K",
            "Harika rapol ",
            "Rituporno Sonowal",
            "Lovepreet singh",
            "Hardik Kumar Rawal",
            "Chirag",
            "Kshitija sontakke",
            "Camera quality best ",
            "Avinash Kumar",
            "aravindkumar",
            "Prasad",
            "Dinesh Kumar",
            "Amazon Customer",
            "Amazon Customer",
            "Ganesh",
            "Jayaram K S",
            "Nani",
            "Sai Bramarambika ",
            "Venkatesh g m Gowda",
            "Subramanian",
            "Harry",
            "Balakrishna",
            "KaFeel",
            "Mohan Jakkula",
            "Prasenjit Mahato",
            "Neelam Kashyap",
            "user",
            "Aditya Pathania",
            "Kumar Vinchurkar",
            "ARAVINDAN N",
            "I am a yellower now! Such a versatile version of iPhone 14 Plus especially this yellow. It shines like the sun in the day and yet vibrant in the night. It so classy to hold in your hands because of its size. 128gb is a wise choice understandably using iCloud storage. It’s not heavy as I thought it would be. I click pics and take videos confidently with the clarity iPhone gives. Trust me it’s worth buying one! Go for it people 🤞",
            "K Raja shekhar gowd",
            "Gaurav",
            "Roopashri",
            "Manhan",
            "Amazon Customer",
            "vjose",
            "Roshan jat",
            "kuldeep singh",
            "Nishanth",
            "A. K",
            "Neel",
            "Sameer ",
            "Seelu",
            "Basumatary j",
            "Amazon Customer",
            "Dharmender Bisht",
            "Aslam",
            "PANKAJ SHARMA",
            "Priyanka Panja",
            "Rashee",
            "Nishant kakade",
            "Am not satisfied with this phone... My first iphone experience is this... overheating and sometimes the ph is stuck.. waste of money i really disappointed to this product.",
            "laichat paul",
            "Mr. Sangma",
            "Ramani",
            "Sunny",
            "neelam p.",
            "Pritam Shetty",
            "Rishi s.",
            "Janardhan",
            "Saroj Debbarma",
            "Amazon Customer",
            "Deeksha Mishra",
            "RAJENDRA s.",
            "Anuj kumar",
            "Kishore",
            "N.SATHISH",
            "Anubhuti Tyagi",
            "Huzaif ",
            "Savan",
            "Consumer's voice",
            "Atc boot house",
            "Abhijeet",
            "Debabrata Sarkar",
            "ABHILASHA",
            "Sumit bisht",
            "Kumar Nitin",
            "Anant kumar",
            "Sudarshan",
            "Saurabh Pandey",
            "Amazon Customer",
            "Heating ",
            "Ketan",
            "KHUNDRAKPAM MANAO SINGH",
            "Nunhlu Pachuau",
            "Nirin",
            "nishant",
            "Bannu",
            "Amazon Customer",
            "sai chand",
            "Faisal Amir",
            "Sabu",
            "Placeholder",
            "vishnu prakash",
            "Premchandra",
            "Twinkle",
            "Azhar Khan",
            "Vishal",
            "divya",
            "Neelkant",
            "Bittu",
            "Ayushmaan",
            "Himanshu",
            "Arun Verma",
            "Amazon Customer",
            "KK",
            "RAM v.",
            "Rohit Vaidya",
            "Ashish R.",
            "Placeholder",
            "Alpana soren",
            "Arshi khan",
            "Omkar Shinde",
            "Jenni",
            "naveen",
            "Amy",
            "Robin Siby",
            "P.Rajesh",
            "Nice",
            "Jatin Patil",
            "Sourav Datta",
            "Gagandeep Singh",
            "Navaneen",
            "Nilotpal Poddar",
            "Arnab B.",
            "Samiksha jaiswal",
            "Vinay Hegde",
            "Mukesh",
            "aswathy sathyan",
            "Parth Patil",
            "Puneet Kumar",
            "Priyanshu",
            "ebrius_baba",
            "JMK Lalwani",
            "Sanjay Gulati Musafir",
            "Samir Shaikh ",
            "m.murali",
            "rishi soni",
            "mohan kumar ",
            "Anant Pokhariyal",
            "Mohnish",
            "Smith",
            "Sumanta Koley",
            "Anup",
            "Dhivya",
            "rakesh r.",
            "Lionel",
            "Rushikesh Sonawale",
            "Gurrapu Raju19",
            "Nishat",
            "ABUBAKKAR ",
            "Mohammed Sharuk m s",
            "Vinay Kumar ",
            "Placeholder",
            "Aayush sidana",
            "kush",
            "Bushan",
            "MOHIT KUMAR",
            "Eshwar Sreevatsa",
            "Tuhin Dey",
            "Om Amberkar",
            "Akshay",
            "Venkata Ratnam",
            "Tejavath sravan kumar",
            "sarithag",
            "Monika",
            "Raj",
            "Deepak Supali",
            "Maruthi H V",
            "Unknown",
            "Placeholder",
            "Ahmad",
            "pragya saha",
            "Debjit ",
            "Placeholder",
            "Rajkumar Yadav",
            "Debasis s.",
            "DR BABLU BHATTACHARJEE",
            "Placeholder",
            "AB",
            "shahzad",
            "Mahabir",
            "Yuvika Sharma",
            "Nitesh katwale",
            "monu",
            "Sadashiv",
            "Anuraag Banerjee",
            "Placeholder",
            "deepanker sati",
            "udayraj rokad",
            "Ajay",
            "Rajesh Kumar",
            "Fahad A.",
            "Taring Tam",
            "KNM REDDY",
            "Prince",
            "Nilesh Mourya",
            "Kumud Ranjan Sinha",
            "Chandan Rout",
            "Amit",
            "ponnuchamy",
            "T W",
            "Preetinder Singh",
            "Shivam",
            "Rohit Raghuwanshi",
            "Nyaneshwar Jadhav",
            "Babu Vandana",
            "Aniruddh",
            "Placeholder",
            "Nitesh",
            "An absolute delight to have this phone. This is my first I phone and it has broken all my previous assumptions of having a costly iPhone ( I thought it is not worth spending so much money on phone). Great experience till now very smooth and sharp phone and technology.Just awesome",
            "Pradeep Bhandari",
            "Ronak",
            "Rahul Das",
            "Amitendra Singh",
            "Saicharan",
            "Dipayan Singha Roy",
            "Goli Rakesh yadav",
            "Amandeep Singh",
            "Khokan",
            "Socratesm__Ar ",
            "rajasekharreddy",
            "gopal sinha",
            "Vipin Kumar",
            "Pavithiran",
            "Nitin Saxena",
            "I have purchased I phone 15 plus and camara quality is not good as compared to other 15 plus phone. Now funny thing is that Amazon not allowing to return ",
            "Placeholder",
            "CHANDAN.G",
            "Hitesh",
            "Samay Thapa",
            "shaik subhani",
            "md saif",
            "Joshua vincent",
            "Kumar Nitya",
            "shaik rafi",
            "Superb",
            "Rahul Yadav",
            "Alok",
            "PDB",
            "Munazir",
            "Jitu",
            "Subashini"
          ],
          "helpful_cnt": [
            "",
            "",
            "",
            "2",
            "",
            "",
            "",
            "",
            "",
            "1",
            "10",
            "",
            "1",
            "1",
            "1",
            "2",
            "3",
            "4",
            "",
            "",
            "2",
            "",
            "1",
            "",
            "5",
            "",
            "6",
            "",
            "",
            "1",
            "2",
            "4",
            "",
            "",
            "",
            "",
            "5",
            "2",
            "3",
            "9",
            "",
            "2",
            "",
            "",
            "",
            "3",
            "",
            "1",
            "",
            "3",
            "1",
            "10",
            "2",
            "",
            "2",
            "1",
            "2",
            "1",
            "",
            "",
            "6",
            "2",
            "16",
            "",
            "",
            "",
            "1",
            "",
            "1",
            "",
            "2",
            "3",
            "4",
            "",
            "",
            "1",
            "4",
            "4",
            "",
            "10",
            "",
            "1",
            "",
            "4",
            "1",
            "4",
            "",
            "4",
            "1",
            "6",
            "",
            "",
            "",
            "",
            "",
            "",
            "4",
            "1",
            "1",
            "1",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "1",
            "",
            "1",
            "1",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "1",
            "",
            "",
            "",
            "1",
            "",
            "1",
            "1",
            "1",
            "",
            "",
            "",
            "1",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "1",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "1",
            "",
            "1",
            "1",
            "1",
            "",
            "2",
            "2",
            "2",
            "",
            "2",
            "",
            "1",
            "3",
            "5",
            "",
            "1",
            "",
            "6",
            "2",
            "",
            "",
            "",
            "3",
            "2",
            "",
            "1",
            "",
            "",
            "",
            "",
            "6",
            "",
            "1",
            "2",
            "",
            "4",
            "1",
            "",
            "16",
            "3",
            "1",
            "13",
            "",
            "3",
            "5",
            "3",
            "",
            "1",
            "1",
            "1",
            "2",
            "",
            "1",
            "1",
            "1",
            "",
            "1",
            "17",
            "2",
            "1",
            "8",
            "5",
            "",
            "",
            "",
            "31",
            "3",
            "4",
            "",
            "8",
            "4",
            "",
            "",
            "2",
            "19",
            "",
            "4",
            "",
            "1",
            "",
            "",
            "1",
            "7",
            "",
            "",
            "",
            "",
            "9",
            "20",
            "1",
            "",
            "",
            "2",
            "1",
            "1",
            "",
            "1",
            "12",
            "",
            "",
            "",
            "9",
            "1",
            "1",
            "5",
            "",
            "8",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "97",
            "",
            "5",
            "2",
            "",
            "6",
            "11",
            "1",
            "4",
            "3",
            "2",
            "",
            "1",
            "3",
            "18",
            "",
            "3",
            "",
            "36",
            "2",
            "1",
            "4",
            "1",
            "",
            "",
            "",
            "16",
            "1",
            "",
            "1",
            "3",
            "",
            "3",
            "",
            "",
            "2",
            "1",
            "",
            "12",
            "",
            "",
            "10",
            "2",
            "1",
            "",
            "",
            "",
            "",
            "14",
            "1",
            "2",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "1",
            "9",
            "3",
            "4",
            "",
            "1",
            "",
            "",
            "",
            "",
            "3",
            "1",
            "",
            "4",
            "53",
            "2",
            "3",
            "2",
            "1",
            "1",
            "2",
            "1",
            "2",
            "",
            "1",
            "2",
            "",
            "14",
            "1",
            "4",
            "2",
            "3",
            "",
            "",
            "1",
            "2",
            "2",
            "",
            "9",
            "2",
            "1",
            "16",
            "1",
            "",
            "2",
            "11",
            "",
            "",
            "",
            "6",
            "4",
            "6",
            "9",
            "1",
            "",
            "9",
            "10",
            "",
            "2",
            "1",
            "3",
            "7",
            "2",
            "",
            "1"
          ],
          "date": [
            "Wed, Apr 03 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Thu, Dec 28 2023",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sat, Apr 13 2024",
            "Thu, Apr 11 2024",
            "Thu, Apr 11 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Sun, Apr 07 2024",
            "Sun, Apr 07 2024",
            "Sat, Apr 06 2024",
            "Sat, Apr 06 2024",
            "Tue, Mar 26 2024",
            "Mon, Mar 25 2024",
            "Sun, Feb 04 2024",
            "Wed, Jan 31 2024",
            "Thu, Apr 04 2024",
            "Tue, Apr 02 2024",
            "Sat, Mar 30 2024",
            "Thu, Mar 28 2024",
            "Thu, Mar 28 2024",
            "Mon, Jan 29 2024",
            "Sun, Jan 28 2024",
            "Wed, Dec 27 2023",
            "Wed, Dec 27 2023",
            "Sat, Dec 23 2023",
            "Wed, Jan 31 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Thu, Mar 21 2024",
            "Tue, Mar 19 2024",
            "Tue, Mar 19 2024",
            "Thu, Mar 07 2024",
            "Wed, Jan 17 2024",
            "Wed, Jan 17 2024",
            "Wed, Jan 17 2024",
            "Mon, Mar 18 2024",
            "Sat, Mar 16 2024",
            "Tue, Mar 12 2024",
            "Fri, Mar 08 2024",
            "Fri, Mar 01 2024",
            "Sun, Jan 14 2024",
            "Thu, Dec 14 2023",
            "Wed, Dec 13 2023",
            "Tue, Dec 12 2023",
            "Sat, Dec 09 2023",
            "Sun, Jan 14 2024",
            "Tue, Feb 27 2024",
            "Mon, Feb 26 2024",
            "Sat, Feb 24 2024",
            "Sun, Feb 18 2024",
            "Fri, Jan 12 2024",
            "Tue, Feb 13 2024",
            "Sat, Feb 10 2024",
            "Thu, Feb 08 2024",
            "Fri, Apr 12 2024",
            "Fri, Jan 12 2024",
            "Fri, Jan 12 2024",
            "Thu, Jan 11 2024",
            "Sun, Jan 07 2024",
            "Sat, Dec 09 2023",
            "Fri, Jan 05 2024",
            "Fri, Jan 05 2024",
            "Wed, Jan 03 2024",
            "Sun, Dec 31 2023",
            "Thu, Jan 25 2024",
            "Tue, Feb 06 2024",
            "Mon, Feb 05 2024",
            "Tue, Jan 23 2024",
            "Sun, Jan 21 2024",
            "Fri, Jan 19 2024",
            "Thu, Jan 18 2024",
            "Sun, Dec 17 2023",
            "Fri, Dec 15 2023",
            "Tue, Dec 12 2023",
            "Sun, Dec 17 2023",
            "Sun, Dec 17 2023",
            "Sat, Dec 16 2023",
            "Sat, Dec 23 2023",
            "Mon, Dec 18 2023",
            "Sat, Dec 02 2023",
            "Wed, Nov 29 2023",
            "Wed, Nov 29 2023",
            "Mon, Dec 11 2023",
            "Thu, Dec 07 2023",
            "Wed, Dec 06 2023",
            "Fri, Nov 24 2023",
            "Fri, Apr 19 2024",
            "Fri, Apr 19 2024",
            "Fri, Apr 19 2024",
            "Wed, Apr 17 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Tue, Nov 28 2023",
            "Tue, Nov 28 2023",
            "Wed, Apr 17 2024",
            "Wed, Apr 17 2024",
            "Tue, Apr 16 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Fri, Apr 12 2024",
            "Fri, Apr 12 2024",
            "Fri, Apr 12 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Thu, Apr 11 2024",
            "Mon, Apr 08 2024",
            "Mon, Apr 08 2024",
            "Sun, Apr 07 2024",
            "Sun, Apr 07 2024",
            "Wed, Apr 10 2024",
            "Fri, Apr 12 2024",
            "Thu, Apr 11 2024",
            "Thu, Apr 11 2024",
            "Thu, Apr 11 2024",
            "Wed, Apr 10 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Sun, Mar 31 2024",
            "Sun, Mar 31 2024",
            "Sun, Mar 31 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Tue, Apr 09 2024",
            "Sat, Mar 30 2024",
            "Sat, Mar 23 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Sat, Mar 30 2024",
            "Tue, Apr 09 2024",
            "Tue, Apr 09 2024",
            "Mon, Apr 08 2024",
            "Sat, Mar 30 2024",
            "Sat, Mar 30 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 27 2024",
            "Sat, Mar 30 2024",
            "Sat, Mar 30 2024",
            "Thu, Mar 28 2024",
            "Sat, Apr 06 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 20 2024",
            "Wed, Mar 20 2024",
            "Sat, Apr 06 2024",
            "Fri, Apr 05 2024",
            "Thu, Apr 04 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 20 2024",
            "Thu, Apr 04 2024",
            "Wed, Apr 03 2024",
            "Tue, Mar 26 2024",
            "Mon, Mar 25 2024",
            "Mon, Mar 25 2024",
            "Mon, Apr 01 2024",
            "Sun, Mar 24 2024",
            "Sun, Mar 24 2024",
            "Mon, Mar 25 2024",
            "Sun, Mar 24 2024",
            "Wed, Apr 03 2024",
            "Tue, Apr 02 2024",
            "Tue, Apr 02 2024",
            "Sat, Mar 23 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Thu, Mar 21 2024",
            "Sun, Mar 24 2024",
            "Sat, Mar 23 2024",
            "Thu, Mar 21 2024",
            "Thu, Mar 21 2024",
            "Wed, Mar 20 2024",
            "Tue, Mar 19 2024",
            "Tue, Mar 19 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 06 2024",
            "Sat, Apr 06 2024",
            "Fri, Apr 19 2024",
            "Tue, Apr 16 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sat, Mar 30 2024",
            "Sun, Mar 24 2024",
            "Sat, Mar 23 2024",
            "Fri, Apr 05 2024",
            "Sun, Mar 31 2024",
            "Wed, Feb 21 2024",
            "Sat, Feb 17 2024",
            "Tue, Feb 13 2024",
            "Sun, Feb 11 2024",
            "Sat, Feb 10 2024",
            "Mon, Oct 02 2023",
            "Wed, Mar 13 2024",
            "Fri, Dec 29 2023",
            "Mon, Dec 25 2023",
            "Wed, Dec 20 2023",
            "Tue, Dec 19 2023",
            "Sat, Dec 16 2023",
            "Sun, Feb 04 2024",
            "Sat, Feb 03 2024",
            "Wed, Jan 31 2024",
            "Tue, Jan 30 2024",
            "Fri, Feb 09 2024",
            "Mon, Feb 05 2024",
            "Mon, Feb 05 2024",
            "Mon, Jan 29 2024",
            "Sun, Jan 28 2024",
            "Thu, Jan 25 2024",
            "Thu, Jan 25 2024",
            "Fri, Jan 19 2024",
            "Thu, Jan 11 2024",
            "Wed, Jan 10 2024",
            "Tue, Jan 30 2024",
            "Sat, Jan 13 2024",
            "Sun, Nov 05 2023",
            "Sat, Nov 04 2023",
            "Thu, Nov 02 2023",
            "Mon, Oct 30 2023",
            "Fri, Oct 20 2023",
            "Mon, Oct 16 2023",
            "Sun, Jan 07 2024",
            "Fri, Jan 05 2024",
            "Wed, Dec 06 2023",
            "Mon, Dec 04 2023",
            "Fri, Dec 01 2023",
            "Tue, Nov 28 2023",
            "Wed, Sep 27 2023",
            "Thu, Nov 09 2023",
            "Sat, Oct 14 2023",
            "Tue, Oct 10 2023",
            "Thu, Dec 14 2023",
            "Wed, Sep 27 2023",
            "Tue, Sep 26 2023",
            "Mon, Sep 25 2023",
            "Thu, Nov 23 2023",
            "Sat, Nov 11 2023",
            "Tue, Sep 12 2023",
            "Mon, Nov 06 2023",
            "Mon, Nov 06 2023",
            "Tue, Sep 19 2023",
            "Sat, Sep 16 2023",
            "Mon, Aug 28 2023",
            "Sun, Aug 27 2023",
            "Sun, Oct 08 2023",
            "Sat, Aug 26 2023",
            "Fri, Aug 25 2023",
            "Mon, Oct 30 2023",
            "Wed, Sep 06 2023",
            "Sun, Sep 03 2023",
            "Tue, Aug 29 2023",
            "Wed, Aug 23 2023",
            "Wed, Aug 23 2023",
            "Fri, Aug 18 2023",
            "Sat, Sep 30 2023",
            "Sat, Sep 30 2023",
            "Thu, Sep 28 2023",
            "Thu, Sep 28 2023",
            "Wed, Sep 20 2023",
            "Mon, Sep 11 2023",
            "Mon, Sep 11 2023",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Fri, Mar 15 2024",
            "Sat, Apr 20 2024",
            "Thu, Apr 18 2024",
            "Thu, Apr 18 2024",
            "Sat, Mar 23 2024",
            "Tue, Apr 16 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Sun, Apr 14 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 13 2024",
            "Thu, Feb 01 2024",
            "Sat, Apr 13 2024",
            "Thu, Apr 11 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Mon, Apr 08 2024",
            "Sat, Apr 06 2024",
            "Mon, Apr 08 2024",
            "Sun, Apr 07 2024",
            "Tue, Mar 19 2024",
            "Fri, Mar 15 2024",
            "Sat, Apr 06 2024",
            "Thu, Apr 04 2024",
            "Thu, Apr 04 2024",
            "Thu, Mar 14 2024",
            "Mon, Apr 01 2024",
            "Tue, Mar 26 2024",
            "Mon, Apr 01 2024",
            "Sun, Mar 31 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 13 2024",
            "Mon, Mar 11 2024",
            "Mon, Mar 11 2024",
            "Tue, Mar 26 2024",
            "Tue, Mar 26 2024",
            "Tue, Mar 26 2024",
            "Thu, Mar 14 2024",
            "Sat, Mar 23 2024",
            "Fri, Mar 08 2024",
            "Wed, Mar 06 2024",
            "Wed, Mar 06 2024",
            "Sat, Mar 23 2024",
            "Wed, Mar 20 2024",
            "Wed, Mar 20 2024",
            "Tue, Mar 19 2024",
            "Mon, Mar 04 2024",
            "Sun, Mar 17 2024",
            "Sun, Mar 17 2024",
            "Sun, Mar 17 2024",
            "Wed, Feb 28 2024",
            "Mon, Feb 26 2024",
            "Tue, Jan 30 2024",
            "Mon, Mar 11 2024",
            "Sun, Mar 03 2024",
            "Thu, Mar 14 2024",
            "Wed, Mar 13 2024",
            "Sun, Feb 25 2024",
            "Sun, Mar 10 2024",
            "Mon, Feb 19 2024",
            "Mon, Feb 19 2024",
            "Sun, Feb 18 2024",
            "Sun, Mar 03 2024",
            "Sun, Feb 25 2024",
            "Sun, Feb 25 2024",
            "Tue, Mar 05 2024",
            "Tue, Feb 20 2024",
            "Sun, Mar 03 2024",
            "Sun, Mar 03 2024",
            "Sat, Mar 02 2024",
            "Thu, Feb 29 2024",
            "Mon, Feb 26 2024",
            "Mon, Feb 26 2024",
            "Sun, Mar 03 2024",
            "Fri, Dec 08 2023",
            "Sat, Mar 02 2024",
            "Sat, Mar 02 2024",
            "Sat, Feb 24 2024",
            "Sun, Feb 25 2024",
            "Sun, Feb 11 2024",
            "Sat, Feb 10 2024",
            "Thu, Feb 08 2024",
            "Sat, Apr 20 2024",
            "Fri, Feb 23 2024",
            "Sat, Feb 17 2024",
            "Sat, Feb 17 2024",
            "Thu, Feb 15 2024",
            "Wed, Apr 17 2024",
            "Sun, Apr 07 2024",
            "Wed, Apr 03 2024",
            "Sun, Apr 07 2024",
            "Sat, Apr 06 2024",
            "Wed, Apr 17 2024",
            "Tue, Apr 16 2024",
            "Fri, Apr 12 2024",
            "Fri, Apr 12 2024",
            "Thu, Apr 11 2024",
            "Sat, Apr 06 2024",
            "Sun, Mar 31 2024",
            "Fri, Mar 29 2024",
            "Fri, Mar 29 2024",
            "Sun, Feb 18 2024",
            "Fri, Apr 05 2024",
            "Thu, Apr 04 2024",
            "Tue, Apr 02 2024",
            "Tue, Apr 02 2024",
            "Tue, Apr 02 2024",
            "Sun, Feb 18 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 27 2024",
            "Sun, Feb 18 2024",
            "Mon, Mar 18 2024",
            "Mon, Mar 18 2024",
            "Sat, Mar 16 2024",
            "Sat, Mar 16 2024",
            "Tue, Mar 26 2024",
            "Fri, Mar 22 2024",
            "Tue, Mar 12 2024",
            "Sun, Mar 10 2024",
            "Sun, Mar 10 2024",
            "Thu, Mar 14 2024",
            "Sat, Mar 09 2024",
            "Sat, Jan 20 2024",
            "Fri, Jan 19 2024",
            "Wed, Jan 17 2024",
            "Sun, Mar 10 2024",
            "Sat, Mar 09 2024",
            "Fri, Mar 08 2024",
            "Sun, Mar 03 2024",
            "Sun, Jan 14 2024",
            "Mon, Feb 26 2024",
            "Fri, Jan 12 2024",
            "Thu, Jan 11 2024",
            "Mon, Jan 08 2024",
            "Fri, Mar 01 2024",
            "Thu, Feb 29 2024",
            "Thu, Feb 15 2024",
            "Sat, Feb 17 2024",
            "Fri, Dec 29 2023",
            "Sun, Jan 07 2024",
            "Thu, Feb 08 2024",
            "Thu, Feb 08 2024",
            "Sat, Feb 03 2024",
            "Fri, Dec 29 2023",
            "Fri, Feb 16 2024",
            "Sat, Jan 06 2024",
            "Fri, Jan 05 2024",
            "Wed, Feb 14 2024",
            "Wed, Jan 24 2024",
            "Mon, Dec 18 2023",
            "Sat, Dec 16 2023",
            "Thu, Dec 14 2023",
            "Sun, Jan 07 2024",
            "Wed, Jan 24 2024",
            "Tue, Jan 23 2024",
            "Fri, Dec 22 2023",
            "Fri, Jan 12 2024",
            "Sat, Nov 25 2023",
            "Mon, Dec 18 2023",
            "Wed, Dec 06 2023",
            "Mon, Dec 04 2023",
            "Sat, Dec 02 2023",
            "Tue, Jan 02 2024",
            "Fri, Dec 08 2023",
            "Fri, Dec 29 2023",
            "Fri, Dec 29 2023",
            "Sun, Dec 24 2023",
            "Sun, Dec 24 2023",
            "Sat, Dec 23 2023",
            "Fri, Dec 22 2023",
            "Fri, Dec 22 2023",
            "Thu, Dec 21 2023",
            "Tue, Dec 19 2023"
          ]
        },
        "emotion_data": {
          "X-axis": [
            4.8,
            6.34,
            -8.65,
            -11.92,
            2.41,
            -4.5,
            1.79,
            -12.29,
            -11.31,
            -5.13,
            -0.68,
            -7.08,
            -0.01,
            -8.25,
            -0.29,
            -1.84,
            7.13,
            -10.59,
            2.9,
            -10.93,
            3.58,
            2.71,
            -2.68,
            -14.36,
            3.37,
            -0.07,
            0.3,
            -0.67,
            -13.04,
            -1.14,
            -7.21,
            1.42,
            -7.64,
            4.6,
            -12.26,
            3.45,
            -10.45,
            -7.51,
            -7.09,
            1.95,
            -2.82,
            6.19,
            -5.26,
            -10.79,
            3.59,
            3.85,
            -3.92,
            -0.24,
            -11.47,
            -13.82,
            7.61,
            2.45,
            -6.31,
            1.42,
            5.87,
            -9.11,
            5.95,
            -2.22,
            -13.14,
            -12.21,
            -11.67,
            -11.92,
            4.02,
            -0.36,
            -14.96,
            2.29,
            -3.4,
            0.19,
            5.81,
            -4.03,
            3.6,
            1.66,
            4.51,
            3.4,
            -2.5,
            -10.34,
            0.03,
            -2.2,
            2.27,
            -1.35,
            -6.94,
            4.28,
            -5.41,
            5.04,
            2.18,
            1.52,
            -5.81,
            5.87,
            6.71,
            -9.19,
            4.49,
            3.76,
            -11.76,
            1.12,
            -9.74,
            -12.21,
            5.39,
            5.95,
            3.37,
            3.45,
            -5.49,
            -12.5,
            5.89,
            -0.73,
            3.46,
            4.61,
            -4.3,
            -2.53,
            6.68,
            3.95,
            3.38,
            -9.7,
            2.33,
            6.01,
            4.09,
            -14.89,
            0.65,
            3.38,
            2.32,
            -0.47,
            3.38,
            -11.67,
            -0.16,
            -10.2,
            1.11,
            -1.46,
            -11.31,
            2.82,
            2.25,
            2.81,
            2.11,
            -14.71,
            -4.84,
            3.5,
            -1.66,
            -11.29,
            -11.66,
            -2.34,
            3.9,
            -6.84,
            1.99,
            -15.39,
            -12.92,
            -10.73,
            -4.11,
            -14.03,
            -3.04,
            -7.17,
            2.42,
            -14.7,
            -2.64,
            -2.77,
            -3.92,
            -12.12,
            6.12,
            -5.09,
            2.37,
            -13.75,
            3.96,
            -8.17,
            -14.8,
            -2,
            0.54,
            -0.18,
            -14.8,
            2.55,
            0.41,
            -12.59,
            0.79,
            -6.94,
            -13.91,
            0.48,
            -7.59,
            -7.45,
            -0.83,
            -4.53,
            -10.21,
            -12.21,
            -1.52,
            -10.79,
            -5.98,
            -2.74,
            -6.26,
            -1.55,
            2.67,
            0.69,
            2.35,
            -7.52,
            -1.69,
            -3.99,
            2.63,
            -6.19,
            -12.05,
            5.39,
            1.49,
            -13.79,
            -0.45,
            2.95,
            5.21,
            7.3,
            -15.29,
            -14.78,
            -5.95,
            -8.89,
            4.8,
            -7.11,
            1.36,
            -5.63,
            -0.33,
            -7.51,
            2.49,
            -12.25,
            -13.47,
            3.66,
            4.22,
            -3.1,
            -0.36,
            -13.44,
            5.17,
            5.53,
            -2.52,
            -7.15,
            6.74,
            -2.73,
            -7.84,
            3.59,
            -3.92,
            -13.13,
            4.57,
            1.2,
            1.12,
            4.43,
            -0.93,
            2.29,
            -14.21,
            -2.27,
            2.16,
            -10.79,
            -2.42,
            -13.84,
            -11.24,
            -1.96,
            -5.46,
            -3.39,
            -0.84,
            6.58,
            6.67,
            1.55,
            -12.44,
            -0.21,
            -12.44,
            2.12,
            3.11,
            -2.73,
            1.13,
            4.91,
            -12.5,
            -1.11,
            -2.25,
            -4.28,
            -10.56,
            2.02,
            2.46,
            5.91,
            3.16,
            -11.8,
            4.99,
            -1.37,
            2.99,
            3.87,
            -7.73,
            8.31,
            0.79,
            7.09,
            -8.37,
            4.04,
            4.95,
            -10.84,
            -8.82,
            -1.36,
            6.81,
            4.08,
            4.49,
            8.58,
            -8.7,
            -0.7,
            3.59,
            -6.69,
            1.99,
            6.69,
            4.68,
            3.97,
            -8.71,
            7.79,
            4.65,
            5.32,
            -6.01,
            -0.14,
            0,
            3.88,
            3.47,
            -4.68,
            -3.04,
            2.05,
            -3.83,
            -3.31,
            1.2,
            3.72,
            -12.52,
            1.89,
            4.32,
            -10.21,
            1.46,
            -1.1,
            -12.36,
            4.41,
            5.41,
            0.41,
            -3.17,
            -11.83,
            0.26,
            3.29,
            -9.21,
            -3.44,
            1.29,
            3.59,
            0.25,
            0.37,
            7.85,
            -11.78,
            7.56,
            -7.71,
            -0.98,
            -10.68,
            -6.66,
            -2.71,
            -1.54,
            -3.6,
            2.16,
            -2.46,
            4.12,
            -13.08,
            -2.98,
            -15.54,
            6.53,
            -3.29,
            -2.51,
            -6.06,
            -4.47,
            4.16,
            7.48,
            -6.12,
            4.52,
            -8.15,
            -5.52,
            5.72,
            5.59,
            -4.03,
            -4.67,
            3.13,
            -5.5,
            0.62,
            -7.64,
            -12.59,
            -2.59,
            -6.23,
            -10.16,
            -11.17,
            -13.8,
            0.27,
            -2.76,
            -12.78,
            -10.15,
            1.43,
            4.38,
            -1.08,
            -5.73,
            -4.52,
            4.48,
            -0.99,
            -1.58,
            -5.04,
            -1.46,
            -9.8,
            -5.23,
            -6.24,
            -8.39,
            -5.42,
            -0.68,
            5.58,
            3.49,
            6.66,
            -2.87,
            -4.19,
            -0.28,
            4.47,
            -0.17,
            -5.12,
            -13.5,
            -7.24,
            3,
            7.72,
            -1.68,
            -4.67,
            5.42,
            -10.94,
            -1.98,
            2.73,
            -3.24,
            -8.38,
            0.31,
            2.41,
            -3.9,
            -2.23,
            6,
            -11.67,
            0.81,
            -6.02,
            3.21,
            0.34,
            -5.53,
            2.77,
            -13.95,
            -13.79,
            2.43,
            -13.98,
            -11.84,
            5.6,
            -10.85,
            -15.28,
            -7.35,
            -3.36,
            -13.85,
            -5.82,
            -1.61,
            4.41,
            -6.99,
            -3.23,
            -4.31,
            -9.96,
            -3.1,
            0.07,
            0.37,
            1.17
          ],
          "Y-axis": [
            13.33,
            -5.41,
            -11.7,
            -6.04,
            12.22,
            4.9,
            -10.57,
            -5.91,
            -12.43,
            11.2,
            9.31,
            0.5,
            -7.66,
            -9.1,
            10.08,
            9.43,
            -6.22,
            -9.03,
            14.59,
            -8.04,
            12.33,
            13.16,
            14.06,
            -6.39,
            -4.59,
            -7.36,
            13.58,
            8.44,
            -6.61,
            -6.48,
            -4.95,
            7.6,
            10.59,
            10,
            -7.79,
            12.99,
            -5.4,
            -6.24,
            0.48,
            7,
            14.89,
            -8.52,
            13.09,
            -3.44,
            6.45,
            4.71,
            -6.27,
            -10.29,
            -7.86,
            -7.14,
            7.59,
            12.02,
            -1.62,
            11.48,
            -6.75,
            -6.61,
            -4.86,
            -10.04,
            -7.12,
            -11.44,
            -1.88,
            -8.71,
            8.65,
            -11.24,
            -5.23,
            12.5,
            12.46,
            5.89,
            4.42,
            3.74,
            -10.13,
            7.53,
            -7.28,
            4.05,
            -9.87,
            -10.41,
            8.44,
            8.28,
            4.3,
            8.83,
            -9.9,
            5.21,
            7.03,
            -10.95,
            15.83,
            6.33,
            -8.34,
            -6.02,
            -5.05,
            -5.09,
            5.3,
            -4.51,
            -7.5,
            10.51,
            -6.11,
            -10.48,
            1.53,
            8.96,
            10.87,
            2.13,
            2.73,
            -11.29,
            6.93,
            -6.65,
            -11.26,
            7.73,
            4.14,
            7.95,
            -8.66,
            -7.01,
            7.09,
            -7.88,
            8.59,
            -7.4,
            9.21,
            -9.16,
            -8.05,
            -13.01,
            -7.73,
            -12.08,
            2.65,
            -8.52,
            -11.67,
            -9.2,
            12.56,
            7.7,
            -4.05,
            10.21,
            -9.34,
            14.57,
            -4.59,
            -7.23,
            2.01,
            -6.63,
            8.49,
            -8.48,
            -12.1,
            14.1,
            -10.94,
            -11.16,
            -9.98,
            -6.72,
            -8.32,
            -6.39,
            6.99,
            -2.71,
            4.03,
            -2.24,
            -10.8,
            -4.85,
            10.9,
            15.31,
            5.51,
            -8.35,
            -5.78,
            11.09,
            -7.18,
            -7.44,
            11.17,
            -1.2,
            -5.12,
            5.07,
            12.81,
            -11.58,
            -4.88,
            6.04,
            -9.9,
            -9.41,
            14.92,
            7.08,
            -5.94,
            -6.79,
            -6.29,
            -6.39,
            14.81,
            3.04,
            -4.76,
            -11.25,
            11.08,
            -11.38,
            -10.36,
            7.29,
            3.05,
            6.9,
            13.52,
            15.16,
            3.53,
            -6.04,
            7.47,
            11.25,
            -3.99,
            -0.55,
            -5.47,
            -8.57,
            2.26,
            -7.92,
            11.9,
            -12.17,
            4.84,
            8.18,
            -6.78,
            -9.64,
            -2.82,
            -7.3,
            9.68,
            -10,
            9.52,
            1.72,
            11.82,
            -7.21,
            -4.15,
            -3.15,
            -5,
            6.98,
            -7.42,
            12.53,
            11.84,
            -6.6,
            -8.68,
            -6.51,
            13.58,
            -6.21,
            -10.24,
            11.89,
            -9.21,
            -5.7,
            4.81,
            -8.01,
            -8.83,
            14.04,
            7.91,
            -7,
            10.41,
            -5.84,
            -9.77,
            7.33,
            15.12,
            -10.06,
            2.88,
            -2.81,
            -11.26,
            0.84,
            -5.46,
            11.68,
            6,
            -5.82,
            5.82,
            10.25,
            -4.49,
            -7.01,
            -4.36,
            -5.35,
            -11.63,
            3.52,
            14.78,
            -12.25,
            -8.86,
            0.76,
            10.77,
            -5.81,
            -7.19,
            10.03,
            -7.44,
            6.5,
            -5.77,
            -6.93,
            -4.82,
            9.15,
            4.51,
            -11.85,
            6.65,
            -6.55,
            5.58,
            8.38,
            -2.02,
            -9.87,
            -11.87,
            -8,
            -3.6,
            -8.84,
            9.6,
            -9.67,
            -10.44,
            8.8,
            -11.57,
            4.45,
            -11.11,
            -1.53,
            13.86,
            -7.16,
            -10.44,
            11.42,
            -3.76,
            -9.7,
            -6.14,
            -10.94,
            12.15,
            -11.67,
            -11.42,
            12.76,
            2.3,
            5.79,
            8.81,
            -10.99,
            5.79,
            13.89,
            -6.83,
            -12.27,
            -8.07,
            -10.97,
            5.91,
            -8,
            8.72,
            8.38,
            -3.23,
            -11.1,
            12.08,
            4.07,
            8.97,
            -5.88,
            10.23,
            -10.71,
            -0.35,
            10.58,
            3.69,
            -10.42,
            10.76,
            -7.83,
            -9.63,
            -9.2,
            -6.24,
            -0.19,
            3.52,
            -11.55,
            -6.44,
            15.01,
            4.35,
            6.48,
            5.11,
            5.76,
            -10.37,
            -5.87,
            6.24,
            -9.05,
            -6.61,
            9.95,
            5.57,
            -0.11,
            1.13,
            -9.12,
            -7.75,
            1.58,
            7.76,
            -6.15,
            8.4,
            6.66,
            6.42,
            7.8,
            -1.26,
            11.5,
            3.49,
            3.27,
            -6.27,
            -11.75,
            4.84,
            -1.33,
            -10.67,
            -9.12,
            -6.13,
            9.41,
            9.88,
            -4.07,
            -4.43,
            12.41,
            5.52,
            11.91,
            4.3,
            -5.74,
            3.04,
            12.73,
            10.06,
            9.63,
            10.55,
            -10.47,
            4.29,
            -11.23,
            -9.72,
            -4.91,
            6.46,
            -10.57,
            8.6,
            9.81,
            4.6,
            9.5,
            -6.96,
            -9.18,
            13.49,
            2.84,
            -11.75,
            -5.86,
            -9.81,
            -8.54,
            4.09,
            9.68,
            4.7,
            -12.66,
            10.48,
            -10.11,
            11.21,
            -8.49,
            5.95,
            5.79,
            3.27,
            9.26,
            7.3,
            -11.96,
            13.22,
            4.25,
            -7.64,
            7.67,
            5.19,
            -9.62,
            -6.44,
            -9.62,
            5.7,
            -4.51,
            -4.4,
            -6.93,
            -5.34,
            -10.14,
            7.14,
            9.61,
            -4.43,
            -8.27,
            5.53,
            -11.41,
            -0.28,
            3.17,
            8.45,
            -2.75,
            7.84,
            2.27,
            -11.27,
            12.6
          ],
          "emotion": [
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "disgust",
            "sadness",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "sadness",
            "sadness",
            "joy",
            "neutral",
            "sadness",
            "surprise",
            "neutral",
            "neutral",
            "joy",
            "joy",
            "joy",
            "sadness",
            "neutral",
            "neutral",
            "joy",
            "surprise",
            "disgust",
            "neutral",
            "neutral",
            "sadness",
            "neutral",
            "neutral",
            "neutral",
            "surprise",
            "neutral",
            "neutral",
            "neutral",
            "surprise",
            "neutral",
            "sadness",
            "neutral",
            "neutral",
            "joy",
            "joy",
            "joy",
            "neutral",
            "joy",
            "joy",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "sadness",
            "joy",
            "sadness",
            "joy",
            "sadness",
            "neutral",
            "joy",
            "surprise",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "sadness",
            "neutral",
            "surprise",
            "neutral",
            "neutral",
            "surprise",
            "sadness",
            "surprise",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "sadness",
            "joy",
            "joy",
            "neutral",
            "neutral",
            "sadness",
            "sadness",
            "neutral",
            "joy",
            "joy",
            "disgust",
            "neutral",
            "neutral",
            "neutral",
            "joy",
            "sadness",
            "sadness",
            "joy",
            "neutral",
            "sadness",
            "sadness",
            "joy",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "sadness",
            "neutral",
            "joy",
            "sadness",
            "joy",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "sadness",
            "joy",
            "joy",
            "joy",
            "surprise",
            "neutral",
            "neutral",
            "sadness",
            "joy",
            "joy",
            "neutral",
            "sadness",
            "neutral",
            "sadness",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "surprise",
            "joy",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "joy",
            "joy",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "surprise",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "sadness",
            "disgust",
            "neutral",
            "joy",
            "sadness",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "disgust",
            "neutral",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "sadness",
            "neutral",
            "disgust",
            "joy",
            "sadness",
            "sadness",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "joy",
            "sadness",
            "sadness",
            "neutral",
            "neutral",
            "anger",
            "joy",
            "neutral",
            "neutral",
            "surprise",
            "joy",
            "sadness",
            "joy",
            "surprise",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "sadness",
            "joy",
            "surprise",
            "sadness",
            "joy",
            "surprise",
            "joy",
            "anger",
            "neutral",
            "neutral",
            "neutral",
            "surprise",
            "neutral",
            "sadness",
            "sadness",
            "sadness",
            "joy",
            "disgust",
            "neutral",
            "joy",
            "joy",
            "neutral",
            "joy",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "sadness",
            "joy",
            "neutral",
            "sadness",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "sadness",
            "disgust",
            "neutral",
            "joy",
            "sadness",
            "neutral",
            "sadness",
            "surprise",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "surprise",
            "neutral",
            "disgust",
            "neutral",
            "joy",
            "joy",
            "sadness",
            "joy",
            "neutral",
            "disgust",
            "neutral",
            "neutral",
            "neutral",
            "sadness",
            "neutral",
            "joy",
            "sadness",
            "neutral",
            "neutral",
            "sadness",
            "neutral",
            "neutral",
            "sadness",
            "joy",
            "joy",
            "joy",
            "joy",
            "neutral",
            "anger",
            "disgust",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "joy",
            "joy",
            "neutral",
            "joy",
            "sadness",
            "sadness",
            "joy",
            "neutral",
            "neutral",
            "surprise",
            "surprise",
            "sadness",
            "joy",
            "neutral",
            "joy",
            "surprise",
            "neutral",
            "surprise",
            "joy",
            "neutral",
            "joy",
            "sadness",
            "neutral",
            "sadness",
            "neutral",
            "disgust",
            "anger",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "surprise",
            "surprise",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "joy",
            "sadness",
            "joy",
            "surprise",
            "joy",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "surprise",
            "neutral",
            "sadness",
            "joy",
            "neutral",
            "surprise",
            "neutral",
            "anger",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "sadness",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "surprise",
            "joy",
            "sadness",
            "neutral",
            "neutral",
            "joy",
            "neutral",
            "joy",
            "joy",
            "joy",
            "neutral",
            "neutral",
            "joy",
            "joy",
            "joy",
            "sadness",
            "joy",
            "joy",
            "anger",
            "joy",
            "joy",
            "joy",
            "neutral",
            "surprise",
            "disgust",
            "neutral",
            "surprise",
            "neutral",
            "joy",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "neutral",
            "joy",
            "joy",
            "neutral",
            "neutral",
            "surprise",
            "neutral",
            "joy"
          ],
          "reviews": [
            "iPhone,Awesome",
            "Got Defective Product.,I got defective product, it has two dents on screen which are very small and process to return/refund initiating is very difficult, i need to visit the apple care for testing the product they found defect and gave written email in which they denied that we don't have any collab with these third party seller.",
            "Review,Security features",
            "Nice,Nice",
            "Iphone 14,Good product",
            "Good camera good performance,Camera and performance is superb but battery backup could have been better except tht its a good smartphone and good build quality",
            "Heating problem,1 hrs use krne pe bahut heat hota h charging me lgane pe v heat hota h",
            "Nice,Good phone 9",
            "Be care full when package received,I like the product very much",
            "Worst phone don't buy guys,In thus price range better to go for samsung s24 or ultra apple is remaking the same iphone Xr for years with some changes that's it its a loot businesss",
            "Loved it ❤️,Buying an iphone with my first salary is the dream i manifested it and it happened. I’m writing this review after 8 months. Camera quality everything is good. There is nothing to say about iphone the best always ❤️. But what i observed is after IOS 17 battery started to drain like for 2 days one percent is dropping after that it stopped.Now my battery health is 93%. This is the only concern with iphone remaining all aspects it is worth the money.",
            "Camera is pretty impressive,",
            "Performance is good but battery performance,I am using it from 18 January 2024 only in 2 and half months battery health is 99% showing😣",
            "Dimag,Dimag",
            "Review after 1 years,1) Display - 4/5 2) durability - 3/5 3) Battery -2/5 4) iphone11 > iphone6 > iPhone14 As we are addicted to apple we are using iPhone else no reason to buy this mobile",
            "Pushing the Boundaries of Innovation,The iPhone 14 marks another leap forward in Apple’s relentless pursuit of innovation and excellence. From its sleek design to its powerful performance and advanced features, this device sets a new standard for what a smartphone can be. Design: The iPhone 14 boasts a stunning design that seamlessly combines form and function. With its refined edges, smooth curves, and premium materials, it exudes elegance and sophistication. Apple continues to lead the industry in design innovation, and the iPhone 14 is a testament to their commitment to craftsmanship. Display: The display on the iPhone 14 is nothing short of breathtaking. Featuring a vibrant OLED panel with true blacks and rich colors, every image comes to life with stunning clarity and detail. Whether you’re streaming your favorite movies, browsing the web, or playing games, the display provides an immersive viewing experience like no other. Performance: Powered by Apple’s latest A-series chip, the iPhone 14 delivers unparalleled performance and efficiency. Apps launch instantly, multitasking is a breeze, and graphics-intensive games run smoothly without any lag or stutter. With improved battery life, you can stay connected and productive throughout the day without worrying about running out of power. Camera: The camera system on the iPhone 14 is a photographer’s dream. With advanced computational photography features and enhanced sensor technology, it captures stunning images with incredible detail and dynamic range. Whether you’re shooting in low light or capturing fast-moving subjects, the iPhone 14 ensures that every photo is a masterpiece. Features: The iPhone 14 is packed with a plethora of features designed to enhance your daily life. From Face ID for secure authentication to 5G connectivity for blazing-fast internet speeds, every aspect of the device is meticulously crafted to provide the ultimate user experience. And with iOS 16, you get access to a wide range of new features and improvements that further elevate the iPhone experience. Conclusion: In summary, the iPhone 14 is a triumph of design, engineering, and innovation. With its stunning design, breathtaking display, blazing-fast performance, and advanced features, it sets a new benchmark for what a smartphone can achieve. Whether you’re a tech enthusiast, a professional photographer, or a casual user, the iPhone 14 is sure to exceed your expectations and elevate your smartphone experience to new heights.",
            "Defective Piece,Fake seller, I got a defective iphone and it was really the toughest thing to get it return, so never buy any expensive electronics online, i learnt a lesson so recommending everyone to follow the same",
            "Used product,Used product",
            "Iphone,Recently bought this product phone is good but Battery 🔋 is not available.  I did not expect this kind of product",
            "Excellent product,Excellent product",
            "I love iPhone,Best",
            "Trust,As usual an iPhone as it has to be",
            "Apple product. That's all,Go with the flow. If you want to show off buy it. If you are an existing android customer never buy an apple product untill and unless u have security trust issues.",
            "Good,Like it",
            "Everything is good ,,No problem in this mobile 14.Also Quick service from Amazon thanks from Shailesh Nanavati",
            "Poor battery,Poor battery support and battery life. It decreases to 96% within 6 months of moderate usage. Battery can not support for 24 hours.",
            "Great buy,I don’t recommend to buy , iPhone because prices keeps on dropping buy this in sale only to get maximum benefit, I bought it for 70k now it is 53 k so loss…🥹",
            "Best purchase,Even though I was doubtful at first that I should buy iPhone online or not I made the decision to go for it on Amazon and frankly it was the best decision ever. Iphone is a complete gamechanger and the camera quality is so much better than any phone I have ever used.",
            "Good,No words",
            "Battery,Battery backup not good Finger print sensor needed",
            "Not valuable for money,Gets hanged in 3 months only what is this APPLE",
            "Worthy gift for better half,Bought the 256gb iPhone product RED. The color is striking and the phone is performing well. Best gift to better half for 10th anniversary!",
            "Superb,Superb phone",
            "Satisfied,Happy with the i phone 14",
            "Good,Very good product",
            "Elegance of iPhone,It’s really awesome when I switched from Android to iPhone then I realised why iPhone creates cult among its user !",
            "It Is looks old,It's looks old",
            "Value for money,Good",
            "Good camera,",
            "Awesome phone,I gifted this to my wife she was really happy to see this phone and the blue colour is Amazing",
            "Awesome product,Amazing product, it's a must buy u should pick it for sure, apple is a life style now, go for it for sure",
            "Faulty product,Faulty product received. It had calling issues, disturbances and cracking noises during calls that were so loud that other side was never able to hear calls.",
            "i Phone is always Excellent,Using from 5s to 7... Now this 14 is Superb ...unmatchable..",
            "Perfect,After using XR , this one is best",
            "happy with the phone but unhappy with Amazon and vendor,unhappy because no cost emi still charging gst + interest which was useless decision to buy the phone from the Amazon.",
            "Phone is very nice,Good performance",
            "Review,Battery charge is less",
            "Exchange value is unexpected low,Exchange value is farji thak h sabhi 34000 ka phone 10 mahine age inki rate 7700 laga rahe h thag h",
            "🍎 Name is enough,Just Wow, amazing product",
            "Good,Good",
            "Performance,Average phone",
            "iPhone 14,Good Phone",
            "Go for it,Camera is wow",
            "Value for money,What to write of an iPhone?? Best as always",
            "Don't buy i phone from online,I brought iPhone 14 from Amazon. After 6 days mobile shutdown. didn't switching on. And I went to apple service center. they had denied to replaced my phone. they forced me to repair my mobile. after that i I had contacted Amazon. They had  refunded my money but it took 1 months credited money in my account.",
            "Satisfactory purchase,Go for it",
            "Defective itam 😕,Defective product delivered",
            "Satisfied with the product received but has some negative opinion,I am completely happy with the product however the things which was unsatisfied is that it took more than a week to deliver even after paying in full before delivery and also the bill which was provided after opening was halfy printed as it appears to be half cutted may be printing error the main parts of billing information was not present I hope the next order will avoid any kind of error in future …",
            "good,great",
            "Delivered on time,Received in perfect condition",
            "Supr,Best All Time IOS",
            "Great product,Great product",
            "Apple Just Wow wow wow!,Awesome phone and Amazon only fulfilled my wish. Thank you for fulfilling my dream.",
            "Nokiya 3310,Accha per thika he hai bus thoda mahenga hai pe chalega lena to hai he nah bus mai Aya pe timepass kr raha hu merko samaj nhi aara tha ke kya kru to mai review likh diya Thanks 🙏🏻👍🏻",
            "👍,👍",
            "Good,Packing was good . It’s an iPhone so works well .",
            "Obviously worth it.,Switching from an android to an iPhone was one of the best decisions.",
            "Great buy at great price !,Great phone at an excellent price ....great performance.... excellent camera.. smooth high quality... wonderful..it's iPhone..... So it's enough said !!",
            "Excellent phone,Better than One Plus",
            "Best phone,Camera quality is awesome",
            "Emits heat and the battery drains !!!,The phone emits a lot of heat and the battery drains immediately --  I given return and i will try  Iphone 15",
            "Very happy,The blue colour looks amazing, very happy to purchase my 1st Iphone🥰",
            "Phone is not working,Recently took I phone 14 it’s not working now",
            "Good product,Best product ever used best of the best in the phone market worth it for the price  top class quality",
            "Delivery period too long,It is showing almost 24 - 33days to deliver it which is a lot of time , sadly I'm disappointed 😔",
            "Feels like a duplicate product,Not sure how to check authenticity of the product",
            "Loved with the colour,After using 4months the review Previously I have heard lot of rumours about the iPhone not to buy on sale but when I bought this it was completely game changer for me. Specially the camera quality and Siri does half of my work. I am happy with the purchase. Thank you Amazon for serving the best.",
            "Buttery smooth,Using iphone 14 for over a week now, its just buttery smooth as expected the display is so amazing and the animations are done so precisely that you will actually forget that this has 60hz display. In term of camera quality back camera is really good, I don’t like the selfie camera that much but i am not a selfie person so its fine with me. Battery is also good will give you upto 6-7hr backup",
            "Fantastic!.,The best thing about this phone is its long battery. With normal use it can go beyond 48 hrs.",
            "It's visually appealing and upgraded device, surpassing my old iPhone 12,Pros:   Good Looking (4/5): The Blue color variant adds to the aesthetic appeal, making the iPhone 14 an eye-catching device.   Better than iPhone 12 (4/5): The iPhone 14 exhibits improvements over the iPhone 12, contributing to an enhanced user experience.   Good Camera (4/5): The camera performance is commendable, capturing high-quality images and enhancing the overall photography experience. In summary, the Apple iPhone 14 in Blue is a solid choice, offering a sleek design, improved features compared to the iPhone 12, and a reliable camera for capturing memorable moments.",
            "Rahul,",
            "Very nice 👌,Nice mobile phone",
            "Good Phone,I switched from Android, and there is not any changes that I feel, performance is same , camera is same , charging is too bad than Android. I play games a lot. P.S :- Don't compare with Android of less than 30,000 rupees. I was user of Snapdragon Gen1+",
            "Heating Issue Sometimes,Faced the Heating issue many times . Rest is Good . Checked on Apple site Product is Original .",
            "A Small Chip On The Side Of My New Iphone,The Iphone that I have purchased has got a small  chip on the side of my iphone . This has kind of ruined the iphone experience for me... After paying 60k for a new phone, the least you do is to expect a phone with perfect conditions in all aspects … having said about this small physical blemish, the overall performance of the phone has been nothing short of phenomenal and spectacular .. iPhone truly is amazing and iconic",
            "Wonderful phone,This phone is a gem. Photo clarity is awesome. This is the phone to use for ages given now iPhone has moved to type c port, this is the last generation of lightning charger.",
            "Slowness,Slow",
            "Cheating with customer their replacement policy is fake,Last week buy iphone the camera was not working when request for replacement they completely denied and redirect to apple store but why you mentioned 7days replacement???????",
            "Don't Purchase Please,Purchased in 2023 now it has seen  colour fade slowly ...Service Centre and Apple Support teams does not take any responsibility for this manufacturing issues.. Suggesting all not purchased this one",
            "Uses,So beautiful,So elegant,just looking like a wow.Seriously you don’t have to read out all comments because it is apple.Everything is outstanding.Value for money depends on user.Otherwise no restriction,just go for it.",
            "Nice phone.. lovly,9,/10",
            "best,brand new condition  all ok but i face delavery problem but its ok phone is good pakaging all are good",
            "Good product,Nice",
            "It’s iPhone,Just a small phone you need for every day, work, entertainment and overall a good phone. iOS is one of the best systems overall in the market. Best display best battery best sound best design",
            "Definitely a must buy,Everything looks good",
            "The perfect one,Good product delivered on time",
            "Superb product,This is one of the finest product I have purchase. Amazon is just superb with their service. I has exchange with my smartphone they in fact not check my phone is their any damage or not simply exchange with my phone without a single question. Love u Amazon. Love u apple.",
            "Iconic phone,Features and robustness of the phone .",
            "Amezing,Just love it .. i fall in love with this iPhone model",
            "Quality of charging cable not good.,I don't recommend others to purchase this phone on online offers, they sell you in less price but the quality of accessories they give you with is phone is compromised. Charging get damaged within 6 months from purchase.",
            "It's soo smooth,The camera quality is just 🔥. The battery is also good.",
            "Excellent,On time delivery and smooth process",
            "best,best mobile phone",
            "Good phones battery issue,Battery issue",
            "Heating,The device is very good. I have only one problem and its the heating of the phone while charging and playing games. Overall its a good product in all aspects.",
            "Dream phone !,I wanted this phone since long ! Now I had it in offer !",
            "Very best iPhone,Camera quality is best Displace very smooth battery life is best giving one day sensor is very best hhvbb hvb",
            "Just an iphone,Back camera is nice Front camera is not upto mark 60hz display in arround 50k does hurt Performance wise owsome If you have budget then please go for 15 series",
            "Worst Calling Experience,Pathetic experience... Unable to hear any sound WhatsApp doesn't work, Facetime doesn't work, regular calling doesn't work. Waste of so much money in buying this useless device.",
            "After 1 year display not working,Display not working my phone is 1 year 3 month old & it display not working The phone was kept in charging & after some time display not working",
            "Genuine product love it,Everything is good Best phone ever",
            "Thiss product was so nice,iPhone products was veryy useful for everyone it was veryy bestt product everr",
            "Best phone,I am new user of iphone and the Best phone ever, luxurious look and premium quality, security and saftety are awesome.",
            "Worst experience… pls dont buy from Amazon,Its just 2 days and the device is overheating…. Amazon service is worst…. they routed me to Apple service centre instead of replacing the phone",
            "Really good phone,It's an absolute all rounder. I mean you know about apple right, it has never disappointed me this time neither",
            "Thankyou Apple ❤️🫶🏻,",
            "Good,As everyone knows it is very Good mobile, but how ever you use battery health percentage will keep decreasing, for me this only issue with iphones",
            "Satisfied,I am using it since January, and completely satisfied. No doubt on product originality from seller end. However facing some heating issue while continuous network usage.",
            "USB Data Cable,Mobile Phone is Okey but USB Data Cable not good as you provide inbox 👎",
            "Bekar Phone hai,Not worth it",
            "Good phone,Phone is absolutely good it hang only while it is hot overall display is very awosome and its very smooth while it charge at good speed",
            "Very nice product,Good product as expected with a very reasonable price",
            "Majha aagya,Waah yr mast phone hai",
            "Bad product,1Accereise missing",
            "iPhone 13 in 2024 still worth it,I bought it in 2024 and I'm really pleased with the updates from Apple. Appreciate it. Great product. Worth buying it.",
            "One of the best iPhones made,At this price point it's one of the best phones you can get! iOS is smooth as always and the camera setup as absolutely clinical. The downside tho is the minimal battery life but it can get you through an entire day.",
            "Perfect in every way,Perfect",
            "The beast!,Purchased it long time ago but this is my 2nd iphone 13. I bought this for my father. He is very happy",
            "Mobile heat and battery 93% just in 1 month,Mobile heat and battery 93% just in 1 month.. Kindly contact me how to change product",
            "iphone 14 is batter than this,All version of iphone is batter than older version so it's creat confusion between the customer that which one is batter",
            "very poor quality,the phone has serious network issues... with high speed 5g there is very slow internet but the same sim gives wonderful performance and network connectivity on other phone",
            "Ok,Good one",
            "Camera & performance,Great quality in wide angle and potrait mode no matter in temperature device although works normally. I like the build quality.",
            "Screen white,Using  continuously  2 year and after updated screen is white facing problem and not working  service centre is delhi and away from my home town .",
            "Fantastic Upgrade,I recently upgraded to the iPhone 13, and I couldn't be happier! The sleek design, stunning display, and lightning-fast performance make it a standout device. The camera quality is exceptional, capturing every moment with clarity and precision.",
            "A Good Product,A Good Product with a Good quality",
            "Delivered safely,Not mentioning product features because everyone can read it. This is the highest value item I purchased on Amazon and kudos for safe and timely delivery.",
            "Do I need to say something? Its apple at it's best..  Happy!,Great product.. I love android and apple both, both have different characters I see. When it comes to iphone 13, I love the camera( great pictures), sound(like a surround sound), software, quality, smoothness etc it offers and with style and premiumness. It's not only about the style but really and honestly, overall the product is great. One should use it and realize how great and satisfying this brand and product is.. Great brand.. Go fot it if you could, you'll not regret..",
            "Device heating,It’s tooooo much heating in normal usage only….. I think this piece have some default because my friend also have same but not heated too early can my iPhone can be replace by new one.",
            "Totally disagree,Okay",
            "Too much heating battery health decrease very fast camera is also not good,Bahut zada hang ho raha battery health bhi kam ho raha bahut jaldi mai suggest karunga aap iPhone 14 buy karo",
            "ok,ok",
            "Good,Good one original product",
            "Good,Feature are good ,colour is not according to. Me",
            "So far so good,Writing this review after using the phone for 5 months. Pros - camera clicks amazing pictures, video recording is the best I've seen in a phone so far compared to my previous phones. Stable videos with no shaking - battery life is good. Lasts an entire day with medium use. I don't game on the phone. Charging is as quick as it is with phones that use USB C. - display is soo good. So bright - built is solid, dropped phone a couple of times once with the cover and once without and not even a scratch. - listening to music and watching videos is a hot cos of how good the speakers r. Crystal clear with the right amount of bass and treble. Cons - phone is a tad heavy and using it for hrs on a stretch can result in pain in the wrist or fingers Got the phone in Diwali sale on discount so bang for buck if u ask me",
            "I phone,I love it",
            "camera,Iphone 13 was good but after using 3 to 4 month it start heating. Camera quality is good even better than phone 15( I personally feel that).",
            "Mind blowing,Phone is absolutely amazing",
            "iPhone 13,Heating problems… jab bhi phone open karta hu heat karne lagta he … bekaar he ye phone",
            "Amazing,",
            "No-nonsense Apple.,I have gotten an iPhone 13 256 GB version for 58000 INR (No cost EMI). This is not my first iPhone, my mom gave me her used iPhone 4 many years ago back in 2014. I purchased it because I had a nice experience with my previous phone, and also felt that I wanted to try a fundamentally different smartphone experience. I've flashed custom ROMs on Androids, the works, but felt that I was tired and needed something different. I also had the perception of iPhones being well-made, no-nonsense phones and this was something I wanted to experience and see what it was like. Anyways, here are my impressions: Pros 1. The phone isn’t too difficult for me to use. Maybe it’s because I owned one long time ago and also because I was using an iPad. 2. I love how iPhones end up having the most timeless designs. The phone feels beautiful to hold and use with its premium glass back and lovely ergonomics. Volume Button placement is very awkward but I can get used to it. 3. I love the fact that you have a physical silent mode switch on the side. I thought this was something that was phased out and was quite surprised that it wasn't the case. 4. The phone feels very nicely optimized. The UI and the customization features enable you to have a good smartphone experience. There's no lag. 5. The camera quality is amazing. The photos this phone takes are beautiful. Even randomly clicked pictures are amazing. 6. Aside from one major issue which I faced, there was not a major paradigm shift moving from Android to Apple. Cons 1. Transferring WhatsApp from Android to iOS is a pain in the neck. I really wish apple didn’t have these weird walls preventing a seamless transfer of chat history to happen. I managed to do it but it took an unnecessarily long amount of time. 2. I think that moving from android to iPhone there are some thing you're going to miss. I for starters immediately wanted to customize the keyboard size to suit my larger hands. I was not able to do this sadly. Same goes for the lack of the back button - though swiping back works 99% of the time. 3. There were a few minor bugs in the phone. The keyboard would randomly swipe down for no reason. The text cursor would weirdly blink occasionally when typing. 4. The keyboard took some time to get used to. I was not very happy with that side of the experience. I was expecting it to be much better. Verdict As someone who moved away from Android to an iPhone, I'm happy to have made the switch. I wasn't expecting the experience to be this good honestly. I personally made the switch to an iPhone becuase I wanted a fundamentally different smartphone experience than what Android offers, and also to see what the other side of the pond looks like. Would I say that I'm satisfied? Hell yes. However, I would also think that while slightly different from a well polished Android, there doesn't seem to be much about it that makes it too different. From a functional perspective at the end of the day, you are using a phone, and ultimately an iPhone and an Android can do the same exact things without much issue. This is not to say that Apple phones are bad or Android phones are different or anything, rather from a functional perspective there isn't much of a difference. I purchased this device for an inflated price of 58k for the 256 GB model. I think that I've gotten my money's worth, given what I was looking for when I made the purchase. But does this necessarily count for everyone? I don't think so. The iPhone is an excellent, well-polished, no-nonsense phone, but there are many folks who would be okay forgoing some of that because all those traits that make an iPhone great come at a steep cost. An Android phone at 30k would lack the novel iOS experience and maybe 70% of the above traits, but for 30k you saved you can take your spouse/significant other out for a good meal, buy some shares on the stock market, maybe pay your rent, and order a decent pair of earphones to go along with your phone. You don't get the above things as well as the status symbol perks you get with an iPhone, but you do get peace of mind. So ultimately, would I recommend this device? Objectively yes. It is an excellent device. The best device I've ever used is the OnePlus 7, and I'm not joking when I say that this phone comes close. But at the same time, from a functional perspective, it doesn't make sense at this price point. It's just a smartphone at the end of the day. A damn good one yes, but it is a smartphone. My point being, Unless you have a massive reason to switch to an iPhone and are also able to completely afford it, switching doesn't make too much sense. So the phone is a good phone, but outside of the above parameters I honestly don't think there's a strong enough reason for anyone should buy it. So unless you can afford it, don't run around taking long EMIs for this device, even if it is an excellent product.",
            "Great,No words about the product as it's good and lovely since Apple is a very  branded and loved brand all over the world",
            "Value for money,I phone 13 is excellent value for money. Sturdy hardware, stable OS. Excellent camera. Battery could have been more. Overall fully satisfied.",
            "Good product,Good product",
            "Amazon failed in customer service,Within 6 months of purchase when I first time put the vibration motor it’s not working. Requested Amazon for replacement, they denied.   Recommend to buy apple product from apple stores",
            "Worst phone,Waste of money pls go for Samsung or any other better hardware better than I phone orcgo for latest version of iphone",
            "Good,Product was good...but disappointed is that apple company provid the charger also in box.",
            "Good,Good without any issues.",
            "Happy purchase,Happy using iphone",
            "Very good quality,Display are superb and processing speed are really very fast",
            "Nice,",
            "Best phone in this budget,I recently buy this product and I was amazed with its camera quality and over all working",
            "Nothing special,What do you want to hear about iPhone,if you are reading this review,it means that you have already done enough research to buy it.so, congratulations for your new iphone🎉",
            "Mengha,Hadd se jaada mengha hai iPhone 15 72 ne mil jata hai kharid lo kuch orrr ye nahi.  Ok th",
            "Beautiful,",
            "Everything is awesome,I think this a great phone I have ever seen",
            "Very bad,Data cable tuti hui nikli",
            "Thank you amazon,Great product",
            "Best price,In good condition my new iPhone is absolutely delivered safely",
            "It never lags .,The big difference between ios and android is that ios never lags , it feels so smooth , and voice control , gesture control , custom commands so manny things are there . And obviously camera quality is also good .",
            "Very good,Very nice",
            "Battery drain fast,Twise a day charging",
            "Value for money😊Happy with it,",
            "Good,Value for money",
            "Iphone,Do I need to write a review for iPhone ? People still gonna buy it anyway. Little bit disappointed from macro lens otherwise who criticize Apple.",
            "Always a king,Best experience in using when compared to android. Camera audio quality is always a top.",
            "Awesome,So beautiful so elegant just looking like a wow",
            "Delivery made within the time,Nice product",
            "Effortlessly sleek and powerful,Overall, the iPhone 14 Plus is a masterpiece of engineering and design, combining cutting-edge technology with unparalleled craftsmanship. From its gorgeous display to its powerful performance and advanced camera system, this device sets a new standard for what a smartphone can be. If you're looking for the ultimate mobile experience, look no further than the iPhone 14 Plus.",
            "Genuine product,Packaging and delivery experience was good Gifted to someone one he is happy",
            "Sahi hai,Sahi hai",
            "Best for Battery Screen size and Camera in this price,This is my first iPhone experience and I loved using this. Camera quality is decent and big screen size fullfills my content consumption demand. Battery backup is also great. It is smooth in use.",
            "Wow,Very good nice upgradation from 13 to 14 All r good Battery life very good Camera is excellent Design is excellent",
            "Camera 📸 beautiful,Battery is fast down but phone is most accessories and I'm very happy I like it  iPhone 15 🔥🔥  bahut accha h You buy this",
            "iPhone is iPhone always,",
            "Iphone review,Very good quality n safely delivered",
            "Overall Good,The phone is good the size of the phone for those who want a sleek one is too big and heavy meanwhile the performance of the phone is good except sometime the Face ID takes time to open.",
            "Value for money,Product is good as it described in its details. Happy to have it in such a low price.",
            "Rate this iPhone 14 camera,",
            "Slowly downloaded processor’s comparison is disappointment,Very slow compared in one 12 download speed separate apps very very death slow one plus 12 is worth for iPhone  only build quality is satisfied but overall 16 gb ram snapdragon gen 3 processor android 14 version so much better in one plus 12",
            "Worst timing in the entire history of gaming,This is the worst mobile, i have bought it for 80000 rupees but it gave notification at the most important time. I almost did 1vs4 in BGMI. Only 1 noob player was standing at that time a notifica came. This hulululu mobile is just a piece of trash",
            "Camera,Simple saying awsm no comparison",
            "Nice,Simply awesome",
            "Don’t bey,Not good phone hanging issu.over Hiting .Microphone properly not working. Overall android good. Bey Oneplus 11r.nothing 2",
            "Excellent,Its really a goodone Excellent Battery performance Every thing ok But at the beginning it seems larger than others with 6.7 screen in course of time i felt its ok now",
            "Good,Good and delivered before time as well",
            "iPhone14 plus,Very good product, Go ahead and take it",
            "After one month heating,Apple product one month after heavy heating. One of the brand mobile. But high cost price Please use that much amount  good think others uses.",
            "Good Phone,Very good phone",
            "Premium gadgets,Excellent Phone",
            "Ok,Ok good",
            "Apple is apple,Good",
            "Nice product, nice battery backup…camera obviously cool.,Product packaging was too bad. Should improve and give proper wraps for products like this.",
            "I got in very good price on amazon.,",
            "Fantastic phone,Original I phone",
            "Chapri Pooki,",
            "best,My first iphone . I loved it. Impressed with the battery life. very smooth to handle. overall superb phone",
            "Camera quality best hai,",
            "iPhone 14 plus,Great phone",
            "what for every penny. 🤝,what for every penny. 🤝",
            "Mobile is hang and slow ,very poor performance ,don't buy it 14 +,,Waste of my money, i am playing pubg but very hang and slow  porpamans, please don't buy this is mobile, i was cheated Amazon",
            "Awesome,Writing this after 7 months, go for it",
            "Goood,Goood",
            "Thanks to amazon,Happy with my phone, delivery safe, original phone, good price, thanks to amazon",
            "Touch problem,Phone screen touch not working properly Very slow touch",
            "first iphone,android is far better in user experience . waste of money after few days of usage still waste of money",
            "Iphone 14 plus,",
            "Very good,Everything is too good.",
            "Hang,Phone hanging",
            "After sale service,I ordered this phone in July, 2023. The delivery was fine. It also started working as it should. But the charger stopped working about ten days ago. The phone itself stopped working yesterday. Having ordered it from Amazon, I do not know how to go about complaint about it or even requesting for customer support. Had I purchased from an Apple Store , I could have at least taken it up with them. Any solutions possible? Subramanian",
            "Apple catalog completed,I have all the apple products except for the iPhone. This is my first iPhone after sticking to android for 12 years. Main reason was for battery and I give full marks to apple for optimisation Soft ware and hardware complement each other. I know most of them debate android vs apple, my opinion is that apple maintains consistency and keeps on optimising its OS and also has clear vision on privacy I’m happy overall",
            "Waste of money, not value for money,Good quality & performance, but not value for money",
            "Kidney,The iPhone is very good but my left side of abdomen is hurting after I sold the kidney. Nice iPhone by the way. 🙂",
            "Hats off to Apple. The 14 Plus - a class apart phone.,Its a big myth that Android phone are better than iPhone. I was with samsung flag ship mobile previously and Samsung never come even close to iPhone in any aspect. After saying this, there is no need to discuss any other android phones in the market. You only understand this beauty only once you use it. Go for it. The battery life is outstanding. The display, look and feel and the seem less fluidic way of its presence is immaculate. The 14 Plus - a class apart phone.",
            "Vhjjjjbcgh,",
            "Product problem,This mobile is in internally problem but company said, this is not part of our warranty. Very bed experience. Hate this online shopping.",
            ",good phone , value for money and best battery life.camera is perfect. camera is perfect.camera is perfect. camera is perfect.camera is perfect.😊",
            "Good buy,Good buy",
            "Extremely bad experience,Most of the apps hang very often. I have to either delete and reinstall the apps or switch off the phone and restart Battery life is extremely short The handset becomes hot if I use it continuously for 5 minutes",
            "iPhone is iPhone,What expected received and price better in Amazon",
            "I am “Yellower”,Love this version of iPhone 14. Magnificent colour on such a classy phone🤞 I love using it for the last 6 months🤩",
            "Phone not working, display/touch not working, purchased two days back only.,Phone not working, display/touch not working, purchased two days back only",
            "iPhone 14 Plus review,It such a nice phone I am using that phone since las one month and battery backup is such better that other android phones and graphics and video quality is much better such nice phone in 70 k …no compare with any other phone",
            "Network  port issue,Service centre says pay 15k for this issue.. it's not even 5 months we got this  paying so much",
            "Apple is a proven product..,Good product",
            "Iphone 14plus,Front Camera very poor",
            "Original product,The original iPhone product received as expected.",
            "good,they give original products too good u can trust them",
            "Worse camer system,The images clicked through from camera does not looks up to the mark and picture comes like a 15k phone . I really disappointed by the worest camera system of 14 plus model.",
            "I phone,It's awesome",
            "Original product,Amazing experience.. delivered on time very next day I ordered.. original product.. Thankyou Amazon.",
            "EXTREMELY BAD BATTERY. DO NOT PURCHASE,Have used this product for about 11 months now. Battery performance starts sinking from the 9th month. Now at 100% charge and normal daily office use ( WhatsApp / LinkedIn / Mails / Calls / minimal photography / almost no videos ) battery lasts from 9 am to 6 pm at 100% charge. Apple service centre says battery good upto 500 charges. Assuming 1 charge a day, you may need to replace battery at a cost of approx Rs 7000/- after a little more than one year use. Need to carry a charge bank with you if using heavily with photo and videos. Not worth Rs 80k. Avoid purchase.",
            "Original,Great product and long life battery value for money 💰",
            "Apple operating system so primitive..,I don’t know why Apple phones are a craze..Notifications panel is a khichadi no organisation of messages like android.Phone app is so old ..no gallery and file manager integration call drops are frequent.if u use camera for long or heavy use it heats pretty well as well as on charging. Only battery back up is great along with video recording.Android is so advanced in most aspects.Truecaller doesn’t work have to pick all calls. wi if ko settings so jakar he off kar sakte ho..Spending so much money on it is waste..",
            "I phone 14 plus is India variant or global,I love the mobile Camera battery lovo love love love love love love love love love love love love love",
            "Selling defective products,Seems seller is intentionally selling defective iPhone products at premium prices. Don’t buy. Everything is wrong on this platform…. Not Satisfied.",
            "Amazing Game Performance,Best Gaming phone, no one can beat",
            "Awesome battery really what an iPhone needs,Best one go for it, used for 2 months",
            "Wonderful,Best",
            "Battery backup,Bro battery gets exhausted so fast. Just half and hour back it was 56% now it is 42% What is wrong?",
            "Great,Best experience",
            "Very bad experience,Mobile using my wife network issue continues.. and also rear camera photo not  up to mark  Don't online  get",
            "Waste,Am not satisfied fr dis product. This is my first experience f dis iphone. Totally wasted my money to buy this product. Overheating is the main prblm and this ph is stuck when i using... Don't buy this waste product. Samsung and OnePlus is far far better than to compare with iphone 14 👎",
            "Rs 10k Android phone is better than this product,Overheating issue.. Don't buy this product please.. If anybody really love to lost 77k than go for this rubbsih.. Camera doesn't match up to even Android phone cost 10k Pathetic experience..",
            "Best iPhone and best shopping app. Guaranteed brand new iPhone,Original iPhone delivered. You can order with out any doubt. Even got replacement offer if received defective or faulty product. Thank you Amazon I am happy",
            "Average,Heating",
            "Awesome product,Good Thks Flipkart",
            "usual apple Q,stunning battery life - so far the best ever. rest is usual apple quality.",
            "Smooth Transition to iPhone 14 Plus,I recently made the switch from Android to the iPhone 14 Plus, and it has been a remarkably smooth transition. Here are some key points about my experience: 1. Seamless Setup: Setting up my new iPhone was a breeze. Apple's migration tool effortlessly transferred all my contacts, photos, and apps from my Android device. It was a stress-free process that ensured I didn't lose any important data. 2. Intuitive User Interface: The iOS interface on the iPhone 14 Plus is incredibly user-friendly. Navigating through the device, customizing settings, and finding apps is straightforward, even for someone who was accustomed to Android. 3. Performance: The iPhone 14 Plus packs a powerful punch. The device runs smoothly, and apps load quickly. Multitasking is a breeze, thanks to the robust hardware and optimized software. 4. Display: The OLED display on the iPhone 14 Plus is stunning. Colors are vibrant, and the screen is sharp and clear. It's a joy to use for watching videos, browsing, and gaming. 5. Camera: The camera quality on the iPhone 14 Plus is exceptional. The photos and videos captured are rich in detail and clarity. The advanced camera features and modes provide ample opportunities for creativity. 6. App Ecosystem: The App Store offers a vast selection of high-quality apps that enhance the iPhone experience. I found all my favorite Android apps and discovered some excellent iOS exclusives. 7. Privacy and Security: Apple's commitment to user privacy and security is evident. Features like App Tracking Transparency and Face ID add an extra layer of protection. 8. Battery Life: The battery life on the iPhone 14 Plus is impressive. I can comfortably go through a day of heavy usage without worrying about running out of power. In conclusion, my transition from Android to the iPhone 14 Plus has been a positive one. The device offers a premium experience with a top-notch camera, excellent performance, and an ecosystem that keeps everything well-integrated. If you're considering the switch, I highly recommend it for a seamless and satisfying smartphone experience.",
            "Battery is good,Battery is long lasting",
            "colour,excellent",
            "Beast Iphone,I love the powerful battery",
            "The Mobile is Good,Dear Sir we received the box and when I open that the charger plug not in the box Please send the charger plug",
            "Best phone ever,Battery is the best.",
            "Worst mobile,It has many bugs problem I’m going to service center they just clear bugs and after some day it start many problem again and Again now they said mobile Bangalore bhejna padega 20-25 dino ke liye",
            "Nice,A1 product",
            "Camera lenses damage,Had camera issue in 6 days of purchase without any physical damage",
            "IPHONE 15 is good upgrade from 12.,1. Good display - • Peak brightness is good and good visibility even in broad day light. • Clarity of the picture is good. 2. Excellent camera update - • Portrait mode pictures are great. • Resolution of the picture has improved and can see more details. 3. Dynamic island - • As a first time experience, it is exiting to see a separated put notch hanging and videos playing around it. Gotta see its uses in long run. 4. USB - C • Gives us option to use other android chargers when needed. Great relief for apple users. Don’t have to be extra careful while packing :-P 5. Colour - i bought it for my wife and pink colour was perfect. Note: This review is considering my previous phone was iphone 12.",
            "Very good product I liked it so much best phone ever,Value for money everybody should purchase this  (If you are rich enough)😂😂😎😎😎😎😎😎😎😎😎😎😎 performance is also very very good purchase it mann",
            "Heating machine,There could hardly be a more hardcore Apple bhakt than me, but I am disappointed. This phone while being an absolute beauty is unfortunatey a heating machine. DISAPPOINTED.",
            "Does it’s job :D,I switched from android to iOS but the entire process was really smooth, good batt life as of 3 months old, still lasts entire day.",
            "The device I almost lost within a week.,I had an interesting experience with the new model. The corners are noticeably curvier compared to the previous version, making the device sleeker. Unfortunately, the phone slipped out of my pant pocket while I was in an auto, and I only noticed after returning home. I quickly grabbed my iPad, locked my device, and used the ‘Find My’ app to track down my phone. Thankfully, it ended up in the hands of someone who wasn’t very tech-savvy and couldn’t figure out how to turn it off using the key combination. This allowed me to successfully locate and retrieve my device. Overall, it was quite an adventure. Now I slapped a rubber case on it and it’s not going anywhere.",
            "Nice,Very good looking this phone 📱 Display resolution fantastic Value for money Thanks Apple   And Thanks Amazon   Superb   Looking good",
            "Expensive phone,It is literally just a phone with an Apple logo on it. My sister forced me to buy this otherwise I would have bought poco 😂",
            "Very good product,Overall very good product, specially long lasting battery, image & video quality, display quality are very clear.",
            "PHONE HEATING WITHIN MINUTES OF USE,We have brought Apple i phone, in hope to get a good phone after spending heavy money it,s great disappointment that the phone is heating up heavily even for 02 minutes of use,the battery dried up automatically when idle with in one hour.Such defective piece apple and amazon are selling after taking high prices,great disappointment. Now after purchase we have to run to service center to repair brand new phone.. Misery of the situation.",
            "Overall good,Heating issues",
            "Great buy,Excellent product",
            "Good,I am using before 14 pro max it was better than this also 13 series used it was also good",
            "eSIM,eSIM not working, what I do now. Very disappointed.",
            "Just for Show off in Indian market,Iphone in indian market is a closed box. Just for status quo, it offers nothing. I had to sell it off at loss and bought samsung. No customizations, no true caller, all it offers is security but at what cost ? ? After using it for 10 days i felt i have traversed back in time to year 2000 - you will have to pay for everything, even for a simple ringtone. If you have been android user from long time, i would suggest never switch to ios, you will hate it after all phone is our daily companion these days.",
            "Phone have heating problems,Phone is not good camera and heating problem",
            "Heating Issue,My iphone is having very much heating issue. It will suddenly start heating up, have to remove back cover to make it cool down. Camera is also not that good rest things are fine",
            "Scratch,Scratch on a new phone",
            "My Honest review,",
            "Amazing Phone,It was a pleasure to walk around. The camera is also good.",
            "Heating issues,We are paying huge amount to buy iPhone but they are not coming up with innovative solutions control device heating, device heats up massively, sometimes I feels holding a nuclear plant in hand,",
            "camera mind blowing........,camera mind blowing",
            "This is iphone yes I know,Best iphone in cheap price",
            "Worst iPhone till day,iPhone has been worst now, their customer service is also pathetic. It is time to leave their ecosystem. Worst experience",
            "Heating Issue,Facing heating issues. Camera quality is not impressive. Device getting heated up too much for just 5 minutes of photo session.",
            "It’s Fantastic,I’m glad I’m back to using iPhone again.",
            "Geniune product,There are pros and cons to this model, but i am satisfied.",
            "transfer from android issue,I am trying to transfer data from android phone to iphone and following the instruction given but it is not complete and giving troubles.",
            "Refurbished,Received a refurbished phone in the place of new phone",
            "Unsatisfied with the Heating issue.,Overall it's okay except the heating issue. Device got automatically heated up after watching a video at high quality.I hope apple will fix it in upcoming updates.",
            "Worst phone ever 71 thousand trash,This phone is worse very poor all phones of apple are trash this is the worst phone ever nokia is better that it",
            "Apple,Bhut hi khrab phone hai bhai koi mat lena",
            "Bekar,Eak no ka bekar phone hai. PTA nhi Maine Kyu buy kiya, heat krta hai, camera quality to Eakdm bekar hai",
            "Nice,Like all other iPhones with few new features.",
            "Good phone,Phone is good. But Charging cable became faulty in few days only. Hope it will be replaced",
            "For all things,Good quality of photos and videos. Quality  of voice calling is good battery backup is good for normal phone user time over all my first this is my first I phone",
            "Works,I had an Iphone 12 and I switched to iphone 15. Honesty I do not feel any difference and does feels like holding the same device.  Dimensions are a bit sleeker this time.  Major camera improvements and the island is actually useful untill noticed.  I had options to buy s24 or this. I need consistency in life. I love the purchase . I still has the top 5 cameras compared to smartphones.",
            "No heating,Koi heating issue ni hota even mere pass I phone 14 b h shuru me hua tha wo heat or wo b sirf chrging k time pr ab to wo b ni hota ek dum Thk h mze me lo",
            "Worth buying,Awesome phone with awesome features. Specifically in love with photo and video quality of camera. Battery back up is decent so far used. Let’s see how many years battery lasts with optimal performance. User interface is far better than previous models. Value for money.",
            "This is an excellent product from Apple!,It beats all the other Android flagships in the market hands down. Go for it if you're looking for a long lasting and reliable product.",
            "Not charging within 15 days of buying,Not charging within 15 days of buying.",
            "Just hype,The device has heating issues has not much to offer when compared to its predecessors. It's just ornamental upgrade",
            "Excellent,Good product",
            "Heating,Without use kiye hi phone heat hota rhta h Battery b kb ud jari kuch pta ni chl ra itna gnda experience rhe ga I phone ka to mein kbhi na leti.. am disappoint 😠😡",
            "Great phone,Got great deal",
            "It's works very well,It's a good product",
            "Got a brand new phone loved ir,Ordered iphone today. Loved the Amazon service. The model number started with an M and battery capacity was at 100%. Loved the color",
            "Good,Purchased iphone 15 from store, its worth the price as i have upgraded it from iphone 11..the camera has major improvement than its previous model",
            "Simply awesome go for it,",
            "Packaging and product,Worst package from Amazon,  iPhone 15 has heating issue",
            "Almost perfect,Everything is better than my iPhone 12 except cell reception which is way worse here",
            "Has its pros, has its cons.,A decent premium smartphone, could've been a banger but cuts few of the most important things, hence lacking it's full potential.",
            "I switched from 13 to 15,I was using iPhone 13 and switching to 15 was a good choice I guess! The phone have  better camera than 13 as the lens are bigger with more megapixels also the Dynamic Island makes it more fun and engaging and the gaming experience is pretty smooth and amazing as it’s having iPhone 14 Pro Max chipset.",
            "Nice phone,Nice",
            "Iphone 15,All experience is nice only issue with battery and heating  otherwise very nice performance and clean using experience and best performance",
            "iPhone 15 is a value for money phone for those whose budget is between 70k and 80k,Got this at 71k from Unicorn store. Previously, I have used XS Max and 12. Apart from iPhone 15, I am also using iPhone 14 Pro. I would say that all the reviews here are not totally true. Charge heating issues have been resolved, and the phone works totally fine. I would recommend this to people with budget upto 80k. USB C is a plus point.",
            "Night pics are awesome,",
            "Overhyped I would say,Initially happy on starting that I finally owned iphone that too latest model. I know price to feature ratio is low, but still chose this as every one said there will be no lag in playing bgmi or pubg. But in reality, there are frame drops even on basic settings. Probably optimization issue but still, we paid hefty price. New update: Bought honor 90(12gb ram, 512gb memory) for my dad at 22k and it is faaar superior to this, be it camera, performance, screen, Ram management or storage. It's curved screen with higher level of brightness and smoothness kicks the iphone out. Only plus is iphones dual speakers. Don't purchase blindly. Mainly if you are some one coming from Android. You have to pay hefty for supported gadgets too. Think thrice before purchase.",
            "good phone,good phone being using it for a while maybe i will go for the pro max one for better batttery life but its a nice phone to",
            "Good buy,The temperature of the phone is getting higher after using it for mire than 15-20 mints. But the heat is not 'out of expectation' level. Good phone.",
            "Go for it,This iPhone is amazing for office or just simple casual use. It offers a lot of new features like the  Dynamic Island. It is on the 14 pro and pro max models but now available on regular versions. In my opinion, it is perfect for its cost. No heating problems from my side. Thanks.",
            "Battery health not good,I bought this phone in Nov 2023. Within 3 months, battery maximum capacity reduced to 98%. I am really unhappy with the product.",
            "WhatsApp chat a problem,I am sorry to write this but it is required to know that iPhone does not allow the WhatsApp chat history to transfer into it from Android. It is a sad part.",
            "Good product,Wonderful product with good features. Worth to buy.",
            "Please check and take,I recieved a used iPhone the box was already unboxed and not sealed and there were minor scratches on the screen as well as back please check serial number and verify it on Apple website",
            "Picture Quality is good.,",
            "Good,Woooooooow very bootyful camera phone with no use dandia island and bery very dangerous processor phone only for risthedaro ki gand jalane lai liye",
            "Genuine device delivered as expected and on time!,Genuine device delivered as expected and on time! This was a surprise gift to my brother and he surprisingly loved it.. ❤️",
            "Value for MOney,value for money invested is not worth with minor cosmetic changes and very basic memory upgrade",
            "Recommended,Recommended for those who are obsessed with Apple products. I'm not. Bought it for my wife. She is happy, so am I.",
            "Nice phone,Every thing is good camera display software all is good",
            "good to buy,very happy to buy after moving android to iphone . Camera is goood and perfomance also good battery life is also good.",
            "Perfect,Amazing. it came fast Super happy with my purchase And the customer support is perfect. Highly recommended and the phone came in a factory packed condition",
            "Money wasted,Don't buy this phone, go for samsung instead will give overall good experience. Samsung S24or S23 is sufficient for daily media consumption and photography",
            "Good phone But heating issues,Hi… I ordered new IPhone and received it yesterday… heating a lot ..while transferring files from old phone",
            "Always Good,Amazing and Cute",
            "Awesome phone,The perfect phone now with hassle-free Type C charging. The camera is outstanding. Performance - A16 bionic is a booster, and Dynamic Island is soothing to the eye. Also, it's so smooth that it never feels like a 60 Herts refresh rate. Thats it.",
            "This is called Apple,One word. Awesome 👌",
            "Hardware crash and poor after sales,The iPhone 15 hardware (mid system) failed after 2 weeks. I went to the service center they are repairing the phone from last 1 week but not replacing it with a new one. Poor quality phone hardware and overall bad apple service experience. Not recommend!",
            "Worth the hype,I had Samsung Note 2 for 3 years. Then S7 for 4 years. Finally Mi11X for 2 years. Familiar with Galaxy S23 and other similar phones Android was a beast. But I was bored. Confused btw iphone 15 plus and 14 pro max. Pro: Light weight Best Music output(on Bluetooth) Call quality is awesome Clean UI(it’s simple and focused) Very Customisable, The UI is 🔥 Decent photography for daily stuffs Smooth and snappy All my data backed up seamlessly. Transition was hassle free Streaming is awesome. Battery goes on for 2 days. Cons: The keyboard is confusing. I am struggling to type. I need to get used to it. Over-Priced Camera could have be better. I miss the Galaxy Pro options. I feel the phone is bit overpriced. Love using it. Wanna hold it for another 4 years.",
            "Best mobile,A really good phone better than samsung s24 in terms of performance and camera do buy this you will never fell regret",
            "Poor front cam quality,Poor front cam quality",
            "Camera quality,Camera quality, very bad night photos green symbol for photos. So please request waste of money….! I phone 15 night photos",
            "Worst,Worst phone , the phone is hanging , and heating issues not worth to the amount , don’t buy it",
            "Worst experience,Don’t buy this device from here.",
            "Best camera,",
            "This is my dream,What a phone i loved it send it fast I egarly waiting for this opportunity go god I am so happy to share this",
            "Loved it!!,Perfect product, Value for money.",
            "Worthy,Dianamic island makes this phone special than Iphone 14. price is same as 14 but this island make us feel like pro. Battery life is also good, we can use mobile up to 48 hrs in single charge.",
            "Best phone,",
            "best phone i ever used,best phone i ever used",
            "Best for an average user.,Go for this without a doubt instead of the 14 pro or previous ones. The camera is really the better one than all the previous versions. If you’re willing to give up on Always On Display, High Refresh Rates (iOS is optimised and you won’t feel any difference if you’ve never used a phone with high refresh rates.) and a Macro Lens then this is the one. The feel in hand is also amazing, you wouldn’t know unless you’ve held one. Type c is also a game-changer than all the previous versions.",
            "CAMERA,CAMERA NOT WORKING WITH IN 4-5 MONTHS",
            "Fantastic,One of the best iPhone ever…❤️",
            "Camera and battery and performance,Best in business.",
            "Excellent choice in the 15 lineup,It's been almost 3 months I have been using the 15 plus. It works flawlessly. The battery works for almost 1.5 days with regular usage(Better than the 15 Pro Max). Only the drawback of this phone is its 60hz display, if you are a casual gamer then you might not find any difference, but if you are a hardcore (full-time gamer) then I suggest you go for the Pro variants.",
            "Amazing,Value for money",
            "Quick delivery ,,All as expected",
            "Best mobile,The great mobile with amazing features, build quality is so good, amazing camera with stunning pictures. Good battery life,good performance.",
            "Super,Need the link to get it for ₹1,amazing.camera Quality is very good Good,value for money costly suggest able Follow it",
            "Genuine,Genuine product. I was hesitant at the beginning to order an expensive product online, but this product on Amazon is genuine and very happy. Got it for 74,990",
            "Good Product,Let me say this product exceeded all my expectations.",
            "Very good,I like it very much",
            "Best IPhone,I really like the phone. It’s fast, smooth and camera is really awesome, battery backup is good, everything is awesome except one thing that is sometimes it will heat. It’s been month that I am using this iPhone",
            "Game changer!!,iPhone 15+ is really a game changer and made an impact. Literally it is the best of best in plus variants. I upgraded iPhone 13 pro max to 15 plus and the only thing i felt disappointed was screen refreshment rate as we know pro variants provide 120Hz while basic models only provides 60Hz. Apple should improve screen refreshment rate in basic models also atleast we are paying 80k. anyway if you are looking to buy new iPhone then i'll absolutely suggest you to buy this phone. Im using 15 plus since january 2024 when i switched phones i really got that upgraded feeling and especially the battery performance is at its peak and one more thing the camera quality is on another level both video and photo (night mode). in hand feel is very light and weightless with thin bezels.",
            "Awesome,Awesome",
            "Wonderful design and love the matte finish,Although I would love a glossy side like the Pros but still it’s amazing.",
            "A must upgrade,Have been an iphone user from long, and loved the upgrade.",
            "very nice phone,smooth experience",
            "iPhone 15 Plus: Impressive Device with a Caveat,I recently purchased the iPhone 15 Plus from Amazon and overall, I'm quite pleased with the product. However, there's a significant drawback that potential buyers should be aware of. One of the drawbacks, though, is the lack of replacement options through Amazon. Unlike some other products where Amazon offers hassle-free replacements, with the iPhone 15 Plus, customers are required to go through Apple's service center for any issues that may arise.",
            "Great,Nice camera and smooth operating system battery backup is awesome",
            "Amazing product go for it.,Battery is long lasting compared to other models. Overall a balanced product.",
            "Very helpful, protective & secured having a long battery life , good looking phone,I like most this product.",
            "Just Awesome,Just Awesome!! After ordering this iPhone 15 Plus, I was not sure about it, too many things were going on in my mind based on social media. After receiving and verifying it on the Apple official site found it's a genuine product. Verified- Before Activating status was \"Not Activated Yet\" and After Activating the status is: \"Active and March 2024\".",
            "The best iPhone to get,If you're getting an iPhone, the Plus models are the best value for money. They offer all the important feature backed by incredible battery and a good enough camera. The Pro and Pro max models have all the best features, but after a while, those features aren't as important (to me). When I compare my main phone - a 15 Pro Max to this, I find this one to do pretty much all I need or want out of the phone. There are some notable omissions like the high refresh rate screen, but you get used to that as well.",
            "Phone refresh rate,I was using android phone all the years got bored and bought iPhone 15, although phone is flawless but still in this budget refresh rate should be 120 HZ, 60 Hz seems slow as I was using one plus 8t with 120 Hz. I did not like phone speed and camera in low light is also issue",
            "My iPhone 15 Plus is so cool and great! 🙌🏻👌Battery,Camera and settings are very nice.,I have gained a very good experience with my iPhone 15 plus. Actually I purchase this iPhone 15 plus for daily use purpose or you can say that I want to use this iPhone 15 plus as per my all requirements which I can do with this iPhone 15 plus. It’s my first and newest iPhone in my life. I’m feeling great times with this iPhone 15 plus. I have been choosing this iPhone on YouTube reviews and google search on this iPhone 15 plus model. Thanks a lot!🙏🏻",
            "Not fake,Recently bought it at the best price from Amazon",
            "Camera quality,All in one power pack mobile and most important Battery backup very impressive. Camera quality video quality is next level",
            "15 plus ki originality kya h,Original ki koi guarantee, nahin",
            "Fraud,Fraud",
            "Great product,Value for money. Battery backup is exceptional",
            "Bibhu,iPhone 15plus a nice photo and beautiful picture ana video my best choice iPhone 15 plus camera a amazing photo and beautiful video",
            "Its overheating and network issues,The product is not up to the mark and now i dobt even know how to replace and get new one. Amazon has declined to replace and asked to go to apple for replacement",
            "World's best phone,From amazon i get best deal and i phone 15 plus is world's best phone. I enjoyed many useful app which is only provide by apple.",
            "Fabulous,Iphone 15 plus is very well packed with features, Specially dynamic appearance on the screen",
            "Best mobile,It is best for picture quality and good sound for musice.overall performance very good..",
            "Incredible Phone. Recommend buying this phone if budget is not a concern.,The Apple iPhone 15 Plus is a little on the higher side of budget but it’s a great phone. The battery life is amazing, and offers over 15 hours of Screen On Time and over 36 hours of Standby Time and takes a little over an hour using the Apple 20W USB C Charger to completely charge. The lack of 120Hz display for the price range doesn’t make sense but I barely notice the 60 Hz display even when I use it next to my Samsung Galaxy S20 with its 120Hz display. There are a very few instances when the software doesn’t work as intended but nothing that’s majorly noticeable or work hampering. The 256GB Storage along with eSIM is a great use case for me. The Camera is usually very good with brilliant video recording, however I personally don’t like how the iPhone processes faces through its HDR. It captures literally all the details of the face, even if one doesn’t want it to and sadly there is no way to turn off HDR in newer models. HDR Videos or Dolby Vision Videos however are very well captured. The phone has a very good stereo setup that has noticeable bass. Consuming media on the phone is a delight. The USB C is a valuable addition that helps me use the same USB C Earphones that I use with my Samsung. The phone along with my Apple Watch SE and Airpods Pro makes a great combination.",
            "Battery Backup not as expected,Battery consumption is good when like watching movies. But Battery drops significantly while using like Facebook/Insta/Youtube.",
            "Phone Hanging and Heating problem,With in 10 days after buying.. the phone was hangout during calls and Heating problem was also there…",
            "Excellent product for the money spent,- Quality is really good like always with the Apple products. - Very beautiful, great quality and performance. - Prices will be good when you have some extra discounts with the offers from credit card, else I would suggest you wait till you have an offer with credit card or Great Indian festival/republic day sale or when a new version of iphone is launcing",
            "❤️🥹,Camera Quality is just Like…. Boom💣😃 Only cons I Noticed according to my preference is heating issue. Its something which Disappoints me otherwise good processor, Better battery capability also an perfect RAM management.",
            "Apple means satisfaction,Thanks to Amazon for fast delivery",
            "Best value for money,Its Osm",
            "Heating issue while charging,It's heating while charging",
            "Product is good but features are not working properly.,My iPhone is delivered in good condition. I am using location service in WhatsApp regularly. Apple Maps not working properly. I installed google maps but end up with difficulty to make it default maps, location service. Apple may have to fix this issue. Or if I missed something then I will have to in coming days.",
            "Awesome 👍,Big screen and good camera. What more is required",
            "ITS A BEAST,Switched from Android (S21 fe, one plus 7T my last 2 phones). I was waiting for S24+ but as i heard its coming with Exynos, I bought 15plus.. I was highly sceptical about the 60hz as i was coming from 120hz s21fe.. and tbh, in merely 30minutes i got used to it and believe me iPhones are wayyyy smoother than anything else, most probably bcoz of the High Touch Sampling rate and awesome animations.. Now coming to best part, which was the Main reason for me to opt 15plus… BATTERY LIFE.. this phone is a beast.. 2days with my usage easy.. Rest i mean, Screen Quality is awesome, Speakers are Fanstastic, Camera is pretty damn good (but i miss my 3x telephoto from samsung), iPhone experience is just flawless (no lags, no stutters, nothing whatsoever), Haptics and vibration motor is Great as well.. i means its a allround phone, got it for 63k. Cant be more happy with it..",
            "Good phone,It is a good phone",
            "Gift Pack Missing,Requested for a gift package with a special message. Unfortunately that was not taken care off. Rest everything is good",
            "**iPhone 15 Plus Review: Redefining Excellence in Every Aspect**,The iPhone 15 Plus is Apple's latest flagship smartphone, and it's nothing short of extraordinary. With its groundbreaking features, stunning design, and unparalleled performance, the iPhone 15 Plus raises the bar for what a smartphone can achieve. Here's a comprehensive review of this exceptional device: **Design and Build Quality:** The iPhone 15 Plus features a sleek and elegant design that is instantly recognizable as an Apple product. The device boasts a premium build quality, with a durable aluminum frame and a ceramic-glass back that feels smooth and luxurious to the touch. The seamless integration of the display and the slim bezels give the iPhone 15 Plus a modern and sophisticated look that is sure to turn heads. **Display:** The iPhone 15 Plus sports a breathtaking 6.9-inch Super Retina XDR display with ProMotion technology, offering an immersive viewing experience like never before. Colors are vibrant, blacks are deep, and the HDR support ensures stunning contrast and detail in every image and video. Whether you're watching movies, playing games, or browsing the web, the display of the iPhone 15 Plus sets a new standard for excellence. **Performance:** Powered by Apple's latest A16 Bionic chip and Neural Engine, the iPhone 15 Plus delivers unmatched performance and efficiency. Apps launch instantly, multitasking is seamless, and even the most demanding tasks are handled with ease. Whether you're editing 4K videos or playing graphics-intensive games, the iPhone 15 Plus handles everything with buttery-smooth responsiveness and unparalleled efficiency. **Camera:** The iPhone 15 Plus features an advanced triple-camera system, including a 12MP wide, 12MP ultra-wide, and 12MP telephoto lens. With improved low-light performance, enhanced optical image stabilization, and new computational photography features, the iPhone 15 Plus captures stunning photos and videos in any lighting condition. From crisp landscapes to detailed portraits, the camera of the iPhone 15 Plus excels in every situation. **Battery Life:** Despite its powerful performance and stunning display, the iPhone 15 Plus offers exceptional battery life that lasts all day on a single charge. With its advanced power management features and efficient hardware, the iPhone 15 Plus ensures that you stay connected and productive throughout the day, without having to worry about running out of battery. **Software:** Running on iOS 16, the iPhone 15 Plus offers a seamless and intuitive user experience that is unmatched by any other smartphone operating system. With its clean design, intuitive gestures, and robust ecosystem of apps and services, iOS 16 enhances the overall user experience and empowers you to do more with your iPhone 15 Plus. **Connectivity:** The iPhone 15 Plus supports 5G connectivity, enabling lightning-fast download and upload speeds for streaming, gaming, and browsing the web. Additionally, it comes with Wi-Fi 6E support for ultra-fast and stable wireless connectivity, as well as Bluetooth 5.4 for seamless pairing with other devices. Whether you're at home or on the go, the iPhone 15 Plus keeps you connected at all times. **Conclusion:** In conclusion, the iPhone 15 Plus is a masterpiece of design and engineering that redefines what a smartphone can be. With its stunning design, immersive display, unparalleled performance, and advanced camera capabilities, the iPhone 15 Plus sets a new benchmark for excellence in the smartphone industry. Whether you're a power user, a photography enthusiast, or simply someone who appreciates the finer things in life, the iPhone 15 Plus delivers an unparalleled experience that is sure to impress.",
            "Babu,All are good But mobile is heating when we are giving charging",
            "Just wow,This phone working so well, UI is simple and ultra smooth, screen is bright and vibrant, if you are long time android user you can switch for iphone for a new experience, battery life is also so good, one thing I really miss is call recording,",
            "Fine,Fine sett",
            "Very nice phone,I am so happy this product love it. iPhone 15 plus wonderful pictures camera quality and video quality.  So let’s go and buy it product.",
            "Awesome,An absolute delight to have this phone. This is my first I phone and it has broken all my previous assumptions of having a costly iPhone ( I thought it is not worth spending so much money on phone). Great experience till now very smooth and sharp phone and technology.",
            "Awesome product,IPhone 15pluse  camera systems are highly regarded, offering excellent image quality, especially in low light conditions.smooth operation and responsiveness to their designed processor Battery life is very good. Performance is too good.",
            "average,Tom’s Guide1 highlights the iPhone 15’s pros and cons. The pros include an upgraded camera with a 48MP main sensor, which replaces the 12MP main camera that’s been an iPhone staple for years1. The iPhone 15 also supports 2x optical zoom1. The cons revolve around features introduced a year ago1. Gadgets 3602 states that the iPhone 15 is the most exciting iPhone model as it finally gets some big upgrades2. The iPhone 15 starts at Rs. 79,900 for the 128GB variant in India2. It features a 48-megapixel main camera sensor and is powered by the A16 Bionic SoC2. The iPhone 15 now comes with Dynamic Island and USB Type-C port2. PCMag3 mentions that the iPhone 15 features a tweaked design, new display tools, an appreciable jump in performance, and a solid set of cameras at a price that’s hard to ignore3",
            "best phone among 15 models,best phone among 15 models",
            "received as committed,A product worth its price. Quality delivery ensured by Amazon adhering to the committed timelines. Thank you Amazon Team !",
            "Iphone is iphone,Dont worry about the market talks about the 15 since 6s iam using iphone i liked it iam passionate for iphones",
            "Amazing ❤️‍🔥 Best Buy of 2023,It's Fantastic. Amazing Battery Backup, Best for Videography and Photography. Amazing Software Experience. Overall it's the best till now.",
            "Battery charging issue,I recently bought Iphone 15 plus but disappointed with battery charging. It takes almost 6 hours of time to comolete 100% charging..i have trust issue now whether i received new phone or used one.. Also now i remeber the product package was sealed at the time of delivery..after 1 hour i tried to call delivedy guy but that was customer care unable reach it. I am disappointed with Iphone battery",
            "A good phone.,I liked this iphone 15 plus very much, huge battery backup, nice camera setup. Colour is just bluish white. If anyone specifically go for blue then this colour is not for you..!!",
            "Just like a wow no compere anything,I'm very happy iphone 15 plus 🥰 camera is a good battery backup most good gaming very smooth 😘",
            "Charging time mobile gets Heating,Overheating mobile on charging condition",
            "It was good,It was good",
            "Excellent,Really good product by Apple",
            "Great technology,An absolute delight to have this phone. This is my first I phone and it has broken all my previous assumptions of having a costly iPhone ( I thought it is not worth spending so much money on phone). Great experience till now very smooth and sharp phone and technology.",
            "WORTHIT,...",
            "Killer,Just Amazing..!",
            "I phone 15 plus return not allowing,Product is bad and amazonw not allowing to retune within 7 days",
            "Nice look,Performance",
            "Very much excited to join apple family,Unboxing experience was Ossum",
            "Awesome,I was just sifted from android to IOS  and just learning but it is awesoms experiance",
            "Honest Review from a usual Android User,I got this phone on 26th September after ordering the very first day of release. I must say the wait was worth it. The last Iphone had was 11 (basic model) and I was happy with it. Since then I switched to OnePlus 9pro and Samsung Z Flip 3, and then finally this. I knew it will be a good phone and delivered more than what I was expecting. I decided to go for it mainly because of the camera as they finally gave 48mp and then almost everything which a 14pro was offering. It hits it out of the park as for last 2 months I have not experience any issues. The best part is the battery life. I did see comparison vids and they all are true. I totally believe it has the best battery among all the models apple has offered. The pro models would definitely offer more but I do not see a reason to spend that much wherein this is also costly but atleast makes it worth it.. Go for it without any second thoughts.. it offers performance, look and statement for sure... 5 on 5 from me as a user!!",
            "Super,",
            "Not optimised yet,Need lot of optimisation and updates",
            "Really nice phone works fast and ios is great,The build quality the software the speed the cameras the battery life it’s all great, I’d post pics of the phone but I can’t coz I’m taking photo with it but it’s about this big in my hand",
            "Heating issue,Everything is Perfect except one Heating issue.",
            "Camera,Quality brilliant",
            "Camara quality superb,I like 15 pluse super handset photo Camara quality ammezing worthfull features are too good love this mobile better  siriers",
            "Worth for money we spent,Phone is excellent  the amount we paid for it this device is fully worth , loaded with lots of features and camera quality are some positive points , apple is doing well but fast charging should be introduce for this much price",
            "protrait 2x zooming,",
            "Iphone 15 plus,Iphone 15 plus has an excellent camera..cinematic mode for shooting videos,it is slightly larger than Iphone 15 and the older Iphone 11 which I have. It is a good buy from the brand if you're looking for practicality. Some people complained about the heating issue, it isn't much and was there when charging initially but it's probably normal as it's not affecting the performance of the phone yet",
            "Best in Best 15 plus,Osmmm Betterie life and big display , A16 chip thats why Perfect Super Power full display 15 series on top marketing",
            "Bohot garm hota he mobile,Over hiting problem update ke baadh bhi solve nahi huaa costumer care wale bol rhe hai agale updat me sahi hoga, dekhte hai kyaa hota hai🥺",
            "Nice awesome must buy,The anroid to iphone is big transformation.very proud to keep iphone with you.Its time to upgrade iphone.so buy it without any confusion"
          ],
          "user_name": [
            "Arbaaz",
            "Mohd Danish Shamim",
            "MWO SK SINGH",
            "Sujatha",
            "Marvellous ",
            "Naveen raj",
            "kavoori adithya",
            "Krishna tiwari",
            "Phone is absolutely perfect ",
            "Karan",
            "Vaishnavi Nelabotla",
            "Amazon Customer",
            "Unique",
            "Return to refund ",
            "Placeholder",
            "Gopal Dandgavale",
            "Ankush",
            "Manoj",
            "Chinni.kish",
            "Amazon Customer",
            "Azad",
            "Cajetan Dcruz",
            "Ranjith",
            "Amazon Customer",
            "Shailesh Nanavati.",
            "sumantra sarkar",
            "Rahul yadav",
            "Rimni Mukherjee",
            "Satish",
            "Koutuhal p.",
            "Giri Gaurav ",
            "Hariharan Balakrishnan",
            "SNEHA AGARWAL ",
            "Deepanshu kansal",
            "shashikant",
            "Sunil",
            "Mohamed eras",
            "Placeholder",
            "PROSENJIT MONDAL",
            "Nabi ullah khan",
            "Placeholder",
            "Amazon Customer",
            "Santhosh K.U",
            "Shantanu K",
            "Gaurav Arora",
            "Muhammed shibili",
            "RBC",
            "Bossy",
            "ROSHAN DHANAI",
            "Good quality",
            "Prabhat Srivastava",
            "Placeholder",
            "Rifat Mehraj",
            "M.M.Jalaly",
            "Abinash Gogoi",
            "Sai",
            "Very bad problem 😕",
            "Placeholder",
            "shiva",
            "Essdee",
            "Abhishek Kr Mishra",
            "Kamleshsinh Thakor",
            "Sanathan Juturu",
            "kenny smith",
            "Ajay Mishra",
            "YSM",
            "Elaine",
            "Nachiket Patil",
            "Rahul Sharma",
            "Pritam",
            "Senthilkumar",
            "Simran shrivastava",
            "Rajendra Kumar",
            "Rahul",
            "Neshim Rahman",
            "sanjay",
            "shibanimukherjee",
            "Kunaal",
            "ashutosh pandey",
            "Jayakrishnan",
            "Rahul",
            "Virendra kumar",
            "Shobhit Ranjan",
            "Amazon Customer",
            "Gangadharan Nadar",
            "Sumit S Illamalle",
            "Ankit Jangra",
            "KaushalTripathi",
            "Rajan Shibi",
            "Swapan Kumar Das",
            "Dk Gurung",
            "💫CRB.",
            "Rohit",
            "Placeholder",
            "Gopal krishna Reddy",
            "Vignesh",
            "Surajit",
            "Virag Muley",
            "Kanchan Kurmi",
            "Sarfaraj k.",
            "Amazing performance. A15 Bio chip prosessor is literally lit 🔥.",
            "Vishal",
            "Subodh Meshram",
            "harsh gupta",
            "Akok moyong",
            "Yash g.",
            "Amazon Customer",
            "pushpendra",
            "Ankit",
            "Ansel",
            "Raman Tripathi",
            "Manthan nathwani",
            "Best phone ever",
            "Nimesh Vyas",
            "Realme buds air 5 ",
            "Ayush maran",
            "Aditya",
            "koushik chaki",
            "Arif Khan",
            "Vipul Waskel ",
            "Om dhoke",
            "Amazon Customer",
            "SXX",
            "Vikas Kashyap",
            "manjunatha",
            "V C Mohan",
            "Maruf",
            "Gagan Pandey",
            "Amazon Customer",
            "Banarasi Kanya",
            "Somnath Choudhury",
            "Giri Gaurav ",
            "Shubham kumar",
            "Placeholder",
            "Sam",
            "Radha jangid",
            "Rohan",
            "NEHA",
            "Kunal",
            "Aradhya mittal",
            "Karan Jaiswal",
            "Ayasha Saifi",
            "Saurabh verma",
            "Priyanka",
            "Rahul Moghe",
            "Ra1rider",
            "Jyoti",
            "Iqbal Mansuri",
            "Rahul shivhare ",
            "Shiven",
            "Brendon Fernandes",
            "praveen",
            "Placeholder",
            "Akshay M B",
            "Lawrence Anthony Pereira",
            "suman singh",
            "Saud",
            "teja",
            "ravi singh",
            "Sumon mandal",
            "Priyanko",
            "Mahesh",
            "Ishwar",
            "Vinakshi Malik",
            "Alishba h.",
            "Atul raj",
            "Ananya",
            "Mohd Zeeshan",
            "Megharaj",
            "Happy",
            "Siraj solanki",
            "shailesh yeole",
            "Sukanya Dhara",
            "Shalin Sabu",
            "Tufel Ajmeri",
            "Mukilan",
            "Baldeep Kaur",
            "R J Sahu",
            "Very good item.",
            "Ashutosh",
            "Adil khan",
            "rahul singh",
            "Tejavath sravan kumar",
            "Very gorgeous phone his display smooth and camera is opp ",
            "Dr Rakesh Choure",
            "Kushal Achchha",
            "Amazon Customer",
            "Tushar Soni",
            "Amazon Customer",
            "AIYANKARAN G",
            "Sagnik Ghosh",
            "Mayank0802",
            "Vaibhav Tiwari",
            "Placeholder",
            "Rajesh M",
            "Umer Shaikh",
            "Joystan dsouza",
            "Raji",
            "A V Techno Soft India Pvt Ltd",
            "akshit s.",
            "Venkatesh K",
            "Harika rapol ",
            "Rituporno Sonowal",
            "Lovepreet singh",
            "Hardik Kumar Rawal",
            "Chirag",
            "Kshitija sontakke",
            "Camera quality best ",
            "Avinash Kumar",
            "aravindkumar",
            "Prasad",
            "Dinesh Kumar",
            "Amazon Customer",
            "Amazon Customer",
            "Ganesh",
            "Jayaram K S",
            "Nani",
            "Sai Bramarambika ",
            "Venkatesh g m Gowda",
            "Subramanian",
            "Harry",
            "Balakrishna",
            "KaFeel",
            "Mohan Jakkula",
            "Prasenjit Mahato",
            "Neelam Kashyap",
            "user",
            "Aditya Pathania",
            "Kumar Vinchurkar",
            "ARAVINDAN N",
            "I am a yellower now! Such a versatile version of iPhone 14 Plus especially this yellow. It shines like the sun in the day and yet vibrant in the night. It so classy to hold in your hands because of its size. 128gb is a wise choice understandably using iCloud storage. It’s not heavy as I thought it would be. I click pics and take videos confidently with the clarity iPhone gives. Trust me it’s worth buying one! Go for it people 🤞",
            "K Raja shekhar gowd",
            "Gaurav",
            "Roopashri",
            "Manhan",
            "Amazon Customer",
            "vjose",
            "Roshan jat",
            "kuldeep singh",
            "Nishanth",
            "A. K",
            "Neel",
            "Sameer ",
            "Seelu",
            "Basumatary j",
            "Amazon Customer",
            "Dharmender Bisht",
            "Aslam",
            "PANKAJ SHARMA",
            "Priyanka Panja",
            "Rashee",
            "Nishant kakade",
            "Am not satisfied with this phone... My first iphone experience is this... overheating and sometimes the ph is stuck.. waste of money i really disappointed to this product.",
            "laichat paul",
            "Mr. Sangma",
            "Ramani",
            "Sunny",
            "neelam p.",
            "Pritam Shetty",
            "Rishi s.",
            "Janardhan",
            "Saroj Debbarma",
            "Amazon Customer",
            "Deeksha Mishra",
            "RAJENDRA s.",
            "Anuj kumar",
            "Kishore",
            "N.SATHISH",
            "Anubhuti Tyagi",
            "Huzaif ",
            "Savan",
            "Consumer's voice",
            "Atc boot house",
            "Abhijeet",
            "Debabrata Sarkar",
            "ABHILASHA",
            "Sumit bisht",
            "Kumar Nitin",
            "Anant kumar",
            "Sudarshan",
            "Saurabh Pandey",
            "Amazon Customer",
            "Heating ",
            "Ketan",
            "KHUNDRAKPAM MANAO SINGH",
            "Nunhlu Pachuau",
            "Nirin",
            "nishant",
            "Bannu",
            "Amazon Customer",
            "sai chand",
            "Faisal Amir",
            "Sabu",
            "Placeholder",
            "vishnu prakash",
            "Premchandra",
            "Twinkle",
            "Azhar Khan",
            "Vishal",
            "divya",
            "Neelkant",
            "Bittu",
            "Ayushmaan",
            "Himanshu",
            "Arun Verma",
            "Amazon Customer",
            "KK",
            "RAM v.",
            "Rohit Vaidya",
            "Ashish R.",
            "Placeholder",
            "Alpana soren",
            "Arshi khan",
            "Omkar Shinde",
            "Jenni",
            "naveen",
            "Amy",
            "Robin Siby",
            "P.Rajesh",
            "Nice",
            "Jatin Patil",
            "Sourav Datta",
            "Gagandeep Singh",
            "Navaneen",
            "Nilotpal Poddar",
            "Arnab B.",
            "Samiksha jaiswal",
            "Vinay Hegde",
            "Mukesh",
            "aswathy sathyan",
            "Parth Patil",
            "Puneet Kumar",
            "Priyanshu",
            "ebrius_baba",
            "JMK Lalwani",
            "Sanjay Gulati Musafir",
            "Samir Shaikh ",
            "m.murali",
            "rishi soni",
            "mohan kumar ",
            "Anant Pokhariyal",
            "Mohnish",
            "Smith",
            "Sumanta Koley",
            "Anup",
            "Dhivya",
            "rakesh r.",
            "Lionel",
            "Rushikesh Sonawale",
            "Gurrapu Raju19",
            "Nishat",
            "ABUBAKKAR ",
            "Mohammed Sharuk m s",
            "Vinay Kumar ",
            "Placeholder",
            "Aayush sidana",
            "kush",
            "Bushan",
            "MOHIT KUMAR",
            "Eshwar Sreevatsa",
            "Tuhin Dey",
            "Om Amberkar",
            "Akshay",
            "Venkata Ratnam",
            "Tejavath sravan kumar",
            "sarithag",
            "Monika",
            "Raj",
            "Deepak Supali",
            "Maruthi H V",
            "Unknown",
            "Placeholder",
            "Ahmad",
            "pragya saha",
            "Debjit ",
            "Placeholder",
            "Rajkumar Yadav",
            "Debasis s.",
            "DR BABLU BHATTACHARJEE",
            "Placeholder",
            "AB",
            "shahzad",
            "Mahabir",
            "Yuvika Sharma",
            "Nitesh katwale",
            "monu",
            "Sadashiv",
            "Anuraag Banerjee",
            "Placeholder",
            "deepanker sati",
            "udayraj rokad",
            "Ajay",
            "Rajesh Kumar",
            "Fahad A.",
            "Taring Tam",
            "KNM REDDY",
            "Prince",
            "Nilesh Mourya",
            "Kumud Ranjan Sinha",
            "Chandan Rout",
            "Amit",
            "ponnuchamy",
            "T W",
            "Preetinder Singh",
            "Shivam",
            "Rohit Raghuwanshi",
            "Nyaneshwar Jadhav",
            "Babu Vandana",
            "Aniruddh",
            "Placeholder",
            "Nitesh",
            "An absolute delight to have this phone. This is my first I phone and it has broken all my previous assumptions of having a costly iPhone ( I thought it is not worth spending so much money on phone). Great experience till now very smooth and sharp phone and technology.Just awesome",
            "Pradeep Bhandari",
            "Ronak",
            "Rahul Das",
            "Amitendra Singh",
            "Saicharan",
            "Dipayan Singha Roy",
            "Goli Rakesh yadav",
            "Amandeep Singh",
            "Khokan",
            "Socratesm__Ar ",
            "rajasekharreddy",
            "gopal sinha",
            "Vipin Kumar",
            "Pavithiran",
            "Nitin Saxena",
            "I have purchased I phone 15 plus and camara quality is not good as compared to other 15 plus phone. Now funny thing is that Amazon not allowing to return ",
            "Placeholder",
            "CHANDAN.G",
            "Hitesh",
            "Samay Thapa",
            "shaik subhani",
            "md saif",
            "Joshua vincent",
            "Kumar Nitya",
            "shaik rafi",
            "Superb",
            "Rahul Yadav",
            "Alok",
            "PDB",
            "Munazir",
            "Jitu",
            "Subashini"
          ],
          "helpful_cnt": [
            "",
            "",
            "",
            "2",
            "",
            "",
            "",
            "",
            "",
            "1",
            "10",
            "",
            "1",
            "1",
            "1",
            "2",
            "3",
            "4",
            "",
            "",
            "2",
            "",
            "1",
            "",
            "5",
            "",
            "6",
            "",
            "",
            "1",
            "2",
            "4",
            "",
            "",
            "",
            "",
            "5",
            "2",
            "3",
            "9",
            "",
            "2",
            "",
            "",
            "",
            "3",
            "",
            "1",
            "",
            "3",
            "1",
            "10",
            "2",
            "",
            "2",
            "1",
            "2",
            "1",
            "",
            "",
            "6",
            "2",
            "16",
            "",
            "",
            "",
            "1",
            "",
            "1",
            "",
            "2",
            "3",
            "4",
            "",
            "",
            "1",
            "4",
            "4",
            "",
            "10",
            "",
            "1",
            "",
            "4",
            "1",
            "4",
            "",
            "4",
            "1",
            "6",
            "",
            "",
            "",
            "",
            "",
            "",
            "4",
            "1",
            "1",
            "1",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "1",
            "",
            "1",
            "1",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "1",
            "",
            "",
            "",
            "1",
            "",
            "1",
            "1",
            "1",
            "",
            "",
            "",
            "1",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "1",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "1",
            "",
            "1",
            "1",
            "1",
            "",
            "2",
            "2",
            "2",
            "",
            "2",
            "",
            "1",
            "3",
            "5",
            "",
            "1",
            "",
            "6",
            "2",
            "",
            "",
            "",
            "3",
            "2",
            "",
            "1",
            "",
            "",
            "",
            "",
            "6",
            "",
            "1",
            "2",
            "",
            "4",
            "1",
            "",
            "16",
            "3",
            "1",
            "13",
            "",
            "3",
            "5",
            "3",
            "",
            "1",
            "1",
            "1",
            "2",
            "",
            "1",
            "1",
            "1",
            "",
            "1",
            "17",
            "2",
            "1",
            "8",
            "5",
            "",
            "",
            "",
            "31",
            "3",
            "4",
            "",
            "8",
            "4",
            "",
            "",
            "2",
            "19",
            "",
            "4",
            "",
            "1",
            "",
            "",
            "1",
            "7",
            "",
            "",
            "",
            "",
            "9",
            "20",
            "1",
            "",
            "",
            "2",
            "1",
            "1",
            "",
            "1",
            "12",
            "",
            "",
            "",
            "9",
            "1",
            "1",
            "5",
            "",
            "8",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "97",
            "",
            "5",
            "2",
            "",
            "6",
            "11",
            "1",
            "4",
            "3",
            "2",
            "",
            "1",
            "3",
            "18",
            "",
            "3",
            "",
            "36",
            "2",
            "1",
            "4",
            "1",
            "",
            "",
            "",
            "16",
            "1",
            "",
            "1",
            "3",
            "",
            "3",
            "",
            "",
            "2",
            "1",
            "",
            "12",
            "",
            "",
            "10",
            "2",
            "1",
            "",
            "",
            "",
            "",
            "14",
            "1",
            "2",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "",
            "1",
            "",
            "",
            "",
            "",
            "",
            "1",
            "9",
            "3",
            "4",
            "",
            "1",
            "",
            "",
            "",
            "",
            "3",
            "1",
            "",
            "4",
            "53",
            "2",
            "3",
            "2",
            "1",
            "1",
            "2",
            "1",
            "2",
            "",
            "1",
            "2",
            "",
            "14",
            "1",
            "4",
            "2",
            "3",
            "",
            "",
            "1",
            "2",
            "2",
            "",
            "9",
            "2",
            "1",
            "16",
            "1",
            "",
            "2",
            "11",
            "",
            "",
            "",
            "6",
            "4",
            "6",
            "9",
            "1",
            "",
            "9",
            "10",
            "",
            "2",
            "1",
            "3",
            "7",
            "2",
            "",
            "1"
          ],
          "date": [
            "Wed, Apr 03 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Thu, Dec 28 2023",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sat, Apr 13 2024",
            "Thu, Apr 11 2024",
            "Thu, Apr 11 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Sun, Apr 07 2024",
            "Sun, Apr 07 2024",
            "Sat, Apr 06 2024",
            "Sat, Apr 06 2024",
            "Tue, Mar 26 2024",
            "Mon, Mar 25 2024",
            "Sun, Feb 04 2024",
            "Wed, Jan 31 2024",
            "Thu, Apr 04 2024",
            "Tue, Apr 02 2024",
            "Sat, Mar 30 2024",
            "Thu, Mar 28 2024",
            "Thu, Mar 28 2024",
            "Mon, Jan 29 2024",
            "Sun, Jan 28 2024",
            "Wed, Dec 27 2023",
            "Wed, Dec 27 2023",
            "Sat, Dec 23 2023",
            "Wed, Jan 31 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Thu, Mar 21 2024",
            "Tue, Mar 19 2024",
            "Tue, Mar 19 2024",
            "Thu, Mar 07 2024",
            "Wed, Jan 17 2024",
            "Wed, Jan 17 2024",
            "Wed, Jan 17 2024",
            "Mon, Mar 18 2024",
            "Sat, Mar 16 2024",
            "Tue, Mar 12 2024",
            "Fri, Mar 08 2024",
            "Fri, Mar 01 2024",
            "Sun, Jan 14 2024",
            "Thu, Dec 14 2023",
            "Wed, Dec 13 2023",
            "Tue, Dec 12 2023",
            "Sat, Dec 09 2023",
            "Sun, Jan 14 2024",
            "Tue, Feb 27 2024",
            "Mon, Feb 26 2024",
            "Sat, Feb 24 2024",
            "Sun, Feb 18 2024",
            "Fri, Jan 12 2024",
            "Tue, Feb 13 2024",
            "Sat, Feb 10 2024",
            "Thu, Feb 08 2024",
            "Fri, Apr 12 2024",
            "Fri, Jan 12 2024",
            "Fri, Jan 12 2024",
            "Thu, Jan 11 2024",
            "Sun, Jan 07 2024",
            "Sat, Dec 09 2023",
            "Fri, Jan 05 2024",
            "Fri, Jan 05 2024",
            "Wed, Jan 03 2024",
            "Sun, Dec 31 2023",
            "Thu, Jan 25 2024",
            "Tue, Feb 06 2024",
            "Mon, Feb 05 2024",
            "Tue, Jan 23 2024",
            "Sun, Jan 21 2024",
            "Fri, Jan 19 2024",
            "Thu, Jan 18 2024",
            "Sun, Dec 17 2023",
            "Fri, Dec 15 2023",
            "Tue, Dec 12 2023",
            "Sun, Dec 17 2023",
            "Sun, Dec 17 2023",
            "Sat, Dec 16 2023",
            "Sat, Dec 23 2023",
            "Mon, Dec 18 2023",
            "Sat, Dec 02 2023",
            "Wed, Nov 29 2023",
            "Wed, Nov 29 2023",
            "Mon, Dec 11 2023",
            "Thu, Dec 07 2023",
            "Wed, Dec 06 2023",
            "Fri, Nov 24 2023",
            "Fri, Apr 19 2024",
            "Fri, Apr 19 2024",
            "Fri, Apr 19 2024",
            "Wed, Apr 17 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Tue, Nov 28 2023",
            "Tue, Nov 28 2023",
            "Wed, Apr 17 2024",
            "Wed, Apr 17 2024",
            "Tue, Apr 16 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Fri, Apr 12 2024",
            "Fri, Apr 12 2024",
            "Fri, Apr 12 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Thu, Apr 11 2024",
            "Mon, Apr 08 2024",
            "Mon, Apr 08 2024",
            "Sun, Apr 07 2024",
            "Sun, Apr 07 2024",
            "Wed, Apr 10 2024",
            "Fri, Apr 12 2024",
            "Thu, Apr 11 2024",
            "Thu, Apr 11 2024",
            "Thu, Apr 11 2024",
            "Wed, Apr 10 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Sun, Mar 31 2024",
            "Sun, Mar 31 2024",
            "Sun, Mar 31 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Tue, Apr 09 2024",
            "Sat, Mar 30 2024",
            "Sat, Mar 23 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Sat, Mar 30 2024",
            "Tue, Apr 09 2024",
            "Tue, Apr 09 2024",
            "Mon, Apr 08 2024",
            "Sat, Mar 30 2024",
            "Sat, Mar 30 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 27 2024",
            "Sat, Mar 30 2024",
            "Sat, Mar 30 2024",
            "Thu, Mar 28 2024",
            "Sat, Apr 06 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 20 2024",
            "Wed, Mar 20 2024",
            "Sat, Apr 06 2024",
            "Fri, Apr 05 2024",
            "Thu, Apr 04 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 20 2024",
            "Thu, Apr 04 2024",
            "Wed, Apr 03 2024",
            "Tue, Mar 26 2024",
            "Mon, Mar 25 2024",
            "Mon, Mar 25 2024",
            "Mon, Apr 01 2024",
            "Sun, Mar 24 2024",
            "Sun, Mar 24 2024",
            "Mon, Mar 25 2024",
            "Sun, Mar 24 2024",
            "Wed, Apr 03 2024",
            "Tue, Apr 02 2024",
            "Tue, Apr 02 2024",
            "Sat, Mar 23 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Fri, Mar 22 2024",
            "Thu, Mar 21 2024",
            "Sun, Mar 24 2024",
            "Sat, Mar 23 2024",
            "Thu, Mar 21 2024",
            "Thu, Mar 21 2024",
            "Wed, Mar 20 2024",
            "Tue, Mar 19 2024",
            "Tue, Mar 19 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 06 2024",
            "Sat, Apr 06 2024",
            "Fri, Apr 19 2024",
            "Tue, Apr 16 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sun, Apr 14 2024",
            "Sat, Mar 30 2024",
            "Sun, Mar 24 2024",
            "Sat, Mar 23 2024",
            "Fri, Apr 05 2024",
            "Sun, Mar 31 2024",
            "Wed, Feb 21 2024",
            "Sat, Feb 17 2024",
            "Tue, Feb 13 2024",
            "Sun, Feb 11 2024",
            "Sat, Feb 10 2024",
            "Mon, Oct 02 2023",
            "Wed, Mar 13 2024",
            "Fri, Dec 29 2023",
            "Mon, Dec 25 2023",
            "Wed, Dec 20 2023",
            "Tue, Dec 19 2023",
            "Sat, Dec 16 2023",
            "Sun, Feb 04 2024",
            "Sat, Feb 03 2024",
            "Wed, Jan 31 2024",
            "Tue, Jan 30 2024",
            "Fri, Feb 09 2024",
            "Mon, Feb 05 2024",
            "Mon, Feb 05 2024",
            "Mon, Jan 29 2024",
            "Sun, Jan 28 2024",
            "Thu, Jan 25 2024",
            "Thu, Jan 25 2024",
            "Fri, Jan 19 2024",
            "Thu, Jan 11 2024",
            "Wed, Jan 10 2024",
            "Tue, Jan 30 2024",
            "Sat, Jan 13 2024",
            "Sun, Nov 05 2023",
            "Sat, Nov 04 2023",
            "Thu, Nov 02 2023",
            "Mon, Oct 30 2023",
            "Fri, Oct 20 2023",
            "Mon, Oct 16 2023",
            "Sun, Jan 07 2024",
            "Fri, Jan 05 2024",
            "Wed, Dec 06 2023",
            "Mon, Dec 04 2023",
            "Fri, Dec 01 2023",
            "Tue, Nov 28 2023",
            "Wed, Sep 27 2023",
            "Thu, Nov 09 2023",
            "Sat, Oct 14 2023",
            "Tue, Oct 10 2023",
            "Thu, Dec 14 2023",
            "Wed, Sep 27 2023",
            "Tue, Sep 26 2023",
            "Mon, Sep 25 2023",
            "Thu, Nov 23 2023",
            "Sat, Nov 11 2023",
            "Tue, Sep 12 2023",
            "Mon, Nov 06 2023",
            "Mon, Nov 06 2023",
            "Tue, Sep 19 2023",
            "Sat, Sep 16 2023",
            "Mon, Aug 28 2023",
            "Sun, Aug 27 2023",
            "Sun, Oct 08 2023",
            "Sat, Aug 26 2023",
            "Fri, Aug 25 2023",
            "Mon, Oct 30 2023",
            "Wed, Sep 06 2023",
            "Sun, Sep 03 2023",
            "Tue, Aug 29 2023",
            "Wed, Aug 23 2023",
            "Wed, Aug 23 2023",
            "Fri, Aug 18 2023",
            "Sat, Sep 30 2023",
            "Sat, Sep 30 2023",
            "Thu, Sep 28 2023",
            "Thu, Sep 28 2023",
            "Wed, Sep 20 2023",
            "Mon, Sep 11 2023",
            "Mon, Sep 11 2023",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Fri, Mar 15 2024",
            "Sat, Apr 20 2024",
            "Thu, Apr 18 2024",
            "Thu, Apr 18 2024",
            "Sat, Mar 23 2024",
            "Tue, Apr 16 2024",
            "Mon, Apr 15 2024",
            "Mon, Apr 15 2024",
            "Sun, Apr 14 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 13 2024",
            "Sat, Apr 13 2024",
            "Thu, Feb 01 2024",
            "Sat, Apr 13 2024",
            "Thu, Apr 11 2024",
            "Wed, Apr 10 2024",
            "Tue, Apr 09 2024",
            "Mon, Apr 08 2024",
            "Sat, Apr 06 2024",
            "Mon, Apr 08 2024",
            "Sun, Apr 07 2024",
            "Tue, Mar 19 2024",
            "Fri, Mar 15 2024",
            "Sat, Apr 06 2024",
            "Thu, Apr 04 2024",
            "Thu, Apr 04 2024",
            "Thu, Mar 14 2024",
            "Mon, Apr 01 2024",
            "Tue, Mar 26 2024",
            "Mon, Apr 01 2024",
            "Sun, Mar 31 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 27 2024",
            "Wed, Mar 13 2024",
            "Mon, Mar 11 2024",
            "Mon, Mar 11 2024",
            "Tue, Mar 26 2024",
            "Tue, Mar 26 2024",
            "Tue, Mar 26 2024",
            "Thu, Mar 14 2024",
            "Sat, Mar 23 2024",
            "Fri, Mar 08 2024",
            "Wed, Mar 06 2024",
            "Wed, Mar 06 2024",
            "Sat, Mar 23 2024",
            "Wed, Mar 20 2024",
            "Wed, Mar 20 2024",
            "Tue, Mar 19 2024",
            "Mon, Mar 04 2024",
            "Sun, Mar 17 2024",
            "Sun, Mar 17 2024",
            "Sun, Mar 17 2024",
            "Wed, Feb 28 2024",
            "Mon, Feb 26 2024",
            "Tue, Jan 30 2024",
            "Mon, Mar 11 2024",
            "Sun, Mar 03 2024",
            "Thu, Mar 14 2024",
            "Wed, Mar 13 2024",
            "Sun, Feb 25 2024",
            "Sun, Mar 10 2024",
            "Mon, Feb 19 2024",
            "Mon, Feb 19 2024",
            "Sun, Feb 18 2024",
            "Sun, Mar 03 2024",
            "Sun, Feb 25 2024",
            "Sun, Feb 25 2024",
            "Tue, Mar 05 2024",
            "Tue, Feb 20 2024",
            "Sun, Mar 03 2024",
            "Sun, Mar 03 2024",
            "Sat, Mar 02 2024",
            "Thu, Feb 29 2024",
            "Mon, Feb 26 2024",
            "Mon, Feb 26 2024",
            "Sun, Mar 03 2024",
            "Fri, Dec 08 2023",
            "Sat, Mar 02 2024",
            "Sat, Mar 02 2024",
            "Sat, Feb 24 2024",
            "Sun, Feb 25 2024",
            "Sun, Feb 11 2024",
            "Sat, Feb 10 2024",
            "Thu, Feb 08 2024",
            "Sat, Apr 20 2024",
            "Fri, Feb 23 2024",
            "Sat, Feb 17 2024",
            "Sat, Feb 17 2024",
            "Thu, Feb 15 2024",
            "Wed, Apr 17 2024",
            "Sun, Apr 07 2024",
            "Wed, Apr 03 2024",
            "Sun, Apr 07 2024",
            "Sat, Apr 06 2024",
            "Wed, Apr 17 2024",
            "Tue, Apr 16 2024",
            "Fri, Apr 12 2024",
            "Fri, Apr 12 2024",
            "Thu, Apr 11 2024",
            "Sat, Apr 06 2024",
            "Sun, Mar 31 2024",
            "Fri, Mar 29 2024",
            "Fri, Mar 29 2024",
            "Sun, Feb 18 2024",
            "Fri, Apr 05 2024",
            "Thu, Apr 04 2024",
            "Tue, Apr 02 2024",
            "Tue, Apr 02 2024",
            "Tue, Apr 02 2024",
            "Sun, Feb 18 2024",
            "Thu, Mar 28 2024",
            "Wed, Mar 27 2024",
            "Sun, Feb 18 2024",
            "Mon, Mar 18 2024",
            "Mon, Mar 18 2024",
            "Sat, Mar 16 2024",
            "Sat, Mar 16 2024",
            "Tue, Mar 26 2024",
            "Fri, Mar 22 2024",
            "Tue, Mar 12 2024",
            "Sun, Mar 10 2024",
            "Sun, Mar 10 2024",
            "Thu, Mar 14 2024",
            "Sat, Mar 09 2024",
            "Sat, Jan 20 2024",
            "Fri, Jan 19 2024",
            "Wed, Jan 17 2024",
            "Sun, Mar 10 2024",
            "Sat, Mar 09 2024",
            "Fri, Mar 08 2024",
            "Sun, Mar 03 2024",
            "Sun, Jan 14 2024",
            "Mon, Feb 26 2024",
            "Fri, Jan 12 2024",
            "Thu, Jan 11 2024",
            "Mon, Jan 08 2024",
            "Fri, Mar 01 2024",
            "Thu, Feb 29 2024",
            "Thu, Feb 15 2024",
            "Sat, Feb 17 2024",
            "Fri, Dec 29 2023",
            "Sun, Jan 07 2024",
            "Thu, Feb 08 2024",
            "Thu, Feb 08 2024",
            "Sat, Feb 03 2024",
            "Fri, Dec 29 2023",
            "Fri, Feb 16 2024",
            "Sat, Jan 06 2024",
            "Fri, Jan 05 2024",
            "Wed, Feb 14 2024",
            "Wed, Jan 24 2024",
            "Mon, Dec 18 2023",
            "Sat, Dec 16 2023",
            "Thu, Dec 14 2023",
            "Sun, Jan 07 2024",
            "Wed, Jan 24 2024",
            "Tue, Jan 23 2024",
            "Fri, Dec 22 2023",
            "Fri, Jan 12 2024",
            "Sat, Nov 25 2023",
            "Mon, Dec 18 2023",
            "Wed, Dec 06 2023",
            "Mon, Dec 04 2023",
            "Sat, Dec 02 2023",
            "Tue, Jan 02 2024",
            "Fri, Dec 08 2023",
            "Fri, Dec 29 2023",
            "Fri, Dec 29 2023",
            "Sun, Dec 24 2023",
            "Sun, Dec 24 2023",
            "Sat, Dec 23 2023",
            "Fri, Dec 22 2023",
            "Fri, Dec 22 2023",
            "Thu, Dec 21 2023",
            "Tue, Dec 19 2023"
          ]
        }
      }
    },
    "start_date": "18/08/2023",
    "end_date": "20/04/2024",
    "license_name": "BrandAstraPro",
    "channel": "amazon",
    "is_topic": false,
    "preview_uuid": "",
    "job_id": "2",
    "title": "Samsung S22 Ultra",
    "hyperlink": "https://www.amazon.in/Samsung-Burgundy-Storage-Additional-Exchange/dp/B09SH7FDKT/ref=pd_        rhf_gw_s_pd_sbs_rvi_d_sccl_1_22/261-8102475-7169761?pd_rd_w=2jjB2&content-id=amzn1.sym.f2f99b52-a5ca-432b-8bfe-0d72feb3d1         ba&pf_rd_p=f2f99b52-a5ca-432b-8bfe-0d72feb3d1ba&pf_rd_r=6ER1P0XVAA541Z3QJRYD&pd_rd_wg=Xj3Kb&pd_rd_r=b74f3c4a-08e4-4260-         953c-85e2ecd3e90e&pd_rd_i=B09SH7FDKT&th=1"
  },
  is_topic: false,
  render_string: "{\"Overviews\":{\"id\":1,\"name\":\"Overviews\",\"type\":\"checkbox\",\"value\":true,\"child\":[{\"id\":\"1a\",\"name\":\"Overall Customer Satisfaction\",\"type\":\"checkbox\",\"value\":true,\"display\":true,\"child\":[{\"id\":\"1aa\",\"name\":\"Average Rating\",\"type\":\"radio\",\"value\":true},{\"id\":\"1ab\",\"name\":\"Verified Purchase\",\"type\":\"radio\",\"value\":false},{\"id\":\"1ac\",\"name\":\"Non Verified Purchase\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"1b\",\"name\":\"Customer Rating\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"1ba\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"1bb\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1bc\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1bd\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"1c\",\"name\":\"Gender Demographics\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"1ca\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"1cb\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1cc\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1cd\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"1d\",\"name\":\"Verified and Non Verified Reviews\",\"type\":\"checkbox\",\"display\":false,\"value\":true,\"child\":[{\"id\":\"1da\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"1db\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1dc\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1dd\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"1e\",\"name\":\"Gender Based Average Rating\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"1ea\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"1eb\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1ec\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"1ed\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"1f\",\"name\":\"Gender Based Rating\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"1fa\",\"name\":\"Male\",\"type\":\"radio\",\"value\":true},{\"id\":\"1fb\",\"name\":\"Female\",\"type\":\"radio\",\"value\":false},{\"id\":\"1fc\",\"name\":\"Unknown\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"1g\",\"name\":\"Trends In User Activity\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"1ga\",\"name\":\"Line Graph\",\"type\":\"radio\",\"value\":true,\"display\":true,\"child\":[{\"id\":\"1gaa\",\"name\":\"Days\",\"type\":\"radio\",\"value\":true,\"display\":true},{\"id\":\"1gab\",\"name\":\"Weeks\",\"type\":\"radio\",\"value\":false,\"display\":true},{\"id\":\"1gac\",\"name\":\"Months\",\"type\":\"radio\",\"value\":false,\"display\":true}]},{\"id\":\"1gb\",\"name\":\"Area Chart\",\"type\":\"radio\",\"display\":true,\"value\":false,\"child\":[{\"id\":\"1gba\",\"name\":\"Days\",\"type\":\"radio\",\"value\":false,\"display\":true},{\"id\":\"1gbb\",\"name\":\"Weeks\",\"type\":\"radio\",\"value\":false,\"display\":true},{\"id\":\"1gbc\",\"name\":\"Months\",\"type\":\"radio\",\"value\":false,\"display\":true}]}]}]},\"Sentiments\":{\"id\":2,\"name\":\"Sentiments\",\"type\":\"checkbox\",\"value\":true,\"child\":[{\"id\":\"2a\",\"name\":\"Sentiment Drilldown\",\"type\":\"checkbox\",\"value\":true,\"display\":true,\"child\":[{\"id\":\"2aa\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"2ab\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"2ac\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"2ad\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"2b\",\"name\":\"Top Helpful Reviews\",\"type\":\"checkbox\",\"display\":true,\"value\":true}]},\"Insights\":{\"id\":3,\"name\":\"Insights\",\"type\":\"checkbox\",\"value\":true,\"child\":[{\"id\":\"3a\",\"name\":\"Word Cloud Analysis - Sentiments\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"3aa\",\"name\":\"Positive\",\"type\":\"checkbox\",\"value\":true},{\"id\":\"3ab\",\"name\":\"Negative\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3ac\",\"name\":\"Neutral\",\"type\":\"checkbox\",\"value\":false}]},{\"id\":\"3b\",\"name\":\"Word Cloud Analysis - Emotions\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"3ba\",\"name\":\"Joy\",\"type\":\"checkbox\",\"value\":true},{\"id\":\"3bb\",\"name\":\"Surprise\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3bc\",\"name\":\"Neutral\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3bd\",\"name\":\"Anger\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3be\",\"name\":\"Disgust\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3bf\",\"name\":\"Sadness\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3bg\",\"name\":\"Fear\",\"type\":\"checkbox\",\"value\":false}]},{\"id\":\"3c\",\"name\":\"Emotion Analysis\",\"type\":\"checkbox\",\"value\":true,\"display\":true,\"child\":[{\"id\":\"3ca\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"3cb\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"3cc\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"3cd\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"3d\",\"name\":\"Correlation Analysis\",\"type\":\"checkbox\",\"value\":true,\"display\":true},{\"id\":\"3e\",\"name\":\"Review Helpfulness\",\"type\":\"checkbox\",\"display\":false,\"value\":true,\"child\":[{\"id\":\"3ea\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"3eb\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"3ec\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"3ed\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"3f\",\"name\":\"Review Liked\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"3fa\",\"name\":\"Bar Graph\",\"type\":\"radio\",\"value\":true},{\"id\":\"3fb\",\"name\":\"Pie Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"3fc\",\"name\":\"Donut Chart\",\"type\":\"radio\",\"value\":false},{\"id\":\"3fd\",\"name\":\"Funnel Chart\",\"type\":\"radio\",\"value\":false}]},{\"id\":\"3g\",\"name\":\"Geographical View of Sentiments\",\"type\":\"checkbox\",\"display\":true,\"value\":true,\"child\":[{\"id\":\"3ga\",\"name\":\"Majority Engagers\",\"type\":\"checkbox\",\"value\":true},{\"id\":\"3gb\",\"name\":\"Positive\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3gc\",\"name\":\"Negative\",\"type\":\"checkbox\",\"value\":false},{\"id\":\"3gd\",\"name\":\"Neutral\",\"type\":\"checkbox\",\"value\":false}]}]},\"Cluster_Analysis\":{\"id\":4,\"name\":\"Cluster Analysis\",\"type\":\"checkbox\",\"value\":true,\"child\":[{\"id\":\"4a\",\"name\":\"Sentiments\",\"type\":\"checkbox\",\"value\":true,\"display\":true},{\"id\":\"4b\",\"name\":\"Emotions\",\"type\":\"checkbox\",\"display\":true,\"value\":true}]},\"Custom_Analysis\":{\"id\":5,\"name\":\"Custom Analysis\",\"type\":\"checkbox\",\"value\":false,\"child\":[]},\"Reviews\":{\"id\":6,\"name\":\"Reviews\",\"type\":\"checkbox\",\"value\":false}}"
}

export const getAllMailList = createAsyncThunk(
  'getAllMailList',
  async (_, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await SentinelHubService.fetchAllMailList(
        brandUser?.tenant_id
      );
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getAllMailListCI = createAsyncThunk(
  'getAllMailListCI',
  async (_, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await SentinelHubService.fetchAllMailListCI(
        brandUser?.tenant_id
      );
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);


export const shareReport = createAsyncThunk(
  'shareReport',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      if (body.reportType == 'twitter' || body.reportType == 'youtube' || body.reportType == 'instagram' || body.reportType == 'facebook'|| body.reportType == 'news') {

        const data = await SentinelHubService.shareReport(
          body.selectedData,
          body.job_id,
          body.newReportData,
          brandUser?.tenant_id,
          brandUser?.user_details.user_id
        );
        thunkAPI.dispatch(setMessage('Report shared'));
        return { data };
      } else if (body.reportType == 'amazon' || body.reportType == 'flipkart') {

        const data = await SentinelHubService.shareReportChatter(
          body.selectedData,
          body.job_id,
          body.repData,
          brandUser?.tenant_id,
          brandUser?.user_details.user_id
        );

        thunkAPI.dispatch(setMessage('Report shared'));
        return { data };
      }
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);


export const shareReportCI = createAsyncThunk(
  'shareReportCI',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

      const data = await SentinelHubService.shareReportCI({
        "ci_id":body.ci_id,
        "newReportData": body?.newReportData,
        "title_name":body?.title_name,
        "subtitle":body?.subtitle,
        "render_field_string":body?.render_field_string,
        "tenant_id" : brandUser?.tenant_id,
        "user_id": brandUser?.user_details.user_id
}
        // body.selectedData,
        // body.job_id,
        // body.newReportData,
      );
      thunkAPI.dispatch(setMessage('Report shared'));
      return { data };

    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getReportCI = createAsyncThunk(
  'getReportCI',
  async (email_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await SentinelHubService.getReportCI(
        brandUser?.tenant_id,
        email_id
      );
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getReport = createAsyncThunk(
  'getReport',
  async (email_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await SentinelHubService.getReport(
        brandUser?.tenant_id,
        email_id
      );
      return { data };
    } catch (error) {
      // || error.response.data.detail
        const message =
          (error.response &&
            error.response.data &&
            ((error.response.data.detail || error.response.data.message))) ||
          error.message ||
          error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteReport = createAsyncThunk(
  'deleteReport',
  async (email_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      await SentinelHubService.deleteReport(brandUser?.tenant_id, email_id);
      const data = await SentinelHubService.fetchAllMailList(
        brandUser?.tenant_id
      );
      thunkAPI.dispatch(setMessage('Report Deleted'));
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteReportCI = createAsyncThunk(
  'deleteReportCI',
  async (email_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      await SentinelHubService.deleteReportCI(brandUser?.tenant_id, email_id);
      const data = await SentinelHubService.fetchAllMailListCI(
        brandUser?.tenant_id
      );
      thunkAPI.dispatch(setMessage('Report Deleted'));
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const hardDeleteReport = createAsyncThunk(
  'hardDeleteReport',
  async (email_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      await SentinelHubService.hardDeleteReport(brandUser?.tenant_id, email_id);
      const data = await SentinelHubService.fetchAllMailList(
        brandUser?.tenant_id
      );
      thunkAPI.dispatch(setMessage('Report Deleted Successfully'));
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);


export const hardDeleteReportCI = createAsyncThunk(
  'hardDeleteReportCI',
  async (email_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      await SentinelHubService.hardDeleteReportCI(brandUser?.tenant_id, email_id);
      const data = await SentinelHubService.fetchAllMailListCI(
        brandUser?.tenant_id
      );
      thunkAPI.dispatch(setMessage('Report Deleted Successfully'));
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getSearchPosts = createAsyncThunk(
  'getSearchPosts',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await SentinelHubService.getSearchPosts({
        tenant_id: brandUser?.tenant_id,
        query: body.query,
        page: body.page,
        sortorder: body.sortorder,
        column_name: body.column_name,
        channel: body.channel
      })
      return data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)


export const getPosts = createAsyncThunk(
  'getPosts',
  async (thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await SentinelHubService.getPosts(
        brandUser?.tenant_id,
      );
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  getAllMailListData: null,
  getAllReportData: [],
  getAllPostsData: [],
  total_count: 0,
  getAllSearchPostValue: [],
};

const sentinelHubSlice = createSlice({
  name: 'sentinelHub',
  initialState,
  reducers: {

    allReportDataEmpty: (state, action) => {
      state.getAllReportData = []
    },
    
    allMailDataEmpty: (state, action) => {
      state.getAllMailListData = []
    },
    
   
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllMailList.fulfilled, (state, action) => {
        state.getAllMailListData = action.payload.data;
      })
      .addCase(getAllMailList.rejected, (state, action) => {
        console.log('Please Try Again');
      })      
      .addCase(getAllMailListCI.fulfilled, (state, action) => {
        state.getAllMailListData = action.payload.data;
      })
      .addCase(getAllMailListCI.rejected, (state, action) => {
        console.log('Please Try Again');
      })
      
      .addCase(shareReport.fulfilled, (state, action) => {
        console.log('Report shared successfully');
      })
      .addCase(shareReport.rejected, (state, action) => {
        console.log('Please Try Again');
      })

      .addCase(getPosts.fulfilled, (state, action) => {
        state.getAllPostsData = action.payload.data;
        state.total_count = action.payload.total_count
      })
      .addCase(getPosts.rejected, (state, action) => {
        console.log('Please Try Again');
      })

      .addCase(getReport.fulfilled, (state, action) => {
        state.getAllReportData = [action.payload.data];
      })
      .addCase(getReport.rejected, (state, action) => {
        console.log('Please Try Again');
      })

      .addCase(getReportCI.fulfilled, (state, action) => {
        state.getAllReportData = [action.payload.data];
      })
      .addCase(getReportCI.rejected, (state, action) => {
        console.log('Please Try Again');
      })
      
      .addCase(deleteReportCI.fulfilled, (state, action) => {
        state.getAllMailListData = action.payload.data;
      })
      .addCase(deleteReportCI.rejected, (state, action) => {
        console.log('Please Try Again');
      })
      .addCase(deleteReport.fulfilled, (state, action) => {
        state.getAllMailListData = action.payload.data;
      })
      .addCase(deleteReport.rejected, (state, action) => {
        console.log('Please Try Again');
      })
      .addCase(hardDeleteReport.fulfilled, (state, action) => {
        state.getAllMailListData = action.payload.data;
      })
      .addCase(hardDeleteReport.rejected, (state, action) => {
        console.log('Please Try Again');
      })

      .addCase(getSearchPosts.fulfilled, (state, action) => {
        state.getAllPostsData = action.payload.data;
        state.total_count = action.payload.total_count
      })
      .addCase(getSearchPosts.rejected, (state, action) => {
        console.log('Please Try Again');
      })
  },
});

export const { allReportDataEmpty ,allMailDataEmpty} = sentinelHubSlice.actions;


export default sentinelHubSlice.reducer;
